/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "//h.cdn.pengpengla.com/upact/jajp-comic2/1.0.1/assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 69);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.11';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });

        return result;
      }

      if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });

        return result;
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17), __webpack_require__(18)(module)))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    /**
     * @file 组件基类
     * @authors 子虔
     * @date    2014-05-12 17:39:36
     * @example <caption>扩展一个子类</caption>
     *      Base.extend({
     *          defaults: {}, // 设置类的默认参数
     *          constructor: function Widget(){
     *              // 子类的构造函数
     *          },
     *      });
     *
     */
    var Events = __webpack_require__(19),
        extend = __webpack_require__(21),
        attributes = __webpack_require__(23),
        isEqual = __webpack_require__(7),
        parseParam = __webpack_require__(6);

    /**
     * 组件Base类
     * @param {object} [Opts={}] - 入参
     */
    function Base(Opts) {
        // 默认配置
        this.defaults = this.defaults || {};

        // 用户配置
        this.config = Opts || {};

        // 最终配置
        this.attributes = $.extend({}, this.attributes || {}, this.defaults) || {};

        if (_typeof(this.config) == 'object') {
            this.attributes = $.extend(this.attributes, this.config) || {};
        }

        this.initialize.apply(this, arguments);
    }

    // 扩展
    $.extend(Base.prototype, Events, {
        /**
         * @constructs
         */
        constructor: Base,

        initialize: function initialize() {},

        /**
         * 频道
         * @deprecated - 当要被废弃
         */
        channel: Events.channel,

        /**
         * 获取配置
         * @param  {string} name - 名称
         * @return {*}
         */
        get: function get(name) {
            return this.attributes[name];
        },

        /**
         * 设置配置
         * @param {*} name  -属性名
         * @param {*} [value] [属性值]
         * @param {boolean} [silent=false] [变化时是否派发事件，默认派发]
         */
        set: function set(name, value, silent) {
            var lastValue;
            if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) == 'object') {
                silent = value;
                for (var key in name) {
                    if (name.hasOwnProperty(key)) {
                        this.set(key, name[key], silent);
                    }
                }
            } else {
                lastValue = this.attributes[name];
                this.attributes[name] = value;
                if (!silent && !isEqual(lastValue, value)) {
                    this.emit('change:' + name, value, lastValue);
                    this.emit('change');
                }
            }
        },

        /**
         * 重置配置
         * @param  {string[]} [whiteList=[]] - white list,不需要重置的list
         * @param  {boolean} [silent=false] - 是否不不派发事件
         */
        reset: function reset(whiteList, silent) {
            whiteList = whiteList || [];

            if (arguments.length > 1) {
                silent = !!whiteList;
            }

            this.defaults = this.defaults || {};

            for (var key in this.attributes) {
                if (this.attributes.hasOwnProperty(key) && whiteList.indexOf(key) == -1) {
                    this.set(key, this.defaults[key], silent);
                }
            }
        },
        /**
         * 销毁，默认移除事件
         */
        destroy: function destroy() {
            this.off();
        }
    });

    // 生成子类
    Base.extend = extend;

    // 修改原型
    Base.use = function (protoProps) {
        var that = this,
            protoProps = [].concat(protoProps);

        protoProps.forEach(function (proto) {
            for (var name in proto) {
                if (proto.hasOwnProperty(name)) {
                    that.prototype[name] = proto[name];
                }
            }
        });
        return this;
    };

    // 组件过滤参数
    Base.parseParam = function (protoProps) {
        var newBase;

        newBase = this.extend({
            /**
             * 过滤实例时的参数
             * @description 剔除非defaults定义的属性
             */
            initialize: function initialize() {
                this.attributes = parseParam(this.defaults || {}, this.attributes);
                this.Parent(initialize, arguments);
            }
        });

        return protoProps ? newBase.extend(protoProps) : newBase;
    };

    module.exports = Base.extend(attributes);
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * 榜单列表
 * data-threshold优先级高于实例化时候传入的统一配置参数。
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {
    var Base = __webpack_require__(1);
    var http = __webpack_require__(3);

    var RankList = Base.extend({
        defaults: {
            wrap: '',
            content: '[node-id=list]',
            loading: '[node-id=loading]',
            error: '[node-id=error]',
            end: '[node-id=end]',
            empty: '[node-id=empty]',
            threshold: 300,
            minSize: 3,
            infiniteScroll: true, // 默认无线滚动列表,
            initParams: {},
            itemExtra: {},
            itemEmptyTpl: function itemEmptyTpl() {
                return '';
            },
            itemTpl: function itemTpl() {
                return '';
            },
            getListData: function getListData(data) {
                return data.hostList || [];
            },
            url: ''
        },

        initialize: function initialize() {
            var self = this;
            self.Parent.apply(self, arguments);

            var nodeWrap = this.nodeWrap = $(this.get('wrap'));
            var nodeContent = this.nodeContent = nodeWrap.find(this.get('content'));
            this.nodeLoading = nodeWrap.find(this.get('loading'));
            this.nodeError = nodeWrap.find(this.get('error'));
            this.nodeEnd = nodeWrap.find(this.get('end'));
            this.nodeEmpty = nodeWrap.find(this.get('empty'));

            var params = nodeContent.data('params');

            if (params) {
                this.params = eval("(" + params + ")");
                this.acid = this.params.eventId.split(':')[0];
            }

            this.pageCount = nodeContent.data('pagesize');
            this.threshold = nodeContent.data('threshold') || this.get('threshold');
            this.minSize = nodeContent.data('minsize') || this.get('minSize');
            this.infiniteScroll = nodeContent.data('infinite-scroll') || this.get('infiniteScroll');
            // 逻辑判断状态
            this.dataOver = false;
            this.dataLoading = true;
            this.isFirst = true;

            this.page = 1;
            this.dataArr = [];

            this._showLoading();

            return this;
        },

        /**
         * 渲染UI
         */
        render: function render() {

            UpAct.loading.show();
            this.loadDataFromServer();
            this.bindEvent();

            return this;
        },

        /**
         * 从服务器端获取数据
         */
        loadDataFromServer: function loadDataFromServer() {
            var _this = this;

            var self = this;
            var page = this.page;
            var initParams = this.get('initParams');
            var params = Object.assign({}, this.params, initParams, {
                index: page,
                pageCount: this.pageCount
            });
            var promise = http.fetch({
                url: this.get('url'),
                data: params
            });

            promise.done(function (res) {
                res = self.formatResult(res);
                if (res.code == 'SC_SUCCESS') {
                    var list = _this.getListData(res.data);

                    var rData = _this.formatList(list);

                    //rData = [];

                    _this.dataLoading = false;

                    _this.dataArr = _this.dataArr.concat(rData);

                    if (rData.length < _this.pageCount) {
                        // 没有更多：列表大小 < 页码
                        _this.dataOver = true;

                        _this._hideLoading();

                        if (!_this.isFirst) {
                            // 没有更多数据了哦
                            _this._showEnd();
                        }
                    }

                    if (_this.isFirst) {
                        _this.isFirst = false;

                        if (rData.length == 0) {
                            // 第一页数据为空
                            _this._hideLoading();
                            _this._showEmpty();
                        }
                        _this.renderList(page, rData, 0);
                    } else {
                        _this.renderList(page, rData, 1);
                    }

                    if (!_this.infiniteScroll) {
                        _this._hideLoading();
                    }
                }

                UpAct.loading.hide();
            });

            promise.fail(function () {
                UpAct.loading.hide();
                _this._hideLoading();
                _this._showError();
            });

            this.page++;
        },

        formatResult: function formatResult(res) {
            return res;
        },

        /**
         * 全部刷新列表
         */
        refresh: function refresh() {
            var _this2 = this;

            var self = this;
            var pageCount = this.dataArr.length || this.pageCount;
            var initParams = this.get('initParams');
            var params = Object.assign({}, this.params, initParams, {
                index: 1,
                pageCount: pageCount
            });

            var promise = http.fetch({
                url: this.get('url'),
                data: params
            });

            UpAct.loading.show();

            this.dataLoading = true;

            promise.done(function (res) {

                res = self.formatResult(res);
                if (res.code == 'SC_SUCCESS') {

                    var list = _this2.getListData(res.data);
                    var rData = _this2.formatList(list);

                    _this2.dataArr = rData;

                    _this2.renderList(1, rData, 0);
                }
                UpAct.loading.hide();
                _this2.dataLoading = false;
            });

            promise.fail(function () {
                UpAct.loading.hide();
                _this2._hideLoading();
                _this2._showError();
                _this2.dataLoading = false;
            });
        },

        /**
         * 获取列表数据
         */
        getListData: function getListData(data) {
            return this.get('getListData').call(this, data);
        },

        /**
         *  解析列表数据
         */
        formatList: function formatList(data) {
            if (data && data.length > 0) {
                data.forEach(function (item, index) {
                    item.avatar = item.avatar || UpAct.img.defaultSrc;
                });
            }

            return data;
        },

        /**
         * 渲染列表内容
         * @param data 数据
         * @param append 是否插入到列表中
         */
        renderList: function renderList(page, data, append) {
            var self = this;
            var nodeContent = this.nodeContent;
            var pageCount = this.pageCount;
            var itemTpl = this.get('itemTpl');
            var itemEmptyTpl = this.get('itemEmptyTpl');
            var nodeList = $('<ul>');
            var dataNum = data.length;

            $.each(data, function (i, item) {
                item.index = i + 1 + (page - 1) * pageCount;

                var nodeItem = itemTpl(Object.assign({
                    data: item,
                    acid: self.acid
                }, self.get("itemExtra")));
                if (nodeItem) {
                    nodeList.append(nodeItem);
                }
            });

            if (page == 1 && dataNum < this.minSize) {
                for (var i = 0; i < this.minSize - dataNum; i++) {
                    var nodeItem = itemEmptyTpl({
                        data: {
                            index: i + dataNum + 1
                        }
                    });
                    if (nodeItem) {
                        nodeList.append(nodeItem);
                    }
                }
            }

            if (append) {
                nodeContent.append(nodeList);
            } else {
                nodeContent.html(nodeList);
            }

            if (!this.imgHelper) {
                this.imgHelper = UpAct.img();
            } else {
                this.imgHelper.start();
            }

            if (!this.gradeHelper) {
                this.gradeHelper = UpAct.grade();
            } else {
                this.gradeHelper.start();
            }

            nodeList.attr({
                'data-showing': '1',
                'data-page': page
            });
        },
        bindEvent: function bindEvent() {
            var _this3 = this;

            if (this.infiniteScroll) {
                $(window).off("scroll");
                $(window).on("scroll", function () {
                    _this3.scroll();
                });
            }
        },
        scroll: function scroll() {
            var _this4 = this;

            this.timer && clearTimeout(this.timer);
            this.timer = setTimeout(function () {
                if (_this4.dataOver) {
                    return;
                }
                if (_this4.dataLoading) {
                    return;
                }
                var body = document.body,
                    docElement = document.documentElement;
                var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
                // 700 在页面滑到底部前700px就可以加载,增加交互流畅性
                if (scrollTop > docElement.offsetHeight - docElement.clientHeight - _this4.get('threshold')) {
                    _this4.dataLoading = true;
                    _this4.loadDataFromServer();
                }
            }, 300);
        },

        /**
         * 显示loading
         */
        _showLoading: function _showLoading() {
            if (this.nodeLoading) {
                this.nodeLoading.removeClass('hidden');
            }
        },
        /**
         * 隐藏loading
         */
        _hideLoading: function _hideLoading() {
            if (this.nodeLoading) {
                this.nodeLoading.addClass('hidden');
            }
        },
        /**
         * 显示数据为空的文案
         */
        _showEmpty: function _showEmpty() {
            if (this.nodeEmpty) {
                this.nodeEmpty.removeClass('hidden');
            }
        },
        /**
         * 隐藏数据为空的文案
         */
        _hideEmpty: function _hideEmpty() {
            if (this.nodeEmpty) {
                this.nodeEmpty.addClass('hidden');
            }
        },
        /**
         * 显示数据异常的文案
         */
        _showError: function _showError() {
            if (this.nodeError) {
                this.nodeError.removeClass('hidden');
            }
        },
        /**
         * 隐藏数据异常的文案
         */
        _hideError: function _hideError() {
            if (this.nodeError) {
                this.nodeError.addClass('hidden');
            }
        },
        /**
         * 显示数据加载完的文案
         */
        _showEnd: function _showEnd() {
            if (this.nodeEnd) {
                this.nodeEnd.removeClass('hidden');
            }
        },
        /**
         * 隐藏数据加载完的文案
         */
        _hideEnd: function _hideEnd() {
            if (this.nodeEnd) {
                this.nodeEnd.addClass('hidden');
            }
        }
    });

    module.exports = RankList;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3 */
/***/ (function(module, exports) {

/**
 * 封装请求数据API
 */
module.exports = {
    /**
     * 发送请求
     */
    fetch: function fetch() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$url = _ref.url,
            url = _ref$url === undefined ? '' : _ref$url,
            _ref$data = _ref.data,
            data = _ref$data === undefined ? {} : _ref$data,
            _ref$type = _ref.type,
            type = _ref$type === undefined ? 'GET' : _ref$type,
            _ref$dataType = _ref.dataType,
            dataType = _ref$dataType === undefined ? 'json' : _ref$dataType,
            _ref$timeout = _ref.timeout,
            timeout = _ref$timeout === undefined ? 10000 : _ref$timeout;

        data.t = new Date().getTime();

        var promise = $.ajax({
            url: url,
            data: data,
            type: type,
            dataType: dataType,
            timeout: timeout
        });

        // 请求成功
        promise.done(function (res) {
            // ... success do something
            if (res.errcode == "1000001" || res.errcode == '1000004') {
                // usertoken登录失效
                $.channel.emit('authorize');
            }
        });

        return promise;
    }
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * H5与native协议 js文件
 */
(function (win, $, UpSDK) {
    var apiStatus = {};
    var iframe = null;
    var urlPrefixCallAppInAndroid = 'uplivecn://goWindow'; // android调用外部协议
    var urlPrefixCallAppInIos = void 0;

    if (window.isUpVoice) {
        // 声播协议
        urlPrefixCallAppInIos = 'https://voice.upliveapps.com/goWindow'; // ios调用外部协议
    } else {
        urlPrefixCallAppInIos = 'https://ios.upliveapps.com/goWindow'; // ios调用外部协议
    }

    var native = {
        send: function send(url) {
            if (iframe) {
                document.body.removeChild(iframe);
                iframe = null;
            }
            if (!iframe) {
                iframe = document.createElement('iframe');
                iframe.id = 'up_callapp_iframe_' + Date.now();
                iframe.frameborder = '0';
                iframe.style.cssText = 'display:none;border:0;width:0;height:0;';
                document.body.appendChild(iframe);
            }
            iframe.src = url;
        },
        sendUriScheme: function sendUriScheme(url) {
            window.location.href = url;
        },
        query: function query(name, scope) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
                scope = scope || 'search',
                r = location[scope].substr(1).match(reg);
            if (r != null) {
                return unescape(r[2]);
            }
            return null;
        },


        addParam: function addParam(url, data) {
            if (typeof data === 'undefined') {
                return;
            }

            var hashReg = /#.*$/gi,
                hashMatch = url.match(hashReg),
                hash = '';

            if (hashMatch) {
                hash = hashMatch[0];
            }

            // 去除hash值的url
            var preUrl = url.replace(hash, '');

            var searchReg = /\?(.*?)$/gi;
            var result = searchReg.exec(preUrl);
            var query;
            if (result) {
                query = result[1].split('#')[0];
            }

            var id = !query ? '' : '&';

            return preUrl + (query && query.length > 0 ? '' : '?') + (id + $.param(data)) + hash;
        },
        // 获得平台类型
        // weixin, weibo, qq, uplive，海外版本Android在URL Hash中添加标识 #pl=uplive
        getPlatform: function getPlatform() {
            var _ref = [navigator.userAgent, 'other'],
                ua = _ref[0],
                pl = _ref[1];


            if (ua.match(/uplive/i) || this.query('pl', 'hash') == 'uplive' || localStorage.getItem('__inuplive__') || this.query('pl') == 'uplive') {
                pl = 'uplive';
            } else if (ua.match(/micromessenger/i)) {
                pl = 'wechat';
            } else if (ua.match(/qq/i)) {
                pl = 'qq';
            } else if (ua.match(/weibo/i)) {
                pl = 'weibo';
            } else if (ua.match(/renren/i)) {
                pl = 'renren';
            } else if (ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1) {
                pl = 'fb';
            } else if (ua.match(/Line/i)) {
                pl = 'line';
            }

            return pl;
        },


        // 获得当前系统类型
        getSystem: function getSystem() {
            var ua = navigator.userAgent;
            return (/(iPhone|iPad|iPod|iOS)/i.test(ua) ? 'ios' : /[aA]ndroid/i.test(ua) ? 'android' : 'pc'
            );
        },


        // 系统语言
        getLanguage: function getLanguage() {
            var language = navigator.language || navigator.browserLanguage;

            if (language) {
                var arr = language.split('-');
                arr[1] = arr[1].toUpperCase();
                language = arr.join('-');
            }

            return language;
        },


        // 检查api是否可用
        checkAvail: function checkAvail() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                apiname = _ref2.apiname,
                errtip = _ref2.errtip;

            setTimeout(function () {
                if (!apiStatus[apiname] && errtip) {
                    if (typeof errtip == 'function') {
                        errtip();
                    } else {
                        alert(errtip);
                    }
                }
            }, 3000);
        },

        /**
         * 获取配置信息
         * @param cfg {
         *      invalid 0: usertoken失效，重新获取；1：第一次获取
         *      complete: function(){}
         * }
         *
         */
        getConfigs: function getConfigs() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref3$complete = _ref3.complete,
                complete = _ref3$complete === undefined ? function () {} : _ref3$complete,
                _ref3$invalid = _ref3.invalid,
                invalid = _ref3$invalid === undefined ? 0 : _ref3$invalid,
                _ref3$errtip = _ref3.errtip,
                errtip = _ref3$errtip === undefined ? '不支持' : _ref3$errtip;

            var self = this;
            var url = 'uplive://getConfigs?json=';
            var params = {
                invalid: invalid,
                receive: "$['upliveapp_getConfigs']",
                jsCallback: '$.getConfigsComplete'
            };

            $.getConfigsComplete = function (param) {
                // usertoken: "", uid: "", language: ""
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getConfigs',
                errtip: errtip
            });
        },


        /**
         * 获取主播信息
         * @param cfg {
         *      complete: function(){}
         * }
         *
         */
        getHostInfo: function getHostInfo() {
            var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref4$complete = _ref4.complete,
                complete = _ref4$complete === undefined ? function () {} : _ref4$complete,
                _ref4$errtip = _ref4.errtip,
                errtip = _ref4$errtip === undefined ? '不支持' : _ref4$errtip;

            var self = this;
            var url = 'uplive://getHostInfo?json=';
            var params = {
                receive: "$['upliveapp_getHostInfo']",
                jsCallback: '$.getHostInfoComplete'
            };

            $.getHostInfoComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getHostInfo',
                errtip: errtip
            });
        },


        // 上报提现结果给客户端
        acceptAgreement: function acceptAgreement() {
            var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref5$errtip = _ref5.errtip,
                errtip = _ref5$errtip === undefined ? '不支持' : _ref5$errtip;

            var url = 'uplive://acceptAgreement?json=';
            var params = {
                receive: "$['upliveapp_acceptAgreement']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'acceptAgreement',
                errtip: errtip
            });
        },

        /**
         * 跳转个人主页
         * @param cfg {
         *      uid: 10234, // {Number} 整型
                tab: 0：动态 1：关注 2：粉丝 3：守护
         * }
         */
        profile: function profile() {
            var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref6$uid = _ref6.uid,
                uid = _ref6$uid === undefined ? 0 : _ref6$uid,
                _ref6$tab = _ref6.tab,
                tab = _ref6$tab === undefined ? 0 : _ref6$tab,
                _ref6$errtip = _ref6.errtip,
                errtip = _ref6$errtip === undefined ? '' : _ref6$errtip,
                _ref6$action = _ref6.action,
                action = _ref6$action === undefined ? 'callapp' : _ref6$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'profile',
                extend: {
                    uid: parseInt(uid, 10),
                    tab: tab
                },
                receive: "$['upliveapp_profile']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'profile',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },

        /**
         * 跳转到直播间
         * @param cfg {
         *      uid: 10234, // {Number} 整型
         *      roomid: 10234 {Number} 整型
         * }
         */
        goRoom: function goRoom() {
            var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref7$uid = _ref7.uid,
                uid = _ref7$uid === undefined ? 0 : _ref7$uid,
                _ref7$roomid = _ref7.roomid,
                roomid = _ref7$roomid === undefined ? 0 : _ref7$roomid,
                _ref7$errtip = _ref7.errtip,
                errtip = _ref7$errtip === undefined ? '' : _ref7$errtip,
                _ref7$action = _ref7.action,
                action = _ref7$action === undefined ? 'callapp' : _ref7$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'room',
                extend: {
                    uid: parseInt(uid, 10),
                    roomid: parseInt(roomid, 10)
                },
                receive: "$['upliveapp_goRoom']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goRoom',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },
        goRank: function goRank() {
            var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref8$name = _ref8.name,
                name = _ref8$name === undefined ? 1 : _ref8$name,
                _ref8$errtip = _ref8.errtip,
                errtip = _ref8$errtip === undefined ? '' : _ref8$errtip,
                _ref8$action = _ref8.action,
                action = _ref8$action === undefined ? 'callapp' : _ref8$action;

            var url = 'uplive://goWindow?json=';
            var key = void 0;

            switch (parseInt(name, 10)) {
                case 1:
                    key = 'starank';
                    break;
                case 2:
                    key = 'hostrank';
                    break;
                case 3:
                    key = 'wealthrank';
                    break;
                default:
                    key = 'starank';
            }

            var params = {
                key: key,
                receive: "$['upliveapp_goRank']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goRank',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        // 跳转充值界面
        gopay: function gopay() {
            var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref9$errtip = _ref9.errtip,
                errtip = _ref9$errtip === undefined ? '' : _ref9$errtip,
                _ref9$complete = _ref9.complete,
                complete = _ref9$complete === undefined ? function () {} : _ref9$complete,
                _ref9$action = _ref9.action,
                action = _ref9$action === undefined ? 'callapp' : _ref9$action;

            var self = this;
            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'pay',
                receive: "$['upliveapp_gopay']",
                jsCallback: "$['getGopayComplete']"
            };

            $.getGopayComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'gopay',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        // 上报提现结果给客户端
        reportCashResult: function reportCashResult() {
            var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref10$success = _ref10.success,
                success = _ref10$success === undefined ? 1 : _ref10$success,
                errtip = _ref10.errtip;

            var url = 'uplive://h5cash?json=';
            var params = {
                success: success,
                receive: "$['upliveapp_reportCashResult']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'reportCashResult',
                errtip: errtip
            });
        },


        // 上报充值结果给客户端
        reportPayResult: function reportPayResult() {
            var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref11$success = _ref11.success,
                success = _ref11$success === undefined ? 1 : _ref11$success,
                errtip = _ref11.errtip;

            var url = 'uplive://h5payment?json=';
            var params = {
                success: success,
                receive: "$['upliveapp_reportPayResult']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'reportPayResult',
                errtip: errtip
            });
        },


        // 关闭webview
        closeWindow: function closeWindow() {
            var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref12$errtip = _ref12.errtip,
                errtip = _ref12$errtip === undefined ? '' : _ref12$errtip;

            var url = 'uplive://closeWindow?json=';
            var params = {
                receive: "$['upliveapp_closeWindow']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'closeWindow',
                errtip: errtip
            });
        },


        // 浏览器中打开
        openBrowser: function openBrowser() {
            var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref13$url = _ref13.url,
                url = _ref13$url === undefined ? '' : _ref13$url,
                _ref13$errtip = _ref13.errtip,
                errtip = _ref13$errtip === undefined ? '' : _ref13$errtip,
                _ref13$action = _ref13.action,
                action = _ref13$action === undefined ? 'callapp' : _ref13$action;

            var _url = 'uplive://openBrowser?json=';
            var params = {
                receive: "$['upliveapp_openBrowser']",
                url: url
            };

            _url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(_url);
                this.checkAvail({
                    apiname: 'openBrowser',
                    errtip: errtip
                });
            } else {
                return _url;
            }
        },

        // 打开新的webview
        openWebView: function openWebView() {
            var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref14$url = _ref14.url,
                url = _ref14$url === undefined ? '' : _ref14$url,
                _ref14$errtip = _ref14.errtip,
                errtip = _ref14$errtip === undefined ? '' : _ref14$errtip,
                _ref14$action = _ref14.action,
                action = _ref14$action === undefined ? 'callapp' : _ref14$action;

            var _url = 'uplive://openWebView?json=';
            var params = {
                receive: "$['upliveapp_openWebView']",
                url: url
            };

            _url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(_url);
                this.checkAvail({
                    apiname: 'openWebView',
                    errtip: errtip
                });
            } else {
                return _url;
            }
        },


        // 获取地理位置
        getLocation: function getLocation() {
            var _ref15 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref15$complete = _ref15.complete,
                complete = _ref15$complete === undefined ? function () {} : _ref15$complete,
                _ref15$errtip = _ref15.errtip,
                errtip = _ref15$errtip === undefined ? '不支持' : _ref15$errtip;

            var self = this;
            var url = 'uplive://getLocation?json=';
            var params = {
                receive: "$['upliveapp_getLocation']",
                jsCallback: '$.getLocationComplete'
            };

            $.getLocationComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getLocation',
                errtip: errtip
            });
        },

        /**
         * 支付调用
         * @param data {object}
         *      - platform 支付平台
         *      - complete {function}
         *      - params 参数
         * @return this
         */
        pay: function pay() {
            var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref16$complete = _ref16.complete,
                complete = _ref16$complete === undefined ? function () {} : _ref16$complete,
                _ref16$platform = _ref16.platform,
                platform = _ref16$platform === undefined ? 'wxpay' : _ref16$platform,
                _ref16$productId = _ref16.productId,
                productId = _ref16$productId === undefined ? '' : _ref16$productId,
                _ref16$errtip = _ref16.errtip,
                errtip = _ref16$errtip === undefined ? '不支持支付' : _ref16$errtip;

            var self = this;
            var _url = 'uplive://payment?json=';
            var _params = {
                receive: "$['upliveapp_pay']",
                platform: platform || 'wxpay',
                params: {
                    productId: productId
                },
                jsCallback: '$.payComplete'
            };

            $.payComplete = function (param) {
                // 支付
                complete.call(self, JSON.parse(param));
            };

            this.send(_url + JSON.stringify(_params));
            this.checkAvail({
                apiname: 'pay',
                errtip: errtip
            });
        },
        ynpay: function ynpay() {
            var _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref17$complete = _ref17.complete,
                complete = _ref17$complete === undefined ? function () {} : _ref17$complete,
                _ref17$platform = _ref17.platform,
                platform = _ref17$platform === undefined ? 'wxpay' : _ref17$platform,
                _ref17$productId = _ref17.productId,
                productId = _ref17$productId === undefined ? '' : _ref17$productId,
                _ref17$orderStr = _ref17.orderStr,
                orderStr = _ref17$orderStr === undefined ? '' : _ref17$orderStr,
                _ref17$orderId = _ref17.orderId,
                orderId = _ref17$orderId === undefined ? '' : _ref17$orderId,
                _ref17$errtip = _ref17.errtip,
                errtip = _ref17$errtip === undefined ? '不支持支付' : _ref17$errtip;

            var self = this;
            var _url = 'uplive://ynzf?json=';
            var _params = {
                receive: "$['upliveapp_ynpay']",
                platform: platform || 'wxpay',
                params: {
                    orderId: orderId + '',
                    productId: productId + '',
                    orderStr: orderStr
                },
                jsCallback: '$.payComplete'
            };

            $.payComplete = function (param) {
                // 支付
                complete.call(self, JSON.parse(param));
            };

            this.send(_url + JSON.stringify(_params));
            this.checkAvail({
                apiname: 'ynpay',
                errtip: errtip
            });
        },
        checkRepairOrder: function checkRepairOrder() {
            var _ref18 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref18$complete = _ref18.complete,
                complete = _ref18$complete === undefined ? function () {} : _ref18$complete,
                _ref18$errtip = _ref18.errtip,
                errtip = _ref18$errtip === undefined ? '' : _ref18$errtip;

            var self = this;
            var url = 'uplive://checkRepairOrder?json=';
            var params = {
                receive: "$['upliveapp_checkRepairOrder']",
                jsCallback: '$.checkRepairOrderComplete'
            };

            $.checkRepairOrderComplete = function (param) {
                // 支付
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'checkRepairOrder',
                errtip: errtip
            });
        },
        goRepairOrder: function goRepairOrder() {
            var _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref19$complete = _ref19.complete,
                complete = _ref19$complete === undefined ? function () {} : _ref19$complete,
                _ref19$errtip = _ref19.errtip,
                errtip = _ref19$errtip === undefined ? '' : _ref19$errtip;

            var url = 'uplive://goRepairOrder?json=';
            var params = {
                receive: "$['upliveapp_goRepairOrder']",
                jsCallback: '$.goRepairOrderComplete'
            };

            $.goRepairOrderComplete = function (param) {
                // 支付
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goRepairOrder',
                errtip: errtip
            });
        },

        // 通过相机获取图片
        getPhotoCamera: function getPhotoCamera() {
            var _ref20 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref20$complete = _ref20.complete,
                complete = _ref20$complete === undefined ? function () {} : _ref20$complete,
                _ref20$type = _ref20.type,
                type = _ref20$type === undefined ? "share" : _ref20$type,
                _ref20$crop = _ref20.crop,
                crop = _ref20$crop === undefined ? 0 : _ref20$crop,
                _ref20$width = _ref20.width,
                width = _ref20$width === undefined ? 640 : _ref20$width,
                _ref20$height = _ref20.height,
                height = _ref20$height === undefined ? 640 : _ref20$height,
                _ref20$errtip = _ref20.errtip,
                errtip = _ref20$errtip === undefined ? '不支持' : _ref20$errtip;

            var self = this;
            var url = 'uplive://getPhoto?json=';
            var params = {
                type: type || 'share',
                sourceType: "camera", //图片来源，照相机
                crop: crop,
                width: width,
                height: height,
                receive: "$['upliveapp_getPhotoCamera']",
                jsCallback: '$.getPhotoCameraComplete'
            };

            $.getPhotoCameraComplete = function (param) {
                // "url":"网络链接"
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getPhotoCamera',
                errtip: errtip
            });
        },

        // 通过图库获取图片
        getPhotoAlbum: function getPhotoAlbum() {
            var _ref21 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref21$complete = _ref21.complete,
                complete = _ref21$complete === undefined ? function () {} : _ref21$complete,
                _ref21$type = _ref21.type,
                type = _ref21$type === undefined ? "share" : _ref21$type,
                _ref21$crop = _ref21.crop,
                crop = _ref21$crop === undefined ? 0 : _ref21$crop,
                _ref21$width = _ref21.width,
                width = _ref21$width === undefined ? 640 : _ref21$width,
                _ref21$height = _ref21.height,
                height = _ref21$height === undefined ? 640 : _ref21$height,
                _ref21$errtip = _ref21.errtip,
                errtip = _ref21$errtip === undefined ? '不支持' : _ref21$errtip;

            var self = this;
            var url = 'uplive://getPhoto?json=';
            var params = {
                type: type || 'share',
                sourceType: "album", //图片来源，照相机
                crop: crop,
                width: width,
                height: height,
                receive: "$['upliveapp_getPhotoAlbum']",
                jsCallback: '$.getPhotoAlbumComplete'
            };

            $.getPhotoAlbumComplete = function (param) {
                // "url":"网络链接"
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getPhotoAlbum',
                errtip: errtip
            });
        },


        // 客户端分享
        share: function share() {
            var _ref22 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref22$complete = _ref22.complete,
                complete = _ref22$complete === undefined ? function () {} : _ref22$complete,
                _ref22$title = _ref22.title,
                title = _ref22$title === undefined ? '分享标题' : _ref22$title,
                _ref22$url = _ref22.url,
                url = _ref22$url === undefined ? 'http://www.baidu.com' : _ref22$url,
                _ref22$imageUrl = _ref22.imageUrl,
                imageUrl = _ref22$imageUrl === undefined ? 'https://m.baidu.com/static/index/plus/plus_logo.png' : _ref22$imageUrl,
                _ref22$desc = _ref22.desc,
                desc = _ref22$desc === undefined ? '分享表述' : _ref22$desc,
                _ref22$platform = _ref22.platform,
                platform = _ref22$platform === undefined ? {} : _ref22$platform,
                _ref22$errtip = _ref22.errtip,
                errtip = _ref22$errtip === undefined ? '客户端不支持分享' : _ref22$errtip;

            var self = this;
            var _url = 'uplive://sharePage?json=';
            var pls = ['qq', 'qzone', 'wechat_friends', 'wechat_circle', 'sina', 'fb', 'tw'];
            var oauthtype = { 'fb': 'fb', 'tw': 'twitter', 'sina': 'weibo' };

            var params = {
                receive: "$['upliveapp_share']",
                platform: {},
                jsCallback: '$.upliveShareComplete'
            };

            pls.forEach(function (item, i) {
                params.platform[item] = {
                    url: url,
                    title: title,
                    imageUrl: imageUrl,
                    desc: desc
                };
            });

            if (JSON.stringify(platform) != '{}') {
                params = $.extend(true, params, {
                    platform: platform
                });
            }

            for (var i in params) {
                if (i == 'platform') {
                    for (var j in params[i]) {
                        for (var k in params[i][j]) {
                            if (k == 'title' || k == 'desc') {
                                params[i][j][k] = encodeURIComponent(params[i][j][k]);
                            }
                            if (k == 'url' && params[i][j][k] && oauthtype[j]) {
                                var _url2 = params[i][j][k];

                                params[i][j][k] = this.addParam(_url2, {
                                    oauthtype: oauthtype[j]
                                });
                            }
                        }
                    }
                }
            }

            $.upliveShareComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };
            this.send(_url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'share',
                errtip: errtip
            });
        },


        // 单渠道分享
        singleShare: function singleShare() {
            var _ref23 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref23$complete = _ref23.complete,
                complete = _ref23$complete === undefined ? function () {} : _ref23$complete,
                _ref23$title = _ref23.title,
                title = _ref23$title === undefined ? '分享标题' : _ref23$title,
                _ref23$url = _ref23.url,
                url = _ref23$url === undefined ? 'http://www.baidu.com' : _ref23$url,
                _ref23$imageUrl = _ref23.imageUrl,
                imageUrl = _ref23$imageUrl === undefined ? 'https://m.baidu.com/static/index/plus/plus_logo.png' : _ref23$imageUrl,
                _ref23$desc = _ref23.desc,
                desc = _ref23$desc === undefined ? '分享表述' : _ref23$desc,
                _ref23$type = _ref23.type,
                type = _ref23$type === undefined ? 'fb' : _ref23$type,
                _ref23$errtip = _ref23.errtip,
                errtip = _ref23$errtip === undefined ? '客户端不支持分享' : _ref23$errtip,
                _ref23$action = _ref23.action,
                action = _ref23$action === undefined ? 'callapp' : _ref23$action;

            var self = this;
            var system = this.getSystem();
            var _url = 'uplive://singleShare?json=';
            var pls = ["qq", "qzone", "wechat_friends", "wechat_circle", "sina", "fb", "tw", "messenger", "whatsapp", "ins", "line", "kakao"];
            var oauthtype = { 'fb': 'fb', 'tw': 'twitter', 'sina': 'weibo' };

            if (url && oauthtype[type]) {
                url = this.addParam(url, {
                    oauthtype: oauthtype[type]
                });
            }
            if (type == 'sina') {
                desc += '>>' + url;
            }
            var params = {
                receive: "$['upliveapp_singleShare']",
                platform: {
                    url: url,
                    title: system == 'ios' ? title : encodeURIComponent(title),
                    imageUrl: imageUrl,
                    desc: system == 'ios' ? desc : encodeURIComponent(desc)
                },
                type: type,
                jsCallback: '$.upliveSingleShareComplete'
            };

            $.upliveSingleShareComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            _url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(_url);
                this.checkAvail({
                    apiname: 'singleShare',
                    errtip: errtip
                });
            } else {
                return _url;
            }
        },


        // 1.6.5 根据国家码跳转到国家主播列表
        goHotListByArea: function goHotListByArea() {
            var _ref24 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref24$countryCode = _ref24.countryCode,
                countryCode = _ref24$countryCode === undefined ? '' : _ref24$countryCode,
                _ref24$errtip = _ref24.errtip,
                errtip = _ref24$errtip === undefined ? '' : _ref24$errtip;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'hotbyarea',
                extend: {
                    countryCode: countryCode
                },
                receive: "$['upliveapp_goHotListByArea']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goHotListByArea',
                errtip: errtip
            });
        },

        /*--------------------- V2.0.0 -------------------*/

        // 游客登录
        login: function login() {
            var _ref25 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref25$complete = _ref25.complete,
                complete = _ref25$complete === undefined ? function () {} : _ref25$complete,
                _ref25$errtip = _ref25.errtip,
                errtip = _ref25$errtip === undefined ? '不支持登录' : _ref25$errtip;

            var self = this;
            var url = 'uplive://goLogin?json=';
            var params = {
                receive: "$['upliveapp_login']",
                jsCallback: '$.loginComplete'
            };
            $.loginComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'login',
                errtip: errtip
            });
        },


        // 刷新用户信息
        refreshProfile: function refreshProfile() {
            var _ref26 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref26$errtip = _ref26.errtip,
                errtip = _ref26$errtip === undefined ? '不支持刷新用户信息' : _ref26$errtip;

            var url = 'uplive://refreshProfile?json=';
            var params = {
                receive: "$['upliveapp_refreshProfile']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'refreshProfile',
                errtip: errtip
            });
        },


        /* -------------------- ios 我的收益 --------------------- */

        goCashRecord: function goCashRecord() {
            var _ref27 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref27$errtip = _ref27.errtip,
                errtip = _ref27$errtip === undefined ? '不支持领取纪录' : _ref27$errtip;

            var url = 'uplive://goCashRecord?json=';
            var params = {
                receive: "$['upliveapp_goCashRecord']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goCashRecord',
                errtip: errtip
            });
        },
        bindMobilePhone: function bindMobilePhone() {
            var _ref28 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref28$complete = _ref28.complete,
                complete = _ref28$complete === undefined ? function () {} : _ref28$complete,
                _ref28$errtip = _ref28.errtip,
                errtip = _ref28$errtip === undefined ? '不支持手机绑定' : _ref28$errtip;

            var self = this;
            var url = 'uplive://bindMobilePhone?json=';
            var params = {
                receive: "$['upliveapp_bindMobilePhone']",
                jsCallback: '$.bindMobilePhoneComplete'
            };
            $.bindMobilePhoneComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'bindMobilePhone',
                errtip: errtip
            });
        },
        bindWechat: function bindWechat() {
            var _ref29 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref29$complete = _ref29.complete,
                complete = _ref29$complete === undefined ? function () {} : _ref29$complete,
                _ref29$errtip = _ref29.errtip,
                errtip = _ref29$errtip === undefined ? '不支持微信绑定' : _ref29$errtip;

            var self = this;
            var url = 'uplive://bindWechat?json=';
            var params = {
                receive: "$['upliveapp_bindWechat']",
                jsCallback: '$.bindWechatComplete'
            };
            $.bindWechatComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'bindWechat',
                errtip: errtip
            });
        },
        setTitle: function setTitle() {
            var _ref30 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref30$title = _ref30.title,
                title = _ref30$title === undefined ? '' : _ref30$title,
                _ref30$errtip = _ref30.errtip,
                errtip = _ref30$errtip === undefined ? function () {} : _ref30$errtip;

            var self = this;
            var system = this.getSystem();
            var _url = 'uplive://setTitle?json=';
            var _params = {
                receive: "$['upliveapp_setTitle']",
                params: {
                    title: title
                }
            };

            if (system == 'android') {
                document.title = title;
            } else {
                this.send(_url + JSON.stringify(_params));
                this.checkAvail({
                    apiname: 'setTitle',
                    errtip: errtip
                });
            }
        },


        /**
         * 设置客户端导航
         */
        setNavBar: function setNavBar() {
            var _ref31 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref31$backgroundColo = _ref31.backgroundColor,
                backgroundColor = _ref31$backgroundColo === undefined ? '#FFFFFF' : _ref31$backgroundColo,
                _ref31$skin = _ref31.skin,
                skin = _ref31$skin === undefined ? 0 : _ref31$skin,
                _ref31$iconPath = _ref31.iconPath,
                iconPath = _ref31$iconPath === undefined ? '' : _ref31$iconPath,
                _ref31$pagePath = _ref31.pagePath,
                pagePath = _ref31$pagePath === undefined ? '' : _ref31$pagePath,
                _ref31$errtip = _ref31.errtip,
                errtip = _ref31$errtip === undefined ? function () {} : _ref31$errtip;

            var self = this;
            var system = this.getSystem();
            var _url = 'uplive://setNavBar?json=';
            var _params = {
                receive: "$['upliveapp_setNavBar']",
                params: {
                    backgroundColor: backgroundColor, // 十六进制
                    skin: skin, // 0: 默认紫色back + 黑色文本；1: 白色back + 白色文本
                    iconPath: iconPath, // 图片路径
                    pagePath: pagePath }
            };

            this.send(_url + JSON.stringify(_params));
            this.checkAvail({
                apiname: 'setNavBar',
                errtip: errtip
            });
        },

        /* ----------------------V 2.6.0 -------------------*/
        /**
         * 跳转到开播准备页面
         * @param cfg {
         * }
         */
        goReadyToLive: function goReadyToLive() {
            var _ref32 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref32$errtip = _ref32.errtip,
                errtip = _ref32$errtip === undefined ? '' : _ref32$errtip,
                _ref32$action = _ref32.action,
                action = _ref32$action === undefined ? 'callapp' : _ref32$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'readyToLive',
                receive: "$['upliveapp_goReadyToLive']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goReadyToLive',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到我的背包页面
         * @param cfg {
         * }
         */
        goPack: function goPack() {
            var _ref33 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref33$errtip = _ref33.errtip,
                errtip = _ref33$errtip === undefined ? '' : _ref33$errtip,
                _ref33$action = _ref33.action,
                action = _ref33$action === undefined ? 'callapp' : _ref33$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'pack',
                receive: "$['upliveapp_goPack']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goPack',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到发现列表
         * @param cfg {
         * }
         */
        goFindList: function goFindList() {
            var _ref34 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref34$errtip = _ref34.errtip,
                errtip = _ref34$errtip === undefined ? '' : _ref34$errtip,
                _ref34$action = _ref34.action,
                action = _ref34$action === undefined ? 'callapp' : _ref34$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'findList',
                receive: "$['upliveapp_goFindList']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goFindList',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到热门列表
         * @param cfg {
         * }
         */
        goHotList: function goHotList() {
            var _ref35 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref35$errtip = _ref35.errtip,
                errtip = _ref35$errtip === undefined ? '' : _ref35$errtip,
                _ref35$action = _ref35.action,
                action = _ref35$action === undefined ? 'callapp' : _ref35$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'hotList',
                receive: "$['upliveapp_goHotList']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goHotList',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到VIP特权页面
         * @param cfg {
         * }
         */
        goVipPrivileges: function goVipPrivileges() {
            var _ref36 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref36$errtip = _ref36.errtip,
                errtip = _ref36$errtip === undefined ? '' : _ref36$errtip;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'vipPrivileges',
                receive: "$['upliveapp_goVipPrivileges']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goVipPrivileges',
                errtip: errtip
            });
        },


        /**
        * 跳转到VIP特权设置页面
        * @param cfg {
        * }
        */
        goVipPrivilegesSetting: function goVipPrivilegesSetting() {
            var _ref37 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref37$errtip = _ref37.errtip,
                errtip = _ref37$errtip === undefined ? '' : _ref37$errtip,
                _ref37$action = _ref37.action,
                action = _ref37$action === undefined ? 'callapp' : _ref37$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'vipPrivilegesSetting',
                receive: "$['upliveapp_goVipPrivilegesSetting']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goVipPrivilegesSetting',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转开通守护
         * uid  主播id
         * roomId 直播间id
         * complete 回调方法
         */
        goOpenGuard: function goOpenGuard() {
            var _ref38 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref38$uid = _ref38.uid,
                uid = _ref38$uid === undefined ? 0 : _ref38$uid,
                _ref38$roomId = _ref38.roomId,
                roomId = _ref38$roomId === undefined ? 0 : _ref38$roomId,
                _ref38$complete = _ref38.complete,
                complete = _ref38$complete === undefined ? function () {} : _ref38$complete,
                _ref38$errtip = _ref38.errtip,
                errtip = _ref38$errtip === undefined ? '' : _ref38$errtip,
                _ref38$action = _ref38.action,
                action = _ref38$action === undefined ? 'callapp' : _ref38$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'openGuard',
                extend: {
                    uid: uid,
                    roomid: roomId
                },
                receive: "$['upliveapp_goOpenGuard']",
                "jsCallback": "$.buyOpenGuardComplete"
            };

            $.buyOpenGuardComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goOpenGuard',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         *
         * 跳转IM聊天
         * uid  主播id
         *
         */

        openChat: function openChat() {
            var _ref39 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref39$uid = _ref39.uid,
                uid = _ref39$uid === undefined ? 10005 : _ref39$uid,
                _ref39$errtip = _ref39.errtip,
                errtip = _ref39$errtip === undefined ? '' : _ref39$errtip,
                _ref39$action = _ref39.action,
                action = _ref39$action === undefined ? 'callapp' : _ref39$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'openChat',
                extend: {
                    uid: uid
                },
                receive: "$['upliveapp_openChat']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'openChat',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到关注列表
         * @param cfg {
         * }
         */
        goFollowList: function goFollowList() {
            var _ref40 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref40$errtip = _ref40.errtip,
                errtip = _ref40$errtip === undefined ? '' : _ref40$errtip,
                _ref40$action = _ref40.action,
                action = _ref40$action === undefined ? 'callapp' : _ref40$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'followList',
                receive: "$['upliveapp_goFollowList']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goFollowList',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到短视频录制准备页面；
         * @param cfg {
                topic: 话题,
                topicId: 话题id {int}
         * }
         */
        goReadyToShortVideo: function goReadyToShortVideo() {
            var _ref41 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref41$topic = _ref41.topic,
                topic = _ref41$topic === undefined ? '' : _ref41$topic,
                _ref41$topicId = _ref41.topicId,
                topicId = _ref41$topicId === undefined ? '' : _ref41$topicId,
                _ref41$errtip = _ref41.errtip,
                errtip = _ref41$errtip === undefined ? '' : _ref41$errtip,
                _ref41$action = _ref41.action,
                action = _ref41$action === undefined ? 'callapp' : _ref41$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'readyToShortVideo',
                extend: {
                    topic: topic,
                    topicId: parseInt(topicId, 10)
                },
                receive: "$['upliveapp_goReadyToShortVideo']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goReadyToShortVideo',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到指定短视频页面&播放视频
         * @param cfg {
                rid: '主帖子ID', ［必须］
                dynamicId: '动态ID',［必须］
                dynamicType: "动态类型",［必须］
                // ［非必须］
                resourceUrls: {}, // 图片或者视频地址
                resourceDesp: "" // 资源描述信息
         * }
         */
        goDynamic: function goDynamic() {
            var _ref42 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref42$rid = _ref42.rid,
                rid = _ref42$rid === undefined ? '' : _ref42$rid,
                _ref42$dynamicId = _ref42.dynamicId,
                dynamicId = _ref42$dynamicId === undefined ? '' : _ref42$dynamicId,
                _ref42$dynamicType = _ref42.dynamicType,
                dynamicType = _ref42$dynamicType === undefined ? '' : _ref42$dynamicType,
                _ref42$resourceUrls = _ref42.resourceUrls,
                resourceUrls = _ref42$resourceUrls === undefined ? null : _ref42$resourceUrls,
                _ref42$resourceDesp = _ref42.resourceDesp,
                resourceDesp = _ref42$resourceDesp === undefined ? '' : _ref42$resourceDesp,
                _ref42$errtip = _ref42.errtip,
                errtip = _ref42$errtip === undefined ? '' : _ref42$errtip;

            var url = 'uplive://goWindow?json=';
            var _params = {
                rid: rid,
                dynamicId: dynamicId,
                dynamicType: dynamicType
            };

            if (resourceUrls) {
                _params.resourceUrls = resourceUrls;
                _params.resourceDesp = resourceDesp;
            }
            var params = {
                key: 'dynamic',
                extend: _params,
                receive: "$['upliveapp_goDynamic']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goDynamic',
                errtip: errtip
            });
        },


        /* ----------------------V ios 2.5.0 -------------------*/

        /**
         * 跳转到座驾商场
         * @param cfg {
         * }
         */
        goCarMall: function goCarMall() {
            var _ref43 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref43$errtip = _ref43.errtip,
                errtip = _ref43$errtip === undefined ? '' : _ref43$errtip,
                _ref43$action = _ref43.action,
                action = _ref43$action === undefined ? 'callapp' : _ref43$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'carmall',
                receive: "$['upliveapp_goCarMall']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goCarMall',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到我的座驾
         * @param cfg {
         * }
         */
        goMyCar: function goMyCar() {
            var _ref44 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref44$errtip = _ref44.errtip,
                errtip = _ref44$errtip === undefined ? '' : _ref44$errtip,
                _ref44$action = _ref44.action,
                action = _ref44$action === undefined ? 'callapp' : _ref44$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'mycar',
                receive: "$['upliveapp_goMyCar']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goMyCar',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /*--------------------- 外部协议 -------------------*/
        // 打开链接
        openUrlCallApp: function openUrlCallApp() {
            var _ref45 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref45$url = _ref45.url,
                url = _ref45$url === undefined ? '' : _ref45$url;

            var system = this.getSystem();
            var _url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                _url = urlPrefixCallAppInAndroid + '/webview?json=';;
            }

            var params = {
                key: 'webview',
                url: url
            };
            this.sendUriScheme(_url + encodeURIComponent(JSON.stringify(params)));
        },


        // 进入app的资讯详情
        newDetailCallApp: function newDetailCallApp(detail) {
            var system = this.getSystem();
            var _url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                _url = urlPrefixCallAppInAndroid + '/newdetail?json=';;
            }

            var params = _extends({
                key: 'newdetail'
            }, detail);

            this.sendUriScheme(_url + encodeURIComponent(JSON.stringify(params)));
        },


        // 进入用户主页
        profileCallApp: function profileCallApp() {
            var _ref46 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref46$uid = _ref46.uid,
                uid = _ref46$uid === undefined ? 0 : _ref46$uid;

            var system = this.getSystem();
            var url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                url = urlPrefixCallAppInAndroid + '/profile?json=';;
            }
            var params = {
                key: 'profile',
                extend: {
                    uid: parseInt(uid, 10)
                }
            };
            this.sendUriScheme(url + encodeURIComponent(JSON.stringify(params)));
        },


        // 进入充值页
        goPayCallApp: function goPayCallApp() {
            var system = this.getSystem();
            var url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                url = urlPrefixCallAppInAndroid + '/pay?json=';
            }
            var params = {
                key: 'pay'
            };
            this.sendUriScheme(url + encodeURIComponent(JSON.stringify(params)));
        },


        // 直播间
        goRoomCallApp: function goRoomCallApp() {
            var _ref47 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref47$uid = _ref47.uid,
                uid = _ref47$uid === undefined ? 0 : _ref47$uid,
                _ref47$roomid = _ref47.roomid,
                roomid = _ref47$roomid === undefined ? 0 : _ref47$roomid;

            var system = this.getSystem();
            var url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                url = urlPrefixCallAppInAndroid + '/room?json=';
            }
            var params = {
                key: 'room',
                extend: {
                    uid: parseInt(uid, 10),
                    roomid: parseInt(roomid, 10)
                }
            };
            this.sendUriScheme(url + encodeURIComponent(JSON.stringify(params)));
        },

        // 榜单页 1 星榜，2主播榜，3财富榜
        goRankCallApp: function goRankCallApp() {
            var _ref48 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref48$name = _ref48.name,
                name = _ref48$name === undefined ? 1 : _ref48$name;

            var system = this.getSystem();
            var url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                url = urlPrefixCallAppInAndroid + '/rank?json=';
            }
            var key = void 0;

            switch (parseInt(name, 10)) {
                case 1:
                    key = 'starank';
                    break;
                case 2:
                    key = 'hostrank';
                    break;
                case 3:
                    key = 'wealthrank';
                    break;
                default:
                    key = 'starank';
            }
            var params = {
                key: key
            };
            this.sendUriScheme(url + encodeURIComponent(JSON.stringify(params)));
        },

        // 1.6.5 根据国家码跳转到国家主播列表
        goHotListByAreaCallApp: function goHotListByAreaCallApp() {
            var _ref49 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref49$countryCode = _ref49.countryCode,
                countryCode = _ref49$countryCode === undefined ? '' : _ref49$countryCode;

            var system = this.getSystem();
            var url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                url = urlPrefixCallAppInAndroid + '/hotbyarea?json=';
            }
            var params = {
                key: 'hotbyarea',
                extend: {
                    countryCode: countryCode
                }
            };
            this.sendUriScheme(url + encodeURIComponent(JSON.stringify(params)));
        },

        /**
         * 发送GIFTO礼物
         * @param cfg {
         *      data {}；发送礼物的详细信息
         *      complete: function(){}
         * }
         *      uplive://sendGTOGift?json={
         *              "jsCallback": ""
         *              ,receive:""
         *              ,"data":"{
         *                  //接收礼物用户uid
         *                  "sendtoUid":"",
         *                  // 消息内容
         *                  "content": "1";
         *                  //礼物ID 必填
         *                  "giftId": "2";
         *                  //礼物名称
         *                  "giftName" : "3";
         *                  //连发系数
         *                  "giftAmount": "4";
         *                  //是否连续
         *                  "isContinuous": "5";
         *                  //连续次数 必填
         *                  "numContinuous": "6";
         *                  //礼物大图
         *                  "giftBigPicUrl": "6";
         *              }"}
         *
         */
        sendGTOGift: function sendGTOGift() {
            var _ref50 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref50$complete = _ref50.complete,
                complete = _ref50$complete === undefined ? function () {} : _ref50$complete,
                _ref50$data = _ref50.data,
                data = _ref50$data === undefined ? {} : _ref50$data,
                _ref50$errtip = _ref50.errtip,
                errtip = _ref50$errtip === undefined ? '不支持' : _ref50$errtip;

            var self = this;
            var url = 'uplive://sendGTOGift?json=';
            var params = {
                receive: "$['upliveapp_sendGTOGift']",
                jsCallback: '$.sendGiftoGiftComplete',
                data: data
            };

            $.sendGiftoGiftComplete = function (param) {
                // usertoken: "", uid: "", language: ""
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'sendGTOGift',
                errtip: errtip
            });
        },

        /**
         * 通过面板的id和礼物的id选中礼物
         * @param data
         * @param errtip
         */
        selectGift: function selectGift(_ref51) {
            var _ref51$data = _ref51.data,
                data = _ref51$data === undefined ? {} : _ref51$data,
                _ref51$errtip = _ref51.errtip,
                errtip = _ref51$errtip === undefined ? '不支持' : _ref51$errtip;

            var url = 'uplive://selectGift?json=';
            var params = {
                receive: "$['upliveapp_selectGift']",
                params: {
                    giftId: data.giftId,
                    labelId: data.labelId
                }
            };
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'selectGift',
                errtip: errtip
            });
        },

        /**
         * 发送登录结果
         * @param data
         * @param errtip
         */
        sendLoginResult: function sendLoginResult(_ref52) {
            var _ref52$data = _ref52.data,
                data = _ref52$data === undefined ? {} : _ref52$data,
                _ref52$errtip = _ref52.errtip,
                errtip = _ref52$errtip === undefined ? '不支持' : _ref52$errtip;

            var url = 'uplive://LoginResult?json=';
            var params = {
                receive: "$['upliveapp_loginResult']",
                userInfo: {
                    id: data.id,
                    first_name: data.first_name,
                    last_name: data.last_name,
                    username: data.username, // 首次注册这个值没有
                    photo_url: data.photo_url, // 首次注册这个值没有
                    auth_date: data.auth_date,
                    hash: data.hash,
                    extends: data.extends || ''
                },
                type: data.type || 'telegram',
                result: data.result,
                message: data.errmsg || '',
                jsCallback: '$.sendLoginResultCallback'
            };
            $.sendLoginResultCallback = function () {};
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'loginResult',
                errtip: errtip
            });
        },

        /**---------------------------------3.3.1新增协议------------------------------------*/
        /**
         * 跳转荣耀挑战赛榜单
         * tab=0 今日上升榜  tab=1 赛季战力榜
         **/
        goPKRank: function goPKRank() {
            var _ref53 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref53$errtip = _ref53.errtip,
                errtip = _ref53$errtip === undefined ? '' : _ref53$errtip,
                _ref53$tab = _ref53.tab,
                tab = _ref53$tab === undefined ? 0 : _ref53$tab,
                _ref53$action = _ref53.action,
                action = _ref53$action === undefined ? 'callapp' : _ref53$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'goPKRank',
                extend: {
                    tab: tab
                },
                receive: "$['upliveapp_goPKRank']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goPKRank',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },

        /**
         * 跳转荣耀挑战赛
         **/
        goPKProfile: function goPKProfile() {
            var _ref54 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref54$errtip = _ref54.errtip,
                errtip = _ref54$errtip === undefined ? '' : _ref54$errtip,
                _ref54$action = _ref54.action,
                action = _ref54$action === undefined ? 'callapp' : _ref54$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'goPKProfile',
                receive: "$['upliveapp_goPKProfile']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goPKProfile',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },

        /**
         * 跳转签到页面
         **/
        goCheckin: function goCheckin() {
            var _ref55 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref55$errtip = _ref55.errtip,
                errtip = _ref55$errtip === undefined ? '不支持' : _ref55$errtip,
                _ref55$action = _ref55.action,
                action = _ref55$action === undefined ? 'callapp' : _ref55$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'openCheckin',
                "receive": "$['upliveapp_goCheckin']"
                // "jsCallback":"$.goCheckinComplete"
            };
            // $.goCheckinComplete = function(param) { // usertoken: "", uid: "", language: ""
            //     complete.call(self, JSON.parse(param));
            // }

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goCheckin',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转游戏列表
         **/
        goGameLivingList: function goGameLivingList() {
            var _ref56 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref56$errtip = _ref56.errtip,
                errtip = _ref56$errtip === undefined ? '' : _ref56$errtip,
                _ref56$action = _ref56.action,
                action = _ref56$action === undefined ? 'callapp' : _ref56$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: "goGameLivingList",
                receive: "$['upliveapp_goGameLivingList']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goGameLivingList',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },

        /**
         * 跳转游戏标签列表
         * labelId 标签id
         **/
        goGameLivingLabel: function goGameLivingLabel() {
            var _ref57 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref57$errtip = _ref57.errtip,
                errtip = _ref57$errtip === undefined ? '' : _ref57$errtip,
                _ref57$labelId = _ref57.labelId,
                labelId = _ref57$labelId === undefined ? 0 : _ref57$labelId,
                _ref57$action = _ref57.action,
                action = _ref57$action === undefined ? 'callapp' : _ref57$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: "goGameLivingLabel",
                extend: {
                    labelId: labelId
                },
                receive: "$['upliveapp_goGameLivingLabel']"
            };
            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goGameLivingLabel',
                    errtip: errtip
                });
            } else {
                return url;
            }
        }
    };

    var _loop = function _loop(i) {
        $['upliveapp_' + i] = function () {
            apiStatus[i] = 1;
        };
    };

    for (var i in native) {
        _loop(i);
    }

    window.UpSDK = native;

    if (typeof module != 'undefined' && module.exports) {
        module.exports = native;
    } else {
        window.UpSDK = native;
    }

    if (window.define && __webpack_require__(24).cmd) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {
            module.exports = native;
        }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
})(window, window.Zepto || window.jQuery || (window['$'] = {}));

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * 礼物兑换
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    var Base = __webpack_require__(1);

    var PopLayer = __webpack_require__(8);

    var GalaPop = Base.extend({
        defaults: {
            title: '',
            context: '',
            btnContext: ''
        },

        initialize: function initialize() {
            var self = this;
            self.Parent.apply(self, arguments);
        },
        getContent: function getContent() {
            return '<div class="content-wrap">\n                            <div class="content-ico"></div>\n                            <div class="content-main">\n                                <div class="content-hd">' + this.get('title') + '</div>\n                                <div class="content-bd">\n                                    ' + this.get('context') + '\n                                </div>\n                                <div class="content-ft">\n                                    ' + this.get('btnContext') + '\n                                </div>\n                            </div>\n                        </div>';
        },
        create: function create(count) {
            var _this = this;

            var self = this;
            this.popup = new PopLayer({
                content: this.getContent()
            });

            this.popup.on('create', function (el) {
                _this.get('onCreate') && _this.get('onCreate')(el, _this.popup, _this);
            });
            this.popup.on('close', function (el) {
                _this.get('onClose') && _this.get('onClose')(el, _this.popup, _this);
            });
            this.popup.create();
        },
        close: function close() {
            this.popup.emit('close');
            this.popup.destroy();
            this.popup.mask.destroy();
        },
        refresh: function refresh() {
            this.popup.get('el').find('.widget-poplayer-content').html(this.getContent());
        }
    });

    module.exports = GalaPop;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    /**
     * @file 合并参数
     * @author 子虔
     * @date    2014-08-15 17:43:36
     * @param  {Object}  to - 源
     * @param  {Object}  from - 要处理的对象
     */

    module.exports = function parseParam(to, from) {
        var key,
            obj = {};

        from = from || {};

        for (key in to) {
            if (to.hasOwnProperty(key)) {
                obj[key] = to[key];
                if (from[key] != null) {
                    if (from.hasOwnProperty(key)) {
                        if ($.isPlainObject(obj[key]) && $.isPlainObject(from[key])) {
                            obj[key] = parseParam(obj[key], from[key]);
                        } else {
                            obj[key] = from[key];
                        }
                    }
                }
            }
        }

        return obj;
    };
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    /**
     * @file isEqual(来自underscore)
     * @author 子虔
     * @date    2015-02-15 15:37:47
     */
    module.exports = eq;

    // Internal recursive comparison function for `isEqual`.
    function eq(a, b, aStack, bStack) {
        // Identical objects are equal. `0 === -0`, but they aren't identical.
        // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
        if (a === b) return a !== 0 || 1 / a === 1 / b;
        // A strict comparison is necessary because `null == undefined`.
        if (a == null || b == null) return a === b;

        // Compare `[[Class]]` names.
        var className = Object.prototype.toString.call(a);
        if (className !== Object.prototype.toString.call(b)) return false;

        switch (className) {
            // Strings, numbers, regular expressions, dates, and booleans are compared by value.
            case '[object RegExp]':
            // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
            case '[object String]':
                // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
                // equivalent to `new String("5")`.
                return '' + a === '' + b;
            case '[object Number]':
                // `NaN`s are equivalent, but non-reflexive.
                // Object(NaN) is equivalent to NaN
                if (+a !== +a) return +b !== +b;
                // An `egal` comparison is performed for other numeric values.
                return +a === 0 ? 1 / +a === 1 / b : +a === +b;
            case '[object Date]':
            case '[object Boolean]':
                // Coerce dates and booleans to numeric primitive values. Dates are compared by their
                // millisecond representations. Note that invalid dates with millisecond representations
                // of `NaN` are not equivalent.
                return +a === +b;
        }

        var areArrays = className === '[object Array]';

        if (!areArrays) {
            if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) != 'object' || (typeof b === 'undefined' ? 'undefined' : _typeof(b)) != 'object') return false;

            // Objects with different constructors are not equivalent, but `Object`s or `Array`s
            // from different frames are.
            var aCtor = a.constructor,
                bCtor = b.constructor;
            if (aCtor !== bCtor && !(typeof aCtor == 'function' && aCtor instanceof aCtor && typeof bCtor == 'function' && bCtor instanceof bCtor) && 'constructor' in a && 'constructor' in b) {
                return false;
            }
        }
        // Assume equality for cyclic structures. The algorithm for detecting cyclic
        // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

        // Initializing stack of traversed objects.
        // It's done here since we only need them for objects and arrays comparison.
        aStack = aStack || [];
        bStack = bStack || [];
        var length = aStack.length;
        while (length--) {
            // Linear search. Performance is inversely proportional to the number of
            // unique nested structures.
            if (aStack[length] === a) return bStack[length] === b;
        }

        // Add the first object to the stack of traversed objects.
        aStack.push(a);
        bStack.push(b);

        // Recursively compare objects and arrays.
        if (areArrays) {
            // Compare array lengths to determine if a deep comparison is necessary.
            length = a.length;
            if (length !== b.length) return false;
            // Deep compare the contents, ignoring non-numeric properties.

            while (length--) {
                if (!eq(a[length], b[length], aStack, bStack)) return false;
            }
        } else {
            // Deep compare objects.
            var keys = Object.keys(a),
                key;
            length = keys.length;
            // Ensure that both objects contain the same number of properties before comparing deep equality.
            if (Object.keys(b).length !== length) return false;

            while (length--) {
                // Deep compare each member
                key = keys[length];
                if (!(b.hasOwnProperty(key) && eq(a[key], b[key], aStack, bStack))) return false;
            }
        }
        // Remove the first object from the stack of traversed objects.
        aStack.pop();
        bStack.pop();
        return true;
    }
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * 弹出框模块
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    var Layer = __webpack_require__(9);
    var Mask = __webpack_require__(28);

    var templateList = ['<div class="widget-poplayer">', '<span class="widget-poplayer-close" data-id="close">×</span>', '<div class="widget-poplayer-content">{{content}}</div>', '</div>'];

    var PopLayer = Layer.extend({

        defaults: {
            template: templateList.join(''),
            content: ''
        },

        initialize: function initialize() {
            var self = this;

            self.mask = new Mask({
                hideWhenTap: 0
            });
            self.Parent(self, arguments);
        },

        create: function create() {
            var self = this;
            var content = this.get('content');
            var template = this.get('template');

            self.set('template', template.replace('{{content}}', content));

            self.mask.create();

            self.Parent.apply(self, arguments);
            self.fixPostion();
            self.bindEvent();
        },

        fixPostion: function fixPostion() {
            var el = this.get('el');

            el.css({
                'margin-left': '-' + el.width() / 2 + 'px',
                'margin-top': '-' + el.height() / 2 + 'px'
            });
        },
        bindEvent: function bindEvent() {
            var self = this;
            var el = this.get('el');

            el.on('click', '[data-id=close]', function () {
                self.emit('close');
                self.destroy();
                self.mask.destroy();
            });

            self.mask.on('destroy', function () {
                el.remove();
            });
        }

    });

    //UpAct.PopLayer = PopLayer;

    module.exports = PopLayer;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {



/**
 *@fileoverview 层
 *@author zhenn
 */

var Base = __webpack_require__(1);

var Layer = Base.extend({

    defaults: {
        template: '<div></div>'
    },

    initialize: function initialize() {
        this.Parent.apply(this, arguments);
        // this.create();
    },

    create: function create() {
        var template = this.get('template');
        var el = $(template);

        $(document.body).append(el);
        this.set('el', el);
        this.emit('create', el);
    },

    destroy: function destroy() {
        var el = this.get('el');
        el.remove();
        this.emit('destroy');
    }

});

module.exports = Layer;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * 礼物兑换
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    var Base = __webpack_require__(1);
    var native = __webpack_require__(4);
    var UserAct = __webpack_require__(25);
    var taskTpl = __webpack_require__(26);

    var getErrConfig = __webpack_require__(27);

    var GalaPop = __webpack_require__(5);

    var TaskComponent = Base.extend({
        defaults: {
            wrap: '#task-bolck',
            taskTpl: taskTpl,
            exchangeCount: 0,
            userToken: ''
        },

        initialize: function initialize() {
            var self = this;
            self.Parent.apply(self, arguments);
            this.nodeWrap = $(this.get('wrap'));
        },
        render: function render() {
            var self = this;
            this.on('getActInfo', function (data) {
                var html = taskTpl({
                    taskActInfo: data
                });

                this.nodeWrap.append(html);
                self.bindEvent();
            });
            this.loadActData();
        },
        loadActData: function loadActData() {
            var _this = this;

            var userAct = new UserAct({
                activityId: UpAct.CONFIG.getTaskActId(),
                userToken: this.get('userToken')
            });
            var promise = userAct.getUserActInfo();

            promise.done(function (data) {
                UpAct.taskActInfo = data;
                _this.emit('getActInfo', data);
            });
        },
        bindEvent: function bindEvent() {

            var self = this;
            $('[node-id="reward-task"]', this.nodeWrap).on('click', function (e) {
                var target = e.currentTarget;
                var acid = $(target).data('acid');
                var toreward = $(target).data('toreward');

                if (toreward > 0) {
                    self.handleClick(acid);
                }
            });
        },
        handleClick: function handleClick(acid) {

            var self = this;
            var taskActInfo = UpAct.taskActInfo[acid];
            // if(taskActInfo.serverTime > taskActInfo.endTime ){
            //     let content = UpAct.lang.template('不在活动时间范围内');
            //     return self.tipForExchange(content);
            // }
            if (taskActInfo.rewardList.toreward > 0) {
                self.guidToExchange(acid, taskActInfo.rewardList.toreward);
            } else {
                var content = UpAct.lang.template('不可领取提示');
                self.tipForExchange(content);
            }
        },
        guidToExchange: function guidToExchange(acid, count) {

            var self = this;

            var pop = new GalaPop({
                //title: UpAct.lang.template('活动规则'),
                context: '<span>' + UpAct.lang.template("可领取提示{count}", { count: count }) + '</span>',
                btnContext: '<div class="gala-pop-btn" node-id="okBtn">\n                        ' + UpAct.lang.template('领取') + '\n                    </div>',
                onCreate: function onCreate(el, popup, gala) {
                    el.addClass('widget-poplayer-alert');
                    el.delegate('[node-id="okBtn"]', 'click', function () {
                        UpAct.loading.show();
                        self.handleExchange(acid);
                        pop.close();
                    });
                }
            });

            pop.create();
        },
        tipForExchange: function tipForExchange(content) {

            var self = this;

            var pop = new GalaPop({
                context: content,
                onCreate: function onCreate(el, popup, gala) {
                    el.addClass('widget-poplayer-alert');
                }
            });

            pop.create();
        },
        tipForExchangeSuccess: function tipForExchangeSuccess(content) {

            var self = this;

            var pop = new GalaPop({
                //title: UpAct.lang.template('活动规则'),
                context: content,
                btnContext: '<div class="gala-pop-btn" node-id="okBtn">\n                        ' + UpAct.lang.template('确定') + '\n                    </div>',
                onCreate: function onCreate(el, popup, gala) {
                    el.addClass('widget-poplayer-alert');
                    el.delegate('[node-id="okBtn"]', 'click', function () {
                        pop.close();
                        window.location.reload();
                    });
                },
                onClose: function onClose(el) {}
            });

            pop.create();
        },
        handleExchange: function handleExchange(acid) {
            var self = this;
            if (this.submitting) {
                return;
            }
            this.submitting = true;

            UpAct.loading.show();
            var userAct = new UserAct({
                activityId: acid,
                userToken: this.get('userToken')
            });
            var promise = userAct.doExchange();
            promise.done(function (res) {
                self.submitting = false;
                UpAct.loading.hide();
                var content = UpAct.lang.template('领取成功提示');
                self.tipForExchangeSuccess(content);
            });
            promise.fail(function (res) {
                self.submitting = false;
                UpAct.loading.hide();

                var errInfo = getErrConfig(res.errcode);

                var content = UpAct.lang.template(errInfo.tip);

                self.tipForExchange(content, errInfo.type);
            });
        }
    });

    module.exports = TaskComponent;

    UpAct.TaskComponent = TaskComponent;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "769f950bb77e82c931d330881cdb0905.jpg";

/***/ }),
/* 12 */
/***/ (function(module, exports) {

/**
 * 前端多语言解决方案
 */
;(function (win, UpAct, Util) {

    var LangUtil = function LangUtil() {
        this.initialize.apply(this, arguments);
    };

    LangUtil.prototype = {
        /**
         * @return zh-CN、zh-TW、zh-HK、ar-EG、vi-VN、ja-JP
         */
        lang: '',
        /**
         * @return zhcn、zhtw、zhhk、areg、vivn、jajp
         */
        langType: '',
        /**
         * 支持的语言列表
         */
        languages: ['zh-CN'],
        /**
         * 初始化化入口
         */
        initialize: function initialize(cfg) {},

        init: function init(cfg) {
            var LangPack = window.UpLive_LangPack || {};
            var lang = this.getLanguage();
            var langType = lang.replace('-', '').toLowerCase();

            $('html').attr('lang', lang);
            $('body').addClass(langType);

            this.lang = lang;
            this.pack = LangPack[langType];
            this.langType = langType;
        },
        /**
         * 获取语言。优先级：URL配置 > 系统语言 > 默认语言
         */
        getLanguage: function getLanguage() {
            if (Util.query('_lang')) {
                // 配置页面语言
                return Util.query('_lang');
            } else if (window.g_Language) {
                // 系统浏览器语言
                return window.g_Language;
            } else {
                return this.languages[0]; // 若没有，获取第一个活动语言。
            }
        },
        /**
         * 渲染模版内容
         * @param tplStr模版内容
         * @param data 数据
         * @splitWidthEM  默认false
         */
        template: function template(tplStr, data, insertEM) {
            var tpl = (this.pack && this.pack[tplStr] || tplStr) + '';

            insertEM = typeof insertEM == 'undefined' ? false : true;

            if (!tpl) {
                return '';
            }

            // for 活动规则。段落分隔符号：@@@@
            if (tpl.indexOf('@@@@') >= 0) {
                var strArr = [];

                strArr.push('<ul>');
                tpl.split('@@@@').forEach(function (item, index) {
                    item && strArr.push('<li>' + item + '</li>');
                });
                strArr.push('</ul>');
                tpl = strArr.join('');
            }

            tpl = tpl.replace(/\{([\s\S]+?)\}/ig, function ($0, $1) {
                if (insertEM) {
                    return '<em class="' + $1 + '">' + data[$1] + '</em>';
                } else {
                    return data[$1];
                }
            });

            return tpl;
        },

        areaTemplate: function areaTemplate(code, tplStr, data, insertEM) {

            var LangPack = window.UpLive_LangPack || {};
            var pack = LangPack[code];
            var tpl = (pack && pack[tplStr] || tplStr) + '';

            insertEM = typeof insertEM == 'undefined' ? false : true;

            if (!tpl) {
                return '';
            }

            // for 活动规则。段落分隔符号：@@@@
            if (tpl.indexOf('@@@@') >= 0) {
                var strArr = [];

                strArr.push('<ul>');
                tpl.split('@@@@').forEach(function (item, index) {
                    item && strArr.push('<li>' + item + '</li>');
                });
                strArr.push('</ul>');
                tpl = strArr.join('');
            }

            tpl = tpl.replace(/\{([\s\S]+?)\}/ig, function ($0, $1) {
                if (insertEM) {
                    return '<em class="' + $1 + '">' + data[$1] + '</em>';
                } else {
                    return data[$1];
                }
            });

            return tpl;
        }
    };

    UpAct.lang = new LangUtil();
})(window, window['UpAct'] || (window['UpAct'] = {}), UpAct.BaseUtil);

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {
    /**
     * @file 基础Event
     * @author 子虔
     * @date    2014-08-04 16:11:13
     * @example
     *        * 支持多个事件的添加、移除、派发
     *            this.on('name1,name2,name3',function(){});
     *        * 支持使用层次的方式调用子对象的事件
     *            this.on('parent/child/child/name',function(){}); === this.parent.child.child.on(name,function(){})
     */
    var Callbacks = __webpack_require__(20),
        channelObj = {};

    // 统一事件机制
    var Events = {
        Event: Callbacks,
        /**
         * 添加事件监听
         * @param  {string}   name - 事件名称
         * @param  {function} callback - 事件回调
         */
        on: function on(name, callback) {
            var obj,
                that = this;

            this.events = this.events || {};

            // 逗号隔开，支持多事件
            if (name && name.indexOf(',') != -1) {
                return (name.split(',') || []).forEach(function (item) {
                    if (item) {
                        that.on(item, callback);
                    }
                });
            }

            if (!this.global && name.indexOf('/') != -1) {
                // 频道监听
                if (name.split('/')[0] == 'channel') {
                    return that.channel.on(name.replace(/^channel\//gi, ''), callback);
                }

                obj = getObjectByNames(name, this);
                this.events[name] = this.events[name] || [];
                this.events[name].push(callback);
                return obj ? obj.on(getEventName(name), callback) : this;
            } else {
                obj = this.events[name] || (this.events[name] = this.Event());
            }

            // 如果设置为一起派发，则再次监听时，直接执行
            if (this._alwayEmitSource && this._alwayEmitSource[name]) {
                return callback.apply(name, this._alwayEmitSource[name]);
            }
            obj.add(callback);

            return this;
        },
        /**
         * 移除事件监听
         * @param  {string}   name     事件名称
         * @param  {function} [callback] - 事件回调，为空时，移除所有回调
         */
        off: function off(name, callback) {
            var obj,
                funs,
                that = this;

            this.events = this.events || {};

            // 逗号隔开，支持多事件
            if (name && name.indexOf(',') != -1) {
                return (name.split(',') || []).forEach(function (item) {
                    if (item) {
                        that.off(item, callback);
                    }
                });
            }

            if (!this.global && name && name.indexOf('/') != -1) {
                if (name.split('/')[0] == 'channel') {
                    return that.channel.off(name.replace(/^channel\//gi, ''), callback);
                }

                if (this.events[name]) {
                    obj = getObjectByNames(name, this);
                    if (callback) {
                        return obj ? obj.off(getEventName(name), callback) : this;
                    } else {
                        funs = this.events[name];
                        for (var i = 0; obj && funs && i < funs.length; i++) {
                            obj.off(getEventName(name), funs[i]);
                        }
                        this.events[name] = null;
                    }
                }

                return this;
            }

            if (name && callback && (obj = this.events[name])) {
                obj.remove(callback);
            } else if (name && (obj = this.events[name])) {
                obj.empty();
            } else {

                for (name in this.events) {
                    if (this.events.hasOwnProperty(name) && this.events[name]) {
                        if (!this.global && name.indexOf('/') != -1) {
                            if (name.split('/')[0] == 'channel') {
                                return this.channel.off(name.replace(/^channel\//gi, ''));
                            }
                            this.off(name);
                        } else {
                            this.events[name].empty();
                        }
                    }
                }
            }

            return this;
        },
        ///**
        // * 只监听一次事件
        // * @param name
        // * @param callback
        // */
        //once: function (name, callback) {
        //    var _callback;
        //
        //    this.on(name, _callback = function () {
        //        callback.apply(this, arguments);
        //        this.off(name, _callback);
        //    });
        //},
        /**
         * 默认派发事件
         * @return {object}
         */
        trigger: function trigger() {
            var name = arguments[0],
                obj,
                param,
                that = this;

            this.events = this.events || {};
            param = Array.prototype.slice.call(arguments, 1);

            // 逗号隔开，支持多事件
            if (name && name.indexOf(',') != -1) {
                return (name.split(',') || []).forEach(function (item) {
                    if (item) {
                        that.trigger.apply(this, [item].concat(param));
                    }
                });
            }

            if (!this.global && name && name.indexOf('/') != -1) {
                if (name.split('/')[0] == 'channel') {
                    return that.channel.trigger.apply(that.channel, [name.replace(/^channel\//gi, '')].concat(param));
                }
                obj = getObjectByNames(name, this);
                name = getEventName(name);
                return obj ? obj.trigger.apply(obj, [name].concat(param)) : this;
            }

            if (name && (obj = this.events[name])) {
                obj.fire.apply(this, [].concat(param));
            }

            return {
                event: obj,
                always: function always() {
                    that._alwayEmitSource = that._alwayEmitSource || {};
                    that._alwayEmitSource[name] = [].concat(param);
                }
            };
        },
        /**
         * 派发事件
         * @example
         *        this.emit('ready',args0,args1...);
         */
        emit: function emit() {
            return this.trigger.apply(this, arguments);
        }
    };

    /**
     * 获取context下的name属性
     * @private
     */
    function getObjectByNames(name, context) {
        var that, names, len;

        context = context || {};
        that = context;
        names = name.split('/');
        len = names.length;

        for (var i = 0; len > 1 && i < len - 1; i++) {
            if (that && that[names[i]]) {
                that = that[names[i]];
            } else {
                that = null;
            }
        }

        return that;
    }

    /**
     * 获取事件名称
     * @param  {String} name [description]
     * @return {String}
     */
    function getEventName(name) {
        var names = name.split('/');
        return names[names.length - 1];
    }

    // global single Event
    Events.channel = $.channel || ($.channel = $.extend(channelObj, Events));
    Events.channel.global = Events.channel;

    module.exports = Events;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    /**
     * @fileoverview callbacks
     * @author 子虔
     * @date    2014-08-31 12:09:10
     */
    module.exports = function (options) {
        options = $.extend({}, options);

        var memory,
            // Last fire value (for non-forgettable lists)
        _fired,
            // Flag to know if list was already fired
        firing,
            // Flag to know if list is currently firing
        firingStart,
            // First callback to fire (used internally by add and fireWith)
        firingLength,
            // End of the loop when firing
        firingIndex,
            // Index of currently firing callback (modified by remove if needed)
        list = [],
            // Actual callback list
        stack = !options.once && [],
            // Stack of fire calls for repeatable lists
        fire = function fire(data) {
            memory = options.memory && data;
            _fired = true;
            firingIndex = firingStart || 0;
            firingStart = 0;
            firingLength = list.length;
            firing = true;
            for (; list && firingIndex < firingLength; ++firingIndex) {
                if (list[firingIndex].apply(data[0], data[1]) === false && options.stopOnFalse) {
                    memory = false;
                    break;
                }
            }
            firing = false;
            if (list) {
                if (stack) stack.length && fire(stack.shift());else if (memory) list.length = 0;else Callbacks.disable();
            }
        },
            Callbacks = {
            list: list,
            add: function add() {
                if (list) {
                    var start = list.length,
                        add = function add(args) {
                        args = Array.prototype.slice.call(args);
                        args.forEach(function (arg, _) {
                            if (typeof arg === "function") {
                                if (!options.unique || !Callbacks.has(arg)) list.push(arg);
                            } else if (arg && arg.length && typeof arg !== 'string') add(arg);
                        });
                    };
                    add(arguments);
                    if (firing) firingLength = list.length;else if (memory) {
                        firingStart = start;
                        fire(memory);
                    }
                }
                return this;
            },
            remove: function remove() {
                var args = Array.prototype.slice.call(arguments);
                if (list) {
                    args.forEach(function (arg, _) {
                        var index;
                        while ((index = list.indexOf(arg, index)) > -1) {
                            list.splice(index, 1);
                            // Handle firing indexes
                            if (firing) {
                                if (index <= firingLength) --firingLength;
                                if (index <= firingIndex) --firingIndex;
                            }
                        }
                    });
                }
                return this;
            },
            has: function has(fn) {
                return !!(list && (fn ? list.indexOf(fn) > -1 : list.length));
            },
            empty: function empty() {
                firingLength = list.length = 0;
                return this;
            },
            disable: function disable() {
                list = stack = memory = undefined;
                return this;
            },
            disabled: function disabled() {
                return !list;
            },
            lock: function lock() {
                stack = undefined;
                if (!memory) Callbacks.disable();
                return this;
            },
            locked: function locked() {
                return !stack;
            },
            fireWith: function fireWith(context, args) {
                if (list && (!_fired || stack)) {
                    args = args || [];
                    args = [context, args.slice ? args.slice() : args];
                    if (firing) stack.push(args);else fire(args);
                }
                return this;
            },
            fire: function fire() {
                return Callbacks.fireWith(this, arguments);
            },
            fired: function fired() {
                return !!_fired;
            }
        };

        return Callbacks;
    };
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    /**
     * @file 继承和扩展
     * @author 子虔
     * @date    2014-08-15 11:24:20
     * @param  {Object} protoProps  子类的prototype
     * @param  {[type]} staticProps 子类的静态方法或属性
     * @return {Class}
     */
    var inherits = __webpack_require__(22);

    module.exports = function (protoProps, staticProps) {
        var parent = this,
            child,
            destroy;

        // The constructor function for the new subclass is either defined by you
        // (the "constructor" property in your `extend` definition), or defaulted
        // by us to simply call the parent's constructor.
        if (protoProps && protoProps.hasOwnProperty('constructor')) {
            child = protoProps.constructor;
        } else {
            child = function child() {
                return parent.apply(this, arguments);
            };
        }

        // inherits
        inherits(child, parent, protoProps, staticProps);

        // 销毁自动继承
        if (protoProps.hasOwnProperty('destroy') && (destroy = protoProps.destroy)) {
            protoProps.destroy = function () {
                try {
                    destroy.apply(this, arguments);
                } catch (e) {}

                try {
                    parent.prototype.destroy.apply(this, arguments);
                } catch (e) {}
            };
        }

        return child;
    };
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {
    /**
     * @file 继承并在原型链中提供`Parent`方法，用于调用父类prototype中的方法
     * @author 子虔
     * @date    2015-02-15 15:11:23
     */
    module.exports = function (child, parent, protoProps, staticProps) {
        // 绑定静态属性
        $.extend(child, parent, staticProps);

        function Prototype() {
            this.constructor = child;
        }

        Prototype.prototype = parent.prototype;

        child.prototype = new Prototype();

        // 绑定新的属性
        if (protoProps) {
            $.extend(child.prototype, protoProps);
        }

        // merge the Class's default's prototype
        child.prototype.defaults = $.extend(true, {}, parent.prototype.defaults, child.prototype.defaults);

        // Set a convenience property in case the parent's prototype is needed
        // later.
        child.__super__ = parent.prototype;
        child.__class__ = [];

        if (!parent.__class__) {
            child.__class__.push(parent, child);
        } else {
            parent.__class__.forEach(function (item) {
                child.__class__.push(item);
            });
            child.__class__.push(child);
        }

        child.prototype.Parent = function Parent() {
            var caller,
                name,
                parent,
                allClass = this.constructor.__class__,
                allClassLength = allClass.length,
                i = allClassLength - 1,
                args = arguments,
                argsLen = args.length;

            if (argsLen == 2 && typeof args[0] == 'function' && isArgsObject(args[1])) {
                caller = args[0];
                args = args[1] || [];
            } else {
                caller = Parent.caller;
                args = arguments;
            }

            if (!caller) return;

            while (i > 0 && !name) {
                var fun = allClass[i],
                    fn = fun.prototype;
                for (var p in fn) {
                    if (fn.hasOwnProperty(p) && fn[p] === caller) {
                        name = p;
                        parent = allClass[i - 1];
                    }
                }
                i--;
            }

            if (name && parent) {
                if (parent.prototype[name]) {
                    return parent.prototype[name].apply(this, args);
                }
            }
        };
    };

    // 判断一个对象是否为arguments对象
    function isArgsObject(obj) {
        var type = Object.prototype.toString.call(obj);
        return type === '[object Arguments]';
    }
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    /**
     * @file 类属性相关的扩展
     * @author 子虔
     * @date    2014-08-18 17:41:24
     */

    var parseParam = __webpack_require__(6),
        isEqual = __webpack_require__(7);

    module.exports = {
        /**
         * 设置参数，可通过`a/b/c/d`的方式设置
         * @param {*} name - 名称或对象
         * @param {*} [value] - 属性值
         * @param {boolean} [silent=false] - 设置的值变化时，是否派发事件
         */
        set: function set(name, value, silent) {
            var data,
                names,
                lastValue,
                len,
                that = this;

            if (typeof name == 'string') {
                names = name.split('/');
                len = names.length;
                if (len > 1) {
                    names.forEach(function (item, index) {
                        if (index == len - 1) {
                            lastValue = data[item];
                            data[item] = value;
                            if (!silent && !isEqual(lastValue, value)) {
                                bubbling.call(that, names, value, lastValue);
                            }
                        } else {
                            data = data || that.attributes;
                            data[item] = data[item] || {};
                            data = data[item];
                        }
                    });
                    return;
                }
            }

            function bubbling(names, value, lastValue) {
                var name = names.length == 1 ? names[0] : names.join('/');

                if (names.length > 0) {
                    this.emit('change:' + name, value, lastValue);
                    names.pop();
                    bubbling.call(this, names, value, lastValue);
                }
            }

            return this.Parent(set, arguments);
        },
        /**
         * 获取参数,可通过`a/b/c/d`获取如上`set`例子中的`d`值
         * @param {string} name - 名称
         * @return {*}
         */
        get: function get(name) {
            var that = this,
                names,
                value = '',
                data,
                len;

            if (typeof name == 'string') {
                names = name.split('/');
                len = names.length;

                if (len > 1) {
                    names.forEach(function (item, index) {
                        if (index == len - 1 && data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) == 'object') {
                            value = data[item];
                        } else {
                            data = data || that.attributes;
                            data[item] = data[item];
                            data = data[item];
                        }
                    });

                    return value;
                }
            }

            return this.Parent(get, arguments);
        }
    };
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _http = __webpack_require__(3);

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserAct = function () {
    function UserAct() {
        var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { activityId: 0, userToken: "" };

        _classCallCheck(this, UserAct);

        this.param = param;
        this.actData = {}; // 存储用户信息 {活动ID：活动信息}
    }

    _createClass(UserAct, [{
        key: 'getUserActInfo',
        value: function getUserActInfo() {
            var _this = this;

            var promise = $.Deferred();
            var param = {};
            var promiseGetData = _http2.default.fetch({
                url: UpAct.CONFIG.getActStatus(),
                data: this.param
            });
            promiseGetData.done(function (res) {
                if (res.errcode == 0) {
                    var rewardData = _this.parseActInfo(res.data);

                    promise.resolve(rewardData);
                } else {
                    promise.reject(res);
                }
            });
            promiseGetData.fail(function (res) {
                promise.reject(res);
            });
            return promise;
        }
    }, {
        key: 'parseActInfo',
        value: function parseActInfo(data) {
            var taskActInfo = {};
            var keysArr = [];
            keysArr = data.status ? Object.keys(data.status) : [];
            if (keysArr.length > 0) {
                $.map(data.status, function (item, index) {

                    item.serverTime = data.serverTime;
                    taskActInfo[item.activityId] = item;
                });
            } else {
                /**test*/
                // data.rewardList.toreward = 10;
                taskActInfo[data.activityId] = data;
            }
            return taskActInfo;
        }
    }, {
        key: 'doExchange',
        value: function doExchange() {
            var promise = $.Deferred();
            var param = {};
            var promiseGetData = _http2.default.fetch({
                url: UpAct.CONFIG.doExchange(),
                data: this.param,
                type: 'POST'
            });
            promiseGetData.done(function (res) {
                if (res.errcode == 0) {
                    promise.resolve(res);
                } else {
                    promise.reject(res);
                }
            });
            promiseGetData.fail(function (res) {
                promise.reject(res);
            });
            return promise;
        }
    }]);

    return UserAct;
}();

module.exports = UserAct;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

	var lang = UpAct.lang;
	var btnText = lang.template('领取');

__p+='\n<div class="tasks">\n	<ul class="reward">\n		';

			_.each(taskActInfo,function(item,index){
			var toReward = 0;
			toReward = item.rewardList.toreward || 0;
			var rewarded = item.rewardList.rewarded || 0;
			
			console.log(toReward);
		
__p+='\n		<li>\n			<div class="toreward">'+
((__t=(lang.template('可领取限定礼物个数:{count}',{count:toReward})))==null?'':__t)+
'</div>\n			<div class="reward-btn ';
if(toReward <= 0){
__p+=' disable';
}
__p+='" node-id="reward-task" data-acid="'+
((__t=(item.activityId))==null?'':__t)+
'" data-toreward="'+
((__t=(toReward))==null?'':__t)+
'">'+
((__t=(btnText))==null?'':__t)+
'</div>\n		</li>\n		';


		})
		
__p+='\n	</ul>\n</div>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));


/***/ }),
/* 27 */
/***/ (function(module, exports) {

var errConfig = {
	2000001: {
		tip: '您已经领取过奖励啦！请下次参加！',
		type: 'alert'
	},
	2000002: {
		tip: '您的区域不是活动区域',
		type: 'alert'
	},
	2000003: {
		tip: '活动目前无法参加',
		type: 'alert'
	},
	2000005: {
		tip: '速度太快了，休息一会再试试',
		type: 'alert'
	},
	2000006: {
		tip: '不在活动时间范围内',
		type: 'alert'
	},
	2000007: {
		tip: '礼物领取失败，请与客服联系',
		type: 'alert'
	},
	2000008: {
		tip: '当前处于游客模式',
		type: 'login'
	},
	1000000: {
		tip: '系统错误',
		type: 'alert'
	}
};

var defaultConfig = {
	tip: '系统错误',
	type: 'alert'
};

function getErrConfig(errcode) {
	if (errConfig[errcode]) {
		return errConfig[errcode];
	} else {
		return defaultConfig;
	}
}
module.exports = getErrConfig;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

/**
 *@fileoverview 遮罩层
 *@author zhenn
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {
    var Layer = __webpack_require__(9);
    var Mask = Layer.extend({

        defaults: {
            hideWhenTap: 1,
            css: {
                position: 'fixed',
                width: '100%',
                height: '100%',
                zIndex: 99,
                background: '#000',
                opacity: '0.8',
                top: 0,
                left: 0
            }
        },

        initialize: function initialize() {
            this.Parent.apply(this, arguments);
        },

        create: function create() {

            var self = this;
            self.Parent.apply(this, arguments);

            var el = self.get('el');

            el.css(self.get('css'));
            self.setPos();
            self.bindEvent();
        },

        bindEvent: function bindEvent() {
            var self = this;
            var el = this.get('el');
            var hideWhenTap = self.get('hideWhenTap');
            el.on('click', function () {
                if (!hideWhenTap) {
                    return;
                }
                self.destroy();
            });
        },

        setPos: function setPos() {
            var self = this;
            var el = self.get('el');

            var realHeight = document.body.offsetHeight;
            var viewportHeight = document.documentElement.clientHeight;
            var maskHeight = realHeight >= viewportHeight ? realHeight : viewportHeight;

            el.css('height', maskHeight);
        }

    });

    module.exports = Mask;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// 组件

__webpack_require__(30);
__webpack_require__(31);
// 基本工具模块
__webpack_require__(32);
// 对数字处理
__webpack_require__(33);
// 对时间处理
__webpack_require__(34);
// 对图片处理
__webpack_require__(35);
// 对直播级别处理
__webpack_require__(36);
// 路由
__webpack_require__(37);
// 筛选组件
__webpack_require__(38);
// 加载
__webpack_require__(39);
// 弹出层
__webpack_require__(8);
// 简单提示
__webpack_require__(40);
// 倒计时
__webpack_require__(41);
// tab切换
__webpack_require__(42);
// 全部刷新
__webpack_require__(44);
// 语言包
__webpack_require__(12);

// 业务模块 
__webpack_require__(45);
__webpack_require__(46);
__webpack_require__(49); // 主播榜单
__webpack_require__(51); // 达成榜单
__webpack_require__(54); // 土豪榜
__webpack_require__(57); // 主播守护榜
__webpack_require__(10); // 兑换礼物
__webpack_require__(60); // 速度榜单
__webpack_require__(61); // 时长榜单礼物
__webpack_require__(63); // 真爱守护
__webpack_require__(66); // 真爱守护

/***/ }),
/* 30 */
/***/ (function(module, exports) {

if (typeof Object.assign != 'function') {
    Object.assign = function (target) {
        'use strict';

        if (target == null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        target = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source != null) {
                for (var key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                    }
                }
            }
        }
        return target;
    };
}

/***/ }),
/* 31 */
/***/ (function(module, exports) {

//////////////////////////////////////////////////////////////////////////////
// the status constants
var PENDING = 0,
    FULFILLED = 1,
    REJECTED = 2;

//////////////////////////////////////////////////////////////////////////////
// Some utils
function isFunction(obj) {
    return typeof obj === "function";
}

function isThenable(obj) {
    return obj && isFunction(obj.then);
}

function checkArray(obj) {
    if (!Array.isArray(obj)) {
        throw new TypeError(obj + " is not array");
    }
}

//////////////////////////////////////////////////////////////////////////////
function resolve(value) {
    if (this._status !== PENDING) {
        return;
    }

    this._v = value;
    this._status = FULFILLED;

    var fn;
    while (fn = this._resolves.shift()) {
        fn.call(this, value);
    }
}

function reject(reason) {
    if (this._status !== PENDING) {
        return;
    }

    this._v = reason;
    this._status = REJECTED;

    var fn;
    while (fn = this._rejects.shift()) {
        fn.call(this, reason);
    }
}

//////////////////////////////////////////////////////////////////////////////
// The constructor function
function Promise(fn) {
    if (!isFunction(fn)) {
        throw new TypeError("Promise argument error:" + fn.toString());
    }

    this._status = PENDING;
    this._resolves = [];
    this._rejects = [];
    this._v = undefined;

    fn(resolve.bind(this), reject.bind(this));
}

//////////////////////////////////////////////////////////////////////////////
// The most important function for Promise is `then`

// `resolve` have different rules against `reject`:
// `resolve` will always trigger the `resolve` of next Promise, while
// `reject` may trigger the `reject` or `resolve` of next Promise.

function resolveWrapper(nRes, nRej, pResFn) {
    return function (value) {
        if (!isFunction(pResFn)) {
            return nRes(value);
        }

        try {
            var ret = pResFn(value);
            if (isThenable(ret)) {
                ret.then(nRes, nRej);
            } else {
                nRes(ret);
            }
        } catch (e) {
            nRej(e);
        }
    };
}

function rejectWrapper(nRes, nRej, pRejFn) {
    return function (reason) {
        if (!isFunction(pRejFn)) {
            return nRej(reason);
        }

        try {
            var ret = pRejFn(reason);
            if (isThenable(ret)) {
                ret.then(nRes, nRej);
            } else {
                nRes(ret);
            }
        } catch (e) {
            nRej(e);
        }
    };
}

function thenHandler(nRes, nRej, pResFn, pRejFn, pP) {
    var rsFn = resolveWrapper(nRes, nRej, pResFn);
    var rjFn = rejectWrapper(nRes, nRej, pRejFn);

    switch (pP._status) {
        case PENDING:
            pP._resolves.push(rsFn);
            pP._rejects.push(rjFn);
            break;
        case FULFILLED:
            rsFn(pP._v);
            break;
        case REJECTED:
            rjFn(pP._v);
            break;
        default:
            throw new Error("invalid status:" + pP._status);
    }
}

Promise.prototype.then = function (resFn, rejFn) {
    var pP = this;
    return new Promise(function (res, rej) {
        return thenHandler(res, rej, resFn, rejFn, pP);
    });
};

//////////////////////////////////////////////////////////////////////////////
// Some utils
Promise.prototype.catch = function (reason) {
    return this.then(null, reason);
};
Promise.resolve = function (value) {
    return new Promise(function (res, _) {
        return res(value);
    });
};
Promise.reject = function (reason) {
    return new Promise(function (_, rej) {
        return rej(reason);
    });
};

//////////////////////////////////////////////////////////////////////////////
// Promise.all
function handleAll(promises, resolve, reject) {
    // all promises share the same `count` and `result`.
    var count = promises.length;
    var result = [];

    function handle(i) {
        return function (value) {
            result[i] = value;
            if (--count === 0) {
                resolve(result);
            }
        };
    }
    promises.forEach(function (p, i) {
        return p.then(handle(i), reject);
    });
}

Promise.all = function (promises) {
    checkArray(promises);
    return new Promise(function (res, rej) {
        return handleAll(promises, res, rej);
    });
};

//////////////////////////////////////////////////////////////////////////////
// Promise.race
Promise.race = function (promises) {
    checkArray(promises);
    return new Promise(function (res, rej) {
        return promises.forEach(function (p) {
            return p.then(res, rej);
        });
    });
};

if (typeof window.Promise != 'function') {
    window.Promise = Promise;
}

//////////////////////////////////////////////////////////////////////////////
// For nodejs
module.exports = Promise;

/***/ }),
/* 32 */
/***/ (function(module, exports) {

;
(function (win, UpAct, $) {
    var ua = window.navigator.userAgent;
    var isIOS = /iPhone|iPad|iPod/i.test(ua);

    var query = function query(name, scope) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
            scope = scope || 'search',
            r = location[scope].substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
    };

    var addParam = function addParam(url, data) {
        if (typeof data === 'undefined') {
            return;
        }

        var hashReg = /#.*$/gi,
            hashMatch = url.match(hashReg),
            hash = '';

        if (hashMatch) {
            hash = hashMatch[0];
        }

        // 去除hash值的url
        var preUrl = url.replace(hash, '');

        var searchReg = /\?(.*?)$/gi;
        var result = searchReg.exec(preUrl);
        var query, newUrl;
        if (result) {
            query = result[1].split('#')[0];
        }

        var id = !query ? '' : '&';

        return preUrl + (query && query.length > 0 ? '' : '?') + (id + $.param(data)) + hash;
    };

    var delQuery = function delQuery(url, key) {
        var path = '',
            param = '',
            hash = '';
        if (url.indexOf('?') == -1) {
            path = url;
        } else {
            path = url.substr(0, url.indexOf('?'));
            param = url.substr(url.indexOf('?') + 1);
            if (param.indexOf('#') != -1) {
                hash = param.substr(param.indexOf('#') + 1);
                param = param.substr(0, param.indexOf('#'));
            }
        }
        var params = param.split('&');
        for (var i = params.length - 1; i >= 0; i--) {
            if (params[i].indexOf(key + '=') > -1) {
                params.splice(i, 1);
                break;
            }
        }

        return path + (params.join('&') ? '?' + params.join('&') : '') + (hash ? '#' + hash : '');
    };

    var envi = function (ua) {
        var platform = {};
        var device = {};
        var env = void 0;

        if (ua.match(/uplive/i) || query('pl', 'hash') == 'uplive') {
            platform = {
                val: 2002,
                name: 'uplive',
                isUplive: true
            };
        } else if (ua.match(/micromessenger/i)) {
            // 微信
            platform = {
                val: 1,
                name: 'wechat',
                isWeixin: true
            };
        } else if (ua.match(/qq/i) || ua.match(/and_sq_/i)) {
            // QQ
            platform = {
                val: 4001,
                name: 'qq',
                isQQ: true
            };
        } else if (ua.match(/weibo/i)) {
            // 微博
            platform = {
                val: 8001,
                name: 'weibo',
                isWeibo: true
            };
        } else if (ua.match(/[Tt]witter/i)) {
            // twitter
            platform = {
                val: 2,
                name: 'twitter',
                isTwitter: true
            };
        } else if (ua.match(/FB_IAB/i)) {
            // facebook
            platform = {
                val: 3,
                name: 'facebook',
                isFacebook: true
            };
        } else {
            platform = {
                val: 0,
                name: 'unknown',
                isOther: true
            };
        }

        if (ua.match(/android/i)) {
            device = {
                val: 1,
                name: 'android',
                isAndroid: true
            };
        } else if (ua.match(/iphone|ipad|itouch/i)) {
            device = {
                val: 2,
                name: 'ios',
                isIOS: true
            };
        } else {
            device = {
                val: 3,
                name: 'unknown',
                isOther: true
            };
        }

        var _env = query('env');

        if (!_env || _env == 'null') {
            env = 'pro';
        } else {
            env = _env;
        }

        return {
            device: device,
            platform: platform,
            env: env
        };
    }(navigator.userAgent);

    var setTitle = function setTitle(value) {
        var nodeTitle = $('title').eq(0);

        if (value && value !== '') {
            nodeTitle.html(value);
        }

        if (isIOS) {
            var $iframe = void 0;

            $iframe = $('<iframe src=""https://g.cdn.upliveapp.com/oauthgame/739266613_b5c5a72bcbb1abe5fdc109b1953f65af%20%281%29.png" style="display:none;border:0;width:0;height:0;"></iframe>');
            $iframe.on('load', function () {
                setTimeout(function () {
                    $iframe.off('load').remove();
                }, 300);
            }).appendTo('body');
        }
    };

    UpAct.device = envi.device;
    UpAct.platform = envi.platform;
    UpAct.BaseUtil = {
        query: query,
        addParam: addParam,
        delQuery: delQuery,
        envi: envi,
        setTitle: setTitle

    };
    $.getScript = function (url, options) {

        var script = document.createElement('script'),
            isFunction = $.isFunction(options),
            timer;

        // 清除定时器
        function clearTimer() {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
        }

        // success
        if (isFunction || options && options.success) {
            script.onload = function () {
                clearTimer();
                isFunction ? options() : options.success.call(options.context);
            };
        }

        if (!isFunction && options) {
            // failure
            if (options.error) {
                script.onerror = function () {
                    clearTimer();
                    options.error.call(options.context);
                };
            }
            // timeout
            if (options.timeout) {
                timer = setTimeout(function () {
                    timer = null;
                    if (options.error) {
                        options.error.call(options.context);
                    }
                }, options.timeout);
            }
        }

        script.setAttribute('data-path', url);

        script.src = url;

        return document.body.appendChild(script);
    };
    $.smartScroll = function (container, selectorScrollable) {
        // 如果没有滚动容器选择器，或者已经绑定了滚动时间，忽略
        if (!selectorScrollable || container.data('isBindScroll')) {
            return;
        }

        // 是否是搓浏览器
        // 自己在这里添加判断和筛选
        var isSBBrowser;

        var data = {
            posY: 0,
            maxscroll: 0
        };

        // 事件处理
        container.on({
            touchstart: function touchstart(event) {
                var events = event.touches[0] || event;

                // 先求得是不是滚动元素或者滚动元素的子元素
                var elTarget = $(event.target);

                if (!elTarget.length) {
                    return;
                }

                var elScroll;

                // 获取标记的滚动元素，自身或子元素皆可
                if (elTarget.is(selectorScrollable)) {
                    elScroll = elTarget;
                } else if ((elScroll = elTarget.parents(selectorScrollable)).length == 0) {
                    elScroll = null;
                }

                if (!elScroll) {
                    return;
                }

                // 当前滚动元素标记
                data.elScroll = elScroll;

                // 垂直位置标记
                data.posY = events.pageY;
                data.scrollY = elScroll.scrollTop();
                // 是否可以滚动
                data.maxscroll = elScroll[0].scrollHeight - elScroll[0].clientHeight;
            },
            touchmove: function touchmove() {
                // 如果不足于滚动，则禁止触发整个窗体元素的滚动
                if (data.maxscroll <= 0 || isSBBrowser) {
                    // 禁止滚动
                    event.preventDefault();
                }
                // 滚动元素
                var elScroll = data.elScroll;
                // 当前的滚动高度
                var scrollTop = elScroll.scrollTop();

                // 现在移动的垂直位置，用来判断是往上移动还是往下
                var events = event.touches[0] || event;
                // 移动距离
                var distanceY = events.pageY - data.posY;

                if (isSBBrowser) {
                    elScroll.scrollTop(data.scrollY - distanceY);
                    elScroll.trigger('scroll');
                    return;
                }

                // 上下边缘检测
                if (distanceY > 0 && scrollTop == 0) {
                    // 往上滑，并且到头
                    // 禁止滚动的默认行为
                    event.preventDefault();
                    return;
                }

                // 下边缘检测
                if (distanceY < 0 && scrollTop + 1 >= data.maxscroll) {
                    // 往下滑，并且到头
                    // 禁止滚动的默认行为
                    event.preventDefault();
                    return;
                }
            },
            touchend: function touchend() {
                data.maxscroll = 0;
            }
        });

        // 防止多次重复绑定
        container.data('isBindScroll', true);
    };
})(window, window['UpAct'] || (window['UpAct'] = {}), Zepto);

/***/ }),
/* 33 */
/***/ (function(module, exports) {

/**
 * @file 数字处理工具
 */
;(function (win, UpAct) {

    var NumberUtil = {
        /**
         * 补0
         * @param  {Number} num    [要处理的数字]
         * @param  {Number} digits [要处理的位数]
         * @example
         *      prefixedNum(1,1); // 01
         *      prefixedNum(1,2); // 001
         */
        prefixed: function prefixed(num, digits) {
            var zeroStr = [];
            num = typeof num == 'undefined' ? '' : num;
            for (var i = 0; i < digits; ++i) {
                zeroStr.push(0);
            }

            return zeroStr.join('').substr(0, digits - num.toString().length) + num;
        },
        /**
         * 分隔数字
         * @param  {String|Number} str       [要处理的数字]
         * @param  {String} separator [分隔符号]
         * @example
         *      getSeparatedNum('900020'); // 900,020
         */
        separate: function separate(str, separator) {
            str = (typeof str == 'undefined' ? '' : str) + '';
            separator = separator || ',';

            return str.replace(/(\d+)(\.\d+)?/g, function (num, a, b) {
                return (a.length > 3 ? a.indexOf(separator) < 0 || a.indexOf(separator) > 3 ? a.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") : a : a) + (b || '');
            });
        }
    };

    UpAct.NumberUtil = NumberUtil;
})(window, window['UpAct'] || (window['UpAct'] = {}));

/***/ }),
/* 34 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * 时间处理工具
 */
;
(function (win, UpAct) {
    var TimeUtil = {
        /**
         * 获取活动时间
         * @param startTime 活动开始时间
         * @param endTime 活动结束时间
         * @param lang 语言
         * @param separator 分隔符
         */
        getActTimeWithDate: function getActTimeWithDate(startTime, endTime, lang, separator) {
            var st = void 0,
                et = void 0;

            lang = lang.replace('-', '').toLowerCase();
            separator = typeof separator == 'undefined' ? ' ～ ' : separator;

            var sdateObj = new Date(startTime);
            var edateObj = new Date(endTime);
            var syear = sdateObj.getFullYear();
            var eyear = edateObj.getFullYear();

            if (lang == 'areg') {
                st = this.formatDate(startTime, 'dd/MM/yyyy HH:mm', 12);
                et = this.formatDate(endTime, 'dd/MM/yyyy HH:mm', 12);
                return st + separator + et;
            } else if (lang == 'vivn') {
                st = this.formatDate(startTime, 'HH:mm dd.MM.yyyy');
                et = this.formatDate(endTime, 'HH:mm dd.MM.yyyy');
                return st + separator + et;
            } else {
                st = this.formatDate(startTime, 'yyyy/MM/dd HH:mm');

                if (syear == eyear) {
                    et = this.formatDate(endTime, 'MM/dd HH:mm');
                } else {
                    et = this.formatDate(endTime, 'yyyy/MM/dd HH:mm');
                }

                return st + separator + et;
            }
        },

        /**
         * 获取日榜时间
         * @param startTime 活动开始时间
         * @param endTime 活动结束时间
         * @param lang 语言
         * @param separator 分隔符
         */
        getDailyTimeWithDate: function getDailyTimeWithDate(startTime, endTime, lang, separator) {
            var st = void 0,
                et = void 0;

            lang = lang.replace('-', '').toLowerCase();
            separator = typeof separator == 'undefined' ? ' ～ ' : separator;

            if (lang == 'areg') {
                st = this.formatDate(startTime, 'dd/MM HH:mm:ss', 12);
                et = this.formatDate(endTime, 'dd/MM HH:mm:ss', 12);
                return st + separator + et;
            } else if (lang == 'vivn') {
                st = this.formatDate(startTime, 'HH:mm:ss dd.MM.yyyy');
                et = this.formatDate(endTime, 'HH:mm:ss dd.MM.yyyy');
                return st + separator + et;
            } else {
                st = this.formatDate(startTime, 'MM/dd HH:mm:ss');
                et = this.formatDate(endTime, 'MM/dd HH:mm:ss');
                return st + separator + et;
            }
        },

        /** 
         * 格式化时间
         * @param time  时间。1. 时间戳：1407897620000；2: 字符串：2014/12/12 12:00:00
         *        new Date(1407897620000)、new Date()、new Date('2014/12/12 12:00:00')
         * @param pattern {String} 格式化模板（默认："yyyy-MM-dd HH:mm:ss"）
         * @param hourType {number} 小时制。12小时、24小时。默认24小时制
         * @return {String} 格式化后的文本 
         **/
        formatDate: function formatDate(time, pattern, hourType) {
            var dateObj = new Date(time);

            hourType = hourType || 24;

            if (!pattern) {
                pattern = "yyyy-MM-dd HH:mm:ss";
            }
            var val, result, hour, minute, second;
            var func = function func(matched) {
                return matched.length == 2 && val < 10 ? "0" + val : val;
            };

            result = pattern.replace(/y{2,4}/, dateObj.getFullYear()); // the year
            val = dateObj.getMonth() + 1; // the month
            result = result.replace(/M{1,2}/, func);
            val = dateObj.getDate(); // the date
            result = result.replace(/d{1,2}/, func);

            if (hourType == 12) {
                val = hour = dateObj.getHours(); // the hour

                var isAm = 1;

                if (val > 12) {
                    result = result.replace(/H{1,2}/, function (matched) {
                        if (matched.length == 2) {
                            if (val > 12) {
                                val = val - 12;
                                if (val < 10) {
                                    val = '0' + val;
                                }
                                isAm = 0;
                            } else if (val < 10) {
                                val = '0' + val;
                                isAm = 1;
                            }
                        }
                        return val;
                    });
                    val = minute = dateObj.getMinutes(); // the minute
                    result = result.replace(/m{1,2}/, func);
                    val = second = dateObj.getSeconds(); // the second
                    result = result.replace(/s{1,2}/, func);
                } else {
                    result = result.replace(/H{1,2}/, func);
                    val = minute = dateObj.getMinutes(); // the minute
                    result = result.replace(/m{1,2}/, func);
                    val = second = dateObj.getSeconds(); // the second
                    result = result.replace(/s{1,2}/, func);
                }

                if (isAm) {
                    if (hour == 0 && minute == 0 && second == 0) {
                        dateObj = new Date(time);
                        result = pattern.replace(/y{2,4}/, dateObj.getFullYear()); // the year
                        val = dateObj.getMonth() + 1; // the month
                        result = result.replace(/M{1,2}/, func);
                        val = dateObj.getDate(); // the date
                        result = result.replace(/d{1,2}/, func);
                        val = hour = 12;
                        result = result.replace(/H{1,2}/, func);
                        val = minute = 0; // the minute
                        result = result.replace(/m{1,2}/, func);
                        val = 0; // the second
                        result = result.replace(/s{1,2}/, func);
                        result += 'am';
                    } else {
                        result += 'am';
                    }
                } else {
                    result += 'pm';
                }
            } else {
                val = hour = dateObj.getHours(); // the hour
                result = result.replace(/H{1,2}/, func);
                val = minute = dateObj.getMinutes(); // the minute
                result = result.replace(/m{1,2}/, func);
                val = second = dateObj.getSeconds(); // the second
                result = result.replace(/s{1,2}/, func);
            }

            return result;
        },

        build: function build(time) {
            var builtTime;

            switch (typeof time === 'undefined' ? 'undefined' : _typeof(time)) {
                case 'number':
                    builtTime = new Date(parseInt(time));
                    break;
                case 'string':
                    // ios下，时间格式为2012-12-12会报错，解决方案: 2012-12-12 ==> 2012/12/12
                    builtTime = Number(time) ? arguments.callee(parseInt(time)) : new Date(time.replace(/-/g, '/'));
                    break;
                default:
                    builtTime = time instanceof Date ? time : new Date();
            }

            if (builtTime == 'Invalid Date') {
                throw new Error('[TimeFormater]: Invalid Date!');
            }

            return builtTime;
        }
    };

    UpAct.TimeUtil = TimeUtil;
})(window, window['UpAct'] || (window['UpAct'] = {}));

/***/ }),
/* 35 */
/***/ (function(module, exports) {

/**
 * 图片处理。仅支持矩形
 */
;(function (win, UpAct) {
    // 图片后缀正则
    var REG_IMG_EXT = /.(jpg|png|gif|jpeg)/i;

    // 图片url正则
    var REG_IMG_SRC = /^(?:(?:http|https):)?\/\/(.+\.((?:upcdn|cdn))\.((?:pengpengla|upliveapp|upliveapps))\.(?:com))(\/.*(?:\.(jpg|png|gif|jpeg|webp))?)$/i;

    // 占位默认图片
    var IMG_DEFAULT_SRC = 'data:image/png;base64,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';

    // 海外CDN图片尺寸的大小列表
    var IMG_SIZE_LIST = [50, 80, 100]; // [50, 80, 100, 300, 600]; 最大100，够用  

    var DEFAULT_SIZE = 50;

    var defaultCfg = {
        'selector': '[node-id=img]', //img 样式名称
        'size': '50', //cdn尺寸
        'dataSrc': 'data-src'
    };

    var imgList = void 0;

    var imgHelper = {
        /**
         * 输出转换后的图片url
         * @param {string} src 图片url
         * @param {object} param { size: 100 }
         */
        getNewUrl: function getNewUrl(url, size) {

            if (!url || typeof url != 'string') {
                return '';
            }
            var defaultSize = size || DEFAULT_SIZE;
            var newUrl = void 0;

            defaultSize = defaultSize * 2;

            if (url.match(REG_IMG_SRC)) {

                var cdnSize = url.match(REG_IMG_SRC);

                if (cdnSize[2] == 'upcdn' || cdnSize[3] == 'upliveapp' || cdnSize[3] == 'upliveapps') {
                    // 海外头像
                    var _size = this.getBestCdnSize(defaultSize); // 头像 width == height
                    var exts = url.match(REG_IMG_EXT);

                    if (exts) {
                        var ext = '_' + _size + '_' + _size + exts[0];
                        newUrl = url.replace(REG_IMG_EXT, ext);
                    } else {
                        console.log('图片后缀名错误');
                    }
                } else {
                    newUrl = url + '?imageView2/1/w/' + defaultSize + '/h/' + defaultSize;
                }
            } else {
                newUrl = url;
            }

            return newUrl;
        },

        /**
         * 获取海外头像图片最佳尺寸
         * @param  {number| string} curSize 图片尺寸
         */
        getBestCdnSize: function getBestCdnSize(curSize) {
            if (!curSize || typeof curSize != 'string' && typeof curSize != 'number') {
                //|| && 同时存在的逻辑不太懂
                console.log('未设置图片尺寸');
            }
            var sizeList = IMG_SIZE_LIST;
            var max = sizeList[sizeList.length - 1];
            var min = sizeList[0];
            var bestSize = 0;

            if (max <= curSize) {
                return max;
            }
            if (min >= curSize) {
                return min;
            }
            for (var i = sizeList.length; i >= 0; i--) {
                if (curSize >= sizeList[i]) {
                    if (sizeList[i] == curSize) {
                        bestSize = curSize;
                    } else {
                        if (i < sizeList.length - 1) {
                            // 取最近最优的尺寸
                            bestSize = sizeList[i + 1];
                        }
                    }
                    break;
                }
            }
            return bestSize;
        },

        /*
         * 主动触发懒加载，适用于动态插入图片节点的场景
         * */
        start: function start() {
            getImgs();
            loadImg();
        }
    };

    function getImgs() {
        imgList = Array.prototype.slice.call(document.querySelectorAll(defaultCfg.selector));
        //Array.prototype.slice.call 能将具有length属性的对象转成数组
    }

    function loadImg() {
        var srcAttr = defaultCfg.dataSrc;

        if (imgList.length) {
            imgList.forEach(function (el, index) {
                if (el.getAttribute('data-src-checked') != 'true') {
                    var dataSrc = el.getAttribute(srcAttr);
                    var dataSize = el.getAttribute('data-size');

                    if (dataSrc) {
                        var img = imgHelper.getNewUrl(dataSrc, dataSize);

                        el.setAttribute('data-src-checked', 'true');
                        el.setAttribute('data-loaded', '0');
                        el.setAttribute('src', img);
                        el.removeAttribute(srcAttr);
                        el.onload = el.error = function () {
                            //都当做end状态处理，需要添加动画
                            el.style.opacity = "1";
                            el.onload = el.onerror = null;
                            el.setAttribute('data-loaded', '1');
                        };
                    }
                }
            });
        }
    }

    var _init = function _init(options) {
        options = options || {};

        defaultCfg = $.extend(defaultCfg, options);

        imgHelper.start();
    };

    UpAct.img = function () {
        _init.apply(imgHelper, arguments);
        return imgHelper;
    };
    UpAct.img.defaultSrc = IMG_DEFAULT_SRC;
})(window, window['UpAct'] || (window['UpAct'] = {}));

/***/ }),
/* 36 */
/***/ (function(module, exports) {

/**
 * @file 直播等级
 */
;(function (win, UpAct) {
    var COLORS = ['rgba(146,208,0,0.7)', //color0
    'rgba(255,135,164,0.7)', //color1
    'rgba(255,78,111,0.7)', //color2
    'rgba(255,174,0,0.7)', //color3
    'rgba(255,47,66,0.7)', //color4
    'rgba(255,53,165,0.7)', //color5
    'rgba(255,0,78,0.7)', //color6
    'rgba(201,0,1,0.7)', //color7
    'rgba(181,48,255,0.7)', //color8
    'rgba(175,2,212,0.7)', //color9
    'rgba(56,136,255,0.7)', //color10
    'rgba(24,21,255,0.7)', //color11
    'rgba(164,57,255,0.7)', //color12
    'rgba(112,0,211,0.7)', //color13
    'rgba(20,197,255,0.7)', //color14
    'rgba(14,99,255,0.7)', //color15
    'rgba(165,97,255,0.7)', //color16
    'rgba(255,0,64,0.7)', //color17
    'rgba(192,0,22,0.7)', //color18
    'rgba(200,75,231,0.7)', //color19
    'rgba(148,35,255,0.7)', //color20
    'rgba(255,206,8,0.7)', //color21
    'rgba(255,126,0,0.7)', //color22
    'rgba(255,0,0,0.7)', //color23
    'rgba(140,0,204,0.7)' //color24
    ];

    var defaultCfg = {
        'selector': '[node-id=grade]', //img 样式名称
        'dataGrade': 'data-grade'
    };

    var gradeNodeList = void 0;

    var gradeHelper = {
        getGradeIndex: function getGradeIndex(grade) {
            if (grade < 1) {
                return 0;
            }

            var x = grade;

            var n = 0;

            if (x < 44) {
                //等级小于44的时候每个区间的『等级差值』是一个等差数列
                //利用等差数列求和公式和求根公式来计算当前等级所在区间对应到图片存放的地方的坐标；输出0123456.....
                n = (Math.sqrt(9 + 8 * x) - 3) / 2;
            } else {
                //等级大于等于44的时候每个区间的『等级』是一个等差数列
                //利用等差数列通项公式来计算当前等级所在区间对应到图片存放的地方的坐标；输出0123456.....
                n = (x - 34) / 10;
                //与44级之前的对接
                n += 7;
            }

            return Math.floor(n);
        },
        start: function start() {
            getGradeNodeList();
            handleGrade();
        }
    };

    function getGradeNodeList() {
        gradeNodeList = Array.prototype.slice.call(document.querySelectorAll(defaultCfg.selector));
    }

    function handleGrade() {
        var gradeAttr = defaultCfg.dataGrade;

        if (gradeNodeList.length > 0) {
            gradeNodeList.forEach(function (el, index) {
                if (el.getAttribute('data-grade-checked') != 'true') {
                    var dataGrade = el.getAttribute(gradeAttr);

                    if (typeof dataGrade !== 'undefined') {
                        var _index = gradeHelper.getGradeIndex(dataGrade);
                        var color = COLORS[_index];
                        var gradeCls = 'grade_' + _index;
                        var htmlArr = ['<i class="' + gradeCls + '"></i>', '<em style="background-color: ' + color + '">' + dataGrade + '</em>'];
                        el.innerHTML = htmlArr.join('');
                        el.setAttribute('data-grade-checked', 'true');
                        el.removeAttribute(gradeAttr);
                    }
                }
            });
        }
    }

    var _init = function _init(options) {
        options = options || {};

        defaultCfg = $.extend(defaultCfg, options);

        gradeHelper.start();
    };

    UpAct.grade = function () {
        _init.apply(gradeHelper, arguments);
        return gradeHelper;
    };
})(window, window['UpAct'] || (window['UpAct'] = {}));

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    var Base = __webpack_require__(1);

    var Route = Base.extend({

        initialize: function initialize() {
            this.bindEvent();
        },

        bindEvent: function bindEvent() {
            var self = this;
            $(window).on('hashchange', function (e) {
                self.changeHandler(e);
            });
        },

        changeHandler: function changeHandler(e) {
            var self = this;
            var oldURL = e.oldURL;
            var newURL = e.newURL;

            var oldHash = self.parseHash(oldURL);
            var newHash = self.parseHash(newURL);
            var eventname = newHash == null ? 'null' : newHash;

            self.emit('leave', {
                hash: oldHash
            });

            eventname = self.transferEvent(eventname);

            self.emit(eventname);
        },

        transferEvent: function transferEvent(eventname) {
            var self = this,
                events = self.events,
                isRegister = 0;

            for (var i in events) {
                if (i == eventname) {
                    isRegister = 1;
                }
            }

            if (!isRegister) {
                eventname = 'null';
            }

            return eventname;
        },

        parseHash: function parseHash(url) {
            var hashReg = /#(.+)$/i;
            var execResult = hashReg.exec(url);

            return execResult && execResult[1];
        },

        start: function start() {
            var cururl = location.href;
            var curhash = this.parseHash(cururl);
            var eventname = curhash == null ? 'null' : curhash;

            eventname = this.transferEvent(eventname);

            this.emit(eventname);
        }

    });

    var route = new Route();

    UpAct.route = route;

    module.exports = route;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * 文本筛选
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    var Base = __webpack_require__(1);

    var Filter = Base.extend({

        defaults: {
            container: null, // 筛选容器 
            tagClass: '.filter-tag', // 选项的className，默认为'filter-tag'
            selectedClass: 'selected', // 选中的选项className, 默认为'selected'
            disabledClass: 'disabled', // 选项禁用时的className，默认为'disabled'
            type: 'radio' // 选项类型，默认单选radio：单选'radio'，复选'checkbox'
        },

        initialize: function initialize() {
            this.Parent.apply(this, arguments);

            // 容器
            this.nodeContainer = this.get('container');

            if (!this.nodeContainer) {
                throw new Error('未找到筛选容器');
                return;
            }
            // 筛选所有选项
            this.filterTags = null;

            // 单选类型存储: text
            this._radioText = null;

            // 单选类型存储: value
            this._radioValue = null;

            // 多选类型存储: text
            this._checkboxText = [];

            // 多选类型存储: value
            this._checkboxValue = [];

            // 绑定事件
            this.bindEvent();
        },

        bindEvent: function bindEvent() {
            var self = this;
            var nodeContainer = this.nodeContainer;

            // 筛选模块选项点击事件
            nodeContainer.delegate(self.get('tagClass'), 'click', function (e) {
                e.preventDefault();

                var node = $(e.currentTarget);
                var value = node.attr('data-value');

                var isSelected = node.hasClass(self.get('selectedClass'));
                var isDisabled = node.hasClass(self.get('disabledClass'));

                var type = self.get('type');
                // 改选项禁用，不可选中
                if (isDisabled) {
                    return;
                }

                if (type == 'radio') {
                    // 单选
                    if (isSelected) {
                        return;
                    } else {
                        self._radioSelect(node, value);
                    }
                } else if (type == 'checkbox') {
                    // 多选
                    if (isSelected) {
                        self._checkboxRemove(node, value);
                        return;
                    } else {
                        self._checkboxSelect(node, value);
                    }
                }

                // 提供事件，获取选中的数据
                self.emit('select', { option: self.getValue() });
            });
        },
        /**
         * 禁用选项
         *
         * @method disabled
         * @param  {Array} data 要禁用的选项值数组
         */
        disabled: function disabled(data) {
            var self = this;
            var nodeContainer = this.nodeContainer;
            var disabledClass = self.get('disabledClass');
            var selectedClass = self.get('selectedClass');
            var filterTags = $(this.get('tagClass'), nodeContainer);

            if ($.isArray(data) && data.length > 0) {
                $.each(filterTags, function (index, node) {
                    if ($.inArray(node.attr('data-value'), data)) {
                        node.addClass(disabledClass);
                    }
                });

                return;
            }

            filterTags.addClass(disabledClass);
        },

        /**
         * 启用选项
         *
         * @method enabled
         * @param  {Array} data 要启用的选项值数组
         * @return {[type]}      [description]
         */
        enabled: function enabled(data) {
            var self = this;

            var nodeContainer = this.nodeContainer;

            var disabledClass = self.get('disabledClass');
            var selectedClass = self.get('selectedClass');
            var filterTags = $(this.get('tagClass'), nodeContainer);

            if ($.isArray(data) && data.length > 0) {
                $.each(filterTags, function (index, node) {
                    if ($.inArray(node.attr('data-value'), data)) {
                        node.removeClass(disabledClass);
                    }
                });

                return;
            }

            filterTags.removeClass(disabledClass);
        },

        _radioSelect: function _radioSelect(node, value) {
            var self = this;
            var nodeContainer = this.nodeContainer;
            var selectedClass = self.get('selectedClass');
            var filterTags = $(this.get('tagClass'), nodeContainer);

            // 清除所有选项选中状态
            filterTags.removeClass(selectedClass);

            // 添加选中样式
            node && node.addClass(selectedClass);

            // 筛选值
            self._radioValue = value;
            self._radioText = node && node.attr('data-text');
        },

        _checkboxSelect: function _checkboxSelect(node, value) {
            var self = this;

            var selectedClass = self.get('selectedClass');

            // 如果匹配值为空，将不限设为已选项
            if (!value) {
                self._checkboxText.length = 0;
                self._checkboxValue.length = 0;
                var filterTags = $(this.get('tagClass'), this.nodeContainer);;
                var selectedClass = this.get('selectedClass');
                filterTags.removeClass(selectedClass);
                return;
            }

            $.each(value.split(','), function (v) {

                if (!node) {
                    return;
                }

                node.addClass(selectedClass);

                self._checkboxText.push(node.attr('data-text'));
                self._checkboxValue.push(node.attr('data-value'));
            });
        },

        _checkboxRemove: function _checkboxRemove(node, value) {
            var self = this;

            var index = self._checkboxValue.indexOf(value);

            var selectedClass = self.get('selectedClass');

            if (value) {
                if (node) {
                    node.removeClass(selectedClass);
                }
                if (index != -1) {
                    self._checkboxText.splice(index, 1);
                    self._checkboxValue.splice(index, 1);
                }
                if (self._checkboxValue.length < 1) {
                    self._checkboxSelect();
                }
                return;
            }

            self._checkboxSelect();
        },

        getValue: function getValue() {
            var type = this.get('type');

            if (type == 'radio') {
                return {
                    value: this._radioValue,
                    text: this._radioText
                };
            } else if (type == 'checkbox') {
                return {
                    value: this._checkboxValue, // 数组，防止外面修改了Array影响它
                    text: this._checkboxText
                };
            }
        },
        /**
         * 获取已选择的选项个数
         */
        getLength: function getLength() {
            var type = this.get('type');

            if (type == 'radio') {
                return this._radioValue ? 1 : 0;
            } else if (type == 'checkbox') {
                return this._checkboxValue.length;
            }
        },

        reset: function reset() {
            var filterTags = $(this.get('tagClass'), this.nodeContainer);;
            var selectedClass = this.get('selectedClass');
            var type = this.get('type');
            filterTags.removeClass(selectedClass);

            if (type == 'radio') {
                this._radioText = null;
                this._radioValue = null;
            } else if (type == 'checkbox') {
                this._checkboxValue = [];
                this._checkboxRemove = [];
            }
        }
    });

    UpAct.Filter = Filter;

    module.exports = Filter;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * 加载模块
 */

var Base = __webpack_require__(1);

var Loading = Base.extend({
    defaults: {
        backdrop: {
            className: 'loading-wrap',
            style: {
                background: 'transparent',
                position: 'fixed',
                width: '100%',
                height: '100%',
                left: 0,
                top: 0,
                overflow: 'hidden',
                zIndex: '99999',
                display: '-webkit-box',
                'webkit-box-orient': 'horizontal',
                '-webkit-box-pack': 'center',
                '-webkit-box-align': 'center'
            }

        },
        contentWrap: {
            className: 'loading-content',
            style: {
                position: 'fixed',
                left: '50%',
                top: '50%',
                width: '3.125rem',
                height: '2.8125rem',
                color: '#fff',
                textAlign: 'center',
                fontSize: '0.34375rem',
                borderRadius: '0.1875rem',
                background: '#000',
                opacity: '0.9',
                display: '-webkit-box',
                '-webkit-box-orient': 'vertical',
                '-webkit-box-align': 'center'
            }
        },
        loadingIcon: {
            className: 'loading-icon',
            style: {
                display: 'block',
                width: '1.25rem',
                height: '1.25rem',
                margin: '0.5625rem auto 0.25rem',
                background: 'url(data:image/gif;base64,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) no-repeat center center',
                backgroundSize: '0.9375rem 0.9375rem'
            }
        },
        content: 'loading'
    },
    initialize: function initialize() {},

    buildDOM: function buildDOM() {
        var backdrop = this.get('backdrop');
        var contentWrap = this.get('contentWrap');
        var loadingIcon = this.get('loadingIcon');
        var content = this.get('content');
        var nodeBackdrop, nodeContentWrap, nodeLoadingIcon, nodeLoadingText;

        nodeBackdrop = this.nodeBackdrop = $('<div class="' + backdrop.className + '" style=></div>');
        nodeBackdrop.css(backdrop.style);

        nodeContentWrap = $('<div class="' + contentWrap.className + '"></div>');
        nodeContentWrap.css(contentWrap.style);

        nodeLoadingIcon = $('<i class="' + loadingIcon.className + '"></i>');
        nodeLoadingIcon.css(loadingIcon.style);

        nodeLoadingText = this.nodeLoadingText = $('<div>' + (UpAct.lang.template('正在加载') || content) + '</div>');

        nodeContentWrap.append(nodeLoadingIcon);
        nodeContentWrap.append(nodeLoadingText);
        nodeBackdrop.append(nodeContentWrap);

        $(document.body).append(nodeBackdrop);

        var bodyRect = document.body.getBoundingClientRect();
        var spanRect = nodeContentWrap[0].getBoundingClientRect();

        nodeContentWrap.css({
            marginLeft: -spanRect.width / 2 + "px",
            marginTop: -spanRect.height / 2 + "px"
        });
    },
    show: function show() {
        if (this.nodeBackdrop) {
            return;
        }

        this.buildDOM();
    },
    hide: function hide() {
        if (this.nodeBackdrop) {
            this.nodeBackdrop.remove();
            this.nodeBackdrop = null;
        }
    }
});

var loading = new Loading();

UpAct.loading = loading;

module.exports = loading;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {

    return function (win, UpAct) {
        var doc = win.document,
            body = doc.body,
            E_float,
            E_floatMsg,
            E_floatContent,
            E_floatOk,
            E_floatCancel,
            initDom = false,
            flashTimeoutId,
            showTimeoutId,
            hideTimeoutId,
            E_mask;

        E_mask = doc.createElement('div');
        E_mask.className = 'c-float-mask hide';

        E_float = doc.createElement('div');
        E_float.className = 'c-float-popWrap msgMode hide';
        E_float.innerHTML = ['<style type="text/css">', '.c-float-modePop{text-align:center}.c-float-modePop .warnMsg{color:#fff}.c-float-modePop button{padding:0.1875rem 0.28125rem 0.1875rem 0.28125rem;color:#157afb;background:-webkit-gradient(linear,left top,left bottom,color-stop(0,#404040),color-stop(100%,#2e2e2e));border:none}.c-float-shade{width:100%;display:block;position:absolute;z-index:99;background-color:#000;opacity:.5;top:0;left:0}.c-float-mask{position:fixed;top:0;left:0;bottom:0;right:0;height:100%;width:100%;z-index:9998;background:rgba(0,0,0,.7);opacity:0;-webkit-transition:opacity .3s linear 0s}.c-float-shade.hide{display:none}.c-float-mask.hide{display:none}.c-float-popWrap{width:90%; border-radius:0.25rem;-webkit-border-radius:0.25rem;z-index:9999;position:fixed;overflow:hidden;left:50%;top:50%; margin-left: -45%; -webkit-transition:opacity .3s linear 0s}.c-float-popWrap .c-float-modePop{background-color:rgba(0,0,0,.7);-webkit-border-radius:0.25rem;border-radius:0.25rem;overflow:hidden;padding:0.3125rem;}.c-float-popWrap .c-float-modePop .warnMsg{padding:0;font-size:0.46875rem;line-height:0.5625rem;color:#fff;font-weight:400}.c-float-popWrap .c-float-modePop .content{line-height:1.5}.c-float-popWrap.hide{display:none;-webkit-box-shadow:none}.c-float-popWrap.show{display:block}.c-float-popWrap.msgMode .c-float-modePop .content,.c-float-popWrap.msgMode .c-float-modePop .doBtn{display:none}.c-float-popWrap.alertMode .c-float-modePop .content{display:none}.c-float-popWrap.alertMode .c-float-modePop .doBtn .cancel{display:none}.c-float-popWrap.alertMode,.c-float-popWrap.confirmMode{width:90%;}.c-float-popWrap.alertMode .c-float-modePop,.c-float-popWrap.confirmMode .c-float-modePop{background:#fff;padding:0;color:#202325}.c-float-popWrap.alertMode .c-float-modePop .content,.c-float-popWrap.confirmMode .c-float-modePop .content{padding:0.3125rem;border-bottom:0.03125rem solid #d6d9dc}.c-float-popWrap.alertMode .c-float-modePop .warnMsg,.c-float-popWrap.confirmMode .c-float-modePop .warnMsg{padding:0.3125rem;display:-webkit-box;-webkit-box-align:center;-webkit-box-pack:center;text-align:center;font-weight:700}.c-float-popWrap.alertMode .c-float-modePop .doBtn,.c-float-popWrap.alertMode .c-float-modePop .warnMsg,.c-float-popWrap.confirmMode .c-float-modePop .doBtn,.c-float-popWrap.confirmMode .c-float-modePop .warnMsg{border-bottom:0.03125rem solid #d6d9dc;color:#202325}.c-float-popWrap.alertMode .c-float-modePop .doBtn,.c-float-popWrap.confirmMode .c-float-modePop .doBtn{border-bottom:none;display:-webkit-box;-webkit-box-align:center}.c-float-popWrap.alertMode .c-float-modePop .content,.c-float-popWrap.confirmMode .c-float-modePop .content{display:block;color:#202325;padding:0.3125rem;line-height:0.75rem;font-size:0.46875rem;text-align:left;font-weight:700}.c-float-modePop button{-webkit-box-flex:1;color:#157afb;background:#fff;height:1.25rem;font-size:0.5625rem;display:block}.c-float-modePop button.cancel{border-right:0.03125rem solid #b2b2b2}.c-float-modePop button.ok{font-weight:700}', '</style>', '<div class="c-float-modePop">', '<div class="warnMsg"></div>', '<div class="content"></div>', '<div class="doBtn">', '<button class="cancel">取消</button>', '<button class="ok">确定</button>', '</div>', '</div>'].join('');

        E_floatMsg = E_float.querySelector('.warnMsg');
        E_floatContent = E_float.querySelector('.content');
        E_floatOk = E_float.querySelector('.doBtn .ok');
        E_floatCancel = E_float.querySelector('.doBtn .cancel');

        E_floatMsg.addEventListener('click', function () {
            // alert(E_float.className);
        }, false);

        function _extend(a, b) {
            for (var k in b) {
                a[k] = b[k];
            }
            return a;
        }

        function successHandler(e) {
            this.callback && this.callback(e, true);
        }

        function failureHandler(e) {
            this.callback && this.callback(e, false);
        }

        function ModePop(options) {
            this._options = _extend({
                mode: 'msg',
                text: '网页提示',
                useTap: false
            }, options || {});

            this._init();
        }

        _extend(ModePop.prototype, {
            _init: function _init() {
                var that = this,
                    opt = that._options,
                    mode = opt.mode,
                    text = opt.text,
                    okText = opt.okText,
                    cancelText = opt.cancelText,
                    content = opt.content,
                    callback = opt.callback,
                    background = opt.background,
                    clickEvent = opt.useTap ? 'touchend' : 'click';

                // set mode
                var classTxt = E_float.className;
                classTxt = classTxt.replace(/(msg|alert|confirm)Mode/i, mode + 'Mode');
                E_float.className = classTxt;

                // set background
                background && (E_float.style.background = background);

                // set text & content
                if (text) {
                    E_floatMsg.innerHTML = text;
                    E_floatMsg.style.display = 'block';
                } else {
                    E_floatMsg.style.display = 'none';
                }

                if (content) {
                    E_floatContent.innerHTML = content;
                    E_floatContent.style.display = 'block';
                } else {
                    E_floatContent.style.display = 'none';
                }

                E_floatOk.innerHTML = okText || '确定';
                E_floatCancel.innerHTML = cancelText || '取消';

                if (mode == 'alert' || mode == 'confirm') {
                    this.hasMask = true;
                } else {
                    this.hasMask = false;
                }

                // click event
                E_floatOk.removeEventListener('touchend', successHandler);
                E_floatOk.removeEventListener('click', successHandler);
                E_floatCancel.removeEventListener('touchend', successHandler);
                E_floatCancel.removeEventListener('click', successHandler);
                E_floatOk.addEventListener(clickEvent, successHandler, false);
                E_floatCancel.addEventListener(clickEvent, failureHandler, false);
                E_floatOk.callback = E_floatCancel.callback = function () {
                    callback.apply(that, arguments);
                };

                if (!initDom) {
                    initDom = true;
                    doc.body.appendChild(E_mask);
                    doc.body.appendChild(E_float);
                    win.addEventListener('resize', function () {
                        setTimeout(function () {
                            that._pos();
                        }, 500);
                    }, false);
                }
            },

            _pos: function _pos() {
                var rect = E_float.getBoundingClientRect(),
                    eW = rect.width,
                    eH = rect.height;

                E_float.style.marginLeft = -eW / 2 + 'px';
                E_float.style.marginTop = -eH / 2 + 'px';
            },

            isShow: function isShow() {
                return E_float.className.indexOf('show') > -1;
            },

            isHide: function isHide() {
                return E_float.className.indexOf('hide') > -1;
            },

            _cbShow: function _cbShow(pos) {
                var that = this,
                    opt = that._options,
                    onShow = opt.onShow;

                E_float.style.opacity = '1';
                that.hasMask && (E_mask.style.opacity = '1');
                that.hasMask && (E_mask.className = E_mask.className.replace(/hide/g, '').trim());

                if (!that.isShow()) {
                    E_float.className += ' show';
                    that.hasMask && (E_mask.className += ' show');
                }

                pos && that._pos();

                onShow && onShow.call(that);
            },

            show: function show() {
                var that = this;

                if (flashTimeoutId) {
                    clearTimeout(flashTimeoutId);
                    flashTimeoutId = null;
                    this._cbHide();
                }

                if (showTimeoutId) {
                    clearTimeout(showTimeoutId);
                    showTimeoutId = null;
                }

                if (hideTimeoutId) {
                    clearTimeout(hideTimeoutId);
                    hideTimeoutId = null;
                }

                if (!that.isShow()) {
                    E_float.className = E_float.className.replace(/hide/g, '').trim();
                    that.hasMask && (E_mask.className = E_mask.className.replace(/hide/g, '').trim());

                    that._pos();

                    setTimeout(function () {
                        E_float.style.opacity = '1';
                        that.hasMask && (E_mask.style.opacity = '1');
                    }, 1);

                    showTimeoutId = setTimeout(function () {
                        that._cbShow();
                    }, 300);
                } else {
                    that._cbShow(true);
                }
            },

            _cbHide: function _cbHide() {
                var that = this,
                    opt = that._options,
                    onHide = opt.onHide;

                E_float.style.opacity = '0';
                E_mask.style.opacity = '0';

                if (!that.isHide()) {
                    E_float.className = E_float.className.replace(/hide|show/g, '').trim();
                    E_float.className += ' hide';
                    E_mask.className = E_mask.className.replace(/hide|show/g, '').trim();
                    E_mask.className += ' hide';
                }
                onHide && onHide.call(that);
            },
            // ruoli 添加timeout参数，防止点击弹出框，立即再弹出一个框，出现闪动
            hide: function hide(timeout) {
                var that = this;

                if (showTimeoutId) {
                    clearTimeout(showTimeoutId);
                    showTimeoutId = null;
                }

                if (hideTimeoutId) {
                    clearTimeout(hideTimeoutId);
                    hideTimeoutId = null;
                }

                if (!that.isHide()) {
                    E_float.className = E_float.className.replace(/show/g, '').trim();
                    E_mask.className = E_mask.className.replace(/show/g, '').trim();

                    setTimeout(function () {
                        E_float.style.opacity = '0';
                        E_mask.style.opacity = '0';
                    }, 1);

                    hideTimeoutId = setTimeout(function () {
                        that._cbHide();
                    }, timeout || 300);
                } else {
                    that._cbHide();
                }
            },

            flash: function flash(timeout) {
                var that = this,
                    opt = that._options;

                that.show();

                //opt.onShow = function() {
                flashTimeoutId = setTimeout(function () {
                    if (flashTimeoutId) {
                        that.hide();
                    }
                }, timeout);
                //};
            }
        });

        var notification = new function () {

            this.simple = function (text, bg, timeout) {
                if (arguments.length == 2) {
                    if (typeof arguments[1] == 'number') {
                        timeout = arguments[1];
                        bg = undefined;
                    }
                }

                var pop = new ModePop({
                    mode: 'msg',
                    text: text,
                    background: bg
                });

                pop.flash(timeout || 2000);
                return pop;
            };

            this.msg = function (text, options) {
                return new ModePop(_extend({
                    mode: 'msg',
                    text: text
                }, options || {}));
            };

            this.alert = function (text, content, callback, options) {

                if (typeof content === 'function') {
                    options = callback;
                    callback = content;
                    content = null;
                }

                return new ModePop(_extend({
                    mode: 'alert',
                    text: text,
                    content: content,
                    callback: callback
                }, options || {}));
            };

            this.confirm = function (text, content, callback, options) {
                return new ModePop(_extend({
                    mode: 'confirm',
                    text: text,
                    content: content,
                    callback: callback
                }, options || {}));
            };

            this.pop = function (options) {
                return new ModePop(options);
            };
        }();

        UpAct.notification = notification;

        return notification;
    }(window, window['UpAct'] || (window['UpAct'] = {}));
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * 倒计时
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {
    var Base = __webpack_require__(1);

    var Timer = Base.extend({
        defaults: {
            // 剩余时间,单位s
            remainTime: 0,
            // 是否需要补齐两位,如8s -> 08(s)
            isDoubleBit: true,
            // 倒计时容器
            wrap: '#J-Countdown',
            // 倒计时容器
            selector: {
                day: '[node-id=day]',
                hour: '[node-id=hour]',
                minute: '[node-id=minute]',
                second: '[node-id=second]'
            }
        },

        initialize: function initialize() {
            var self = this;
            self.Parent.apply(self, arguments);
        },
        // 开始倒计时
        start: function start(time) {
            clearTimeout(this.countDown);

            if (time <= 0) {
                return;
            }
            this.set('remainTime', time);
            this.startCountDown();
        },

        /**
         * 分割剩余时间，天、时、分、秒
         * @param time {number} 时间,单位s
         * @return result {object}
         *      @key day {string|number} 天
         *      @key hour {string|number} 时
         *      @key minute {string|number} 分
         *      @key second {string|number} 秒
         */
        splitTime: function splitTime(time) {

            var self = this,
                day = Math.floor(time / 86400),
                hour = Math.floor(time % 86400 / 3600),
                minute = Math.floor(time % 86400 % 3600 / 60),
                second = Math.floor(time % 86400 % 3600 % 60);

            return {
                day: day >= 0 ? day : 0,
                hour: hour >= 0 ? hour : 0,
                minute: minute >= 0 ? minute : 0,
                second: second >= 0 ? second : 0
            };
        },

        /**
         * 合并剩余时间到秒
         * @param time {object} 时间
         *      @key day {string|number} 天
         *      @key hour {string|number} 时
         *      @key minute {string|number} 分
         *      @key second {string|number} 秒
         * @return result {number} 
         
         */
        combineTime: function combineTime(time) {
            return time.day * 86400 + time.hour * 3600 + time.minute * 60 + time.second;
        },

        /**
         * 格式化时间(补齐两位)
         * @param time {object} 未补齐两位的时间对象
         *      @key day {string|number} 天
         *      @key hour {string|number} 时
         *      @key minute {string|number} 分
         *      @key second {string|number} 秒
         * @return time
         */
        formatTime: function formatTime(time) {
            var self = this;
            for (var i in time) {
                time[i] = self.addBit(time[i]);
            }
            return time;
        },

        /**
         * 渲染剩余时间到dom
         * @param result {object} 时间对象
         *      @key day {string|number} 天
         *      @key hour {string|number} 时
         *      @key minute {string|number} 分
         *      @key second {string|number} 秒
         * @return void
         */
        render: function render(result) {
            var self = this;
            var nodeWrap = $(this.get('wrap'));
            var selector = this.get('selector');

            if (nodeWrap.length > 0) {
                var dayWrap = $(selector.day, nodeWrap);
                var hourWrap = $(selector.hour, nodeWrap);
                var minuteWrap = $(selector.minute, nodeWrap);
                var secondWrap = $(selector.second, nodeWrap);

                if (dayWrap.length > 0) {
                    dayWrap.html(result.day);
                }

                if (hourWrap.length > 0) {
                    hourWrap.html(result.hour);
                }

                if (minuteWrap.length > 0) {
                    minuteWrap.html(result.minute);
                }

                if (secondWrap.length > 0) {
                    secondWrap.html(result.second);
                }
            }
        },

        /**
         * 增加位数
         * @param num {number} 数字
         * @return result {string}
         */
        addBit: function addBit(num) {
            return num < 10 ? '0' + num : num;
        },

        /**
         * 开始倒计时
         * @param void
         * @param {Boolean} flag 内部参数，用来判断是否正在跳动
         * @return void
         */
        startCountDown: function startCountDown(flag) {
            var self = this,
                localTimeStamp = new Date().getTime(),
                isDoubleBit = self.get('isDoubleBit'),
                localTimeGap,
                now,
                realRemainTime,
                splitTime,
                renderData,
                isEnd;

            self.countDown && clearTimeout(self.countDown);
            self.countDown = setTimeout(function () {
                localTimeGap = new Date().getTime() - localTimeStamp;
                realRemainTime = self.get('remainTime') - localTimeGap / 1000;

                // 设置真正的剩余时间
                self.set('remainTime', realRemainTime);

                splitTime = self.splitTime(realRemainTime);

                renderData = isDoubleBit ? self.formatTime(splitTime) : splitTime;

                self.render(renderData);

                self.emit('tick', {
                    remainTime: realRemainTime,
                    serverTime: new Date().getTime() / 1000
                });

                isEnd = self.isEnd(splitTime);

                self.set('isEnd', isEnd);

                if (isEnd) {
                    self.emit('end');
                    return;
                }

                // 重新呼叫此方法启动演示器
                self.startCountDown(true);
            }, flag ? 1000 : 0);
        },

        /**
         * 判断当前倒计时是否结束
         * @param realTime {object} 参考render参数
         * @return boolean
         */
        isEnd: function isEnd(realTime) {
            return realTime.second <= 0 && realTime.minute == 0 && realTime.hour == 0 && realTime.day == 0;
        },

        destroy: function destroy() {
            clearTimeout(this.countDown);
        }
    });

    UpAct.countdown = new Timer();
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @fileoverview 简单的Tab切换管理
 * @author 陈立英
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {
    var Base = __webpack_require__(1);
    var IScroll = __webpack_require__(43);
    var SingleTabView = Base.extend({
        defaults: {
            wrap: '#J-Tabs',
            index: -1,
            tabs: '[node-id="tab"]',
            panels: '[node-id="panel"]',
            scrollWrap: '[node-id="scrollWrap"]',
            scroll: '[node-id="scroll"]',
            prev: '[node-id="prev"]',
            next: '[node-id="next"]',
            selectedIndex: 0,
            selectedClass: 'selected',
            event: 'click',
            scrollable: false,
            direction: 'left' // 显示方向 left： right
        },

        initialize: function initialize() {
            var self = this;
            self.Parent.apply(self, arguments);
        },

        render: function render() {
            this.buildDOM();
            this.bindEvent();
            this.isInit = true;
            this.syncUI();
        },
        buildDOM: function buildDOM() {
            this.tabs && this.tabs.off();
            this.nodeWrap = $(this.get("wrap")) || $('body');
            this.nodeScrollWrap = $(this.get("scrollWrap"), this.nodeWrap);
            this.tabs = $(this.get("tabs"), this.nodeWrap);
            this.panels = $(this.get("panels"), this.nodeWrap);
            this.nodePrev = $(this.get("prev"), this.nodeWrap);
            this.nodeNext = $(this.get("next"), this.nodeWrap);
            this.tabLength = this.tabs.length;

            this.event = this.get('event');
            this.selectedClass = this.get('selectedClass');
            this.direction = this.get('direction');

            if (this.get('scrollable')) {
                this.itemWH = Math.ceil(this.nodeWrap.find('li').css('width').replace('px', ''));

                this.syncUI(null, false);
                //this.tabWrapWH = this.itemWH * this.tabLength;
                this.tabWrapWH = this.getTabWidth();
                this.maxScrollWidth = this.tabWrapWH - this.nodeScrollWrap.width();
                this.nodeNavScroll = $(this.get('scroll'), this.nodeWrap);

                this.nodeNavScroll.css({
                    width: this.tabWrapWH
                });

                if (this.direction == 'right') {
                    this.startX = -(this.tabWrapWH - $('body').width());

                    this.iscroll = new IScroll(this.nodeScrollWrap[0], {
                        eventPassthrough: true,
                        scrollX: true,
                        scrollY: false,
                        preventDefault: false,
                        startX: this.startX
                    });
                } else {
                    this.iscroll = new IScroll(this.nodeScrollWrap[0], {
                        eventPassthrough: true,
                        scrollX: true,
                        scrollY: false,
                        preventDefault: false
                    });
                }

                this.offset = 0;
            }
        },

        getTabWidth: function getTabWidth() {
            var width = 0;
            this.nodeScrollWrap.find('li').each(function (index, item) {
                width += Math.ceil($(item).css('width').replace('px', ''));
            });
            return width;
        },


        // 默认选中的Tab展示
        syncUI: function syncUI(index) {
            var emit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            var selected = this.get("selectedIndex");
            if (typeof index == "number") {
                this.select(index, emit);
            } else if (typeof selected == "number") {
                this.select(selected, emit);
            }
        },

        bindEvent: function bindEvent() {
            var self = this;

            this.tabs.on(this.event, function (e) {
                self._onTabClick(e);
            });

            this.on('select', function (e) {
                self.set('index', e.index);
            });

            if (this.nodePrev) {
                this.nodePrev.on('click', function (e) {
                    self._handlePrev();
                });
            }

            if (this.nodeNext) {
                this.nodeNext.on('click', function (e) {
                    self._handleNext();
                });
            }
        },

        _handlePrev: function _handlePrev() {
            var index = this.get('index');
            var nodePrev = this.nodePrev;

            if (index == 0) {
                return;
            }
            this.select(index - 1);
        },

        _handleNext: function _handleNext() {
            var index = this.get('index');

            if (index == this.tabLength - 1) {
                return;
            }
            this.select(index + 1);
        },

        _onTabClick: function _onTabClick(e) {
            var index = this.tabs.indexOf(e.currentTarget);

            if (index !== this.get('index')) {
                this.select(index);
            }
        },

        select: function select(index) {
            var emit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            var val = index,
                prev = this.get("index");
            var selectedClass = this.selectedClass;
            var nodePrev = this.nodePrev;
            var nodeNext = this.nodeNext;

            var tab = val > -1 ? this.tabs.eq(val) : null,
                prevTab = prev > -1 ? this.tabs.eq(prev) : null;

            var panel = val > -1 ? this.panels.eq(val) : null,
                prevPanel = prev > -1 ? this.panels.eq(prev) : null;

            prevTab && prevTab.removeClass(selectedClass);
            tab && tab.addClass(selectedClass);
            prevPanel && prevPanel.css({ display: 'none' });
            panel && panel.css({ display: 'block' });

            if (index == 0) {
                nodePrev.addClass('disabled');
            } else if (index == this.tabLength - 1) {
                nodeNext.addClass('disabled');
            } else {
                nodeNext.removeClass('disabled');
                nodePrev.removeClass('disabled');
            }
            if (this.get('scrollable')) {
                this.scrollToActiveTab(tab, val);
            }

            if (emit) {
                this.emit("select", {
                    tab: tab,
                    prevTab: prevTab,
                    panel: panel,
                    prevPanel: prevPanel,
                    index: val,
                    prevIndex: prev
                });
            }
        },

        setOffset: function setOffset(target) {
            var _this = this;

            if (this.isInit) {
                this.isInit = false;
                this.iscroll.scrollTo(target, 0);
            } else {
                setTimeout(function () {
                    _this.iscroll.scrollTo(target, 0, 500);
                }, 10);
            }

            this.offset = target;
        },

        scrollToActiveTab: function scrollToActiveTab(activeTab, index) {
            var activeTabWH = this.itemWH;
            var direction = this.get('direction');
            var offset = void 0;

            if (direction == 'right') {
                offset = Math.min(0, -this.tabWrapWH + activeTabWH * (2 + index));
                offset = Math.max(-this.maxScrollWidth, offset);
            } else {
                if (index + 1 == this.tabLength) {
                    offset = Math.min(0, -(activeTabWH * (index - 1)));
                } else {
                    offset = Math.min(0, -(activeTabWH * index));
                }
                offset = Math.max(-this.maxScrollWidth, offset);
            }

            this.setOffset(offset);
        }
    });

    UpAct.TabView = SingleTabView;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 43 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! iScroll v5.1.2 ~ (c) 2008-2014 Matteo Spinelli ~ http://cubiq.org/license */
(function (window, document, Math) {
    var rAF = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
        window.setTimeout(callback, 1000 / 60);
    };

    var utils = function () {
        var me = {};

        var _elementStyle = document.createElement('div').style;
        var _vendor = function () {
            var vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
                transform,
                i = 0,
                l = vendors.length;

            for (; i < l; i++) {
                transform = vendors[i] + 'ransform';
                if (transform in _elementStyle) return vendors[i].substr(0, vendors[i].length - 1);
            }

            return false;
        }();

        function _prefixStyle(style) {
            if (_vendor === false) return false;
            if (_vendor === '') return style;
            return _vendor + style.charAt(0).toUpperCase() + style.substr(1);
        }

        me.getTime = Date.now || function getTime() {
            return new Date().getTime();
        };

        me.extend = function (target, obj) {
            for (var i in obj) {
                target[i] = obj[i];
            }
        };

        me.addEvent = function (el, type, fn, capture) {
            el.addEventListener(type, fn, !!capture);
        };

        me.removeEvent = function (el, type, fn, capture) {
            el.removeEventListener(type, fn, !!capture);
        };

        me.prefixPointerEvent = function (pointerEvent) {
            return window.MSPointerEvent ? 'MSPointer' + pointerEvent.charAt(9).toUpperCase() + pointerEvent.substr(10) : pointerEvent;
        };

        me.momentum = function (current, start, time, lowerMargin, wrapperSize, deceleration) {
            var distance = current - start,
                speed = Math.abs(distance) / time,
                destination,
                duration;

            deceleration = deceleration === undefined ? 0.0006 : deceleration;

            destination = current + speed * speed / (2 * deceleration) * (distance < 0 ? -1 : 1);
            duration = speed / deceleration;

            if (destination < lowerMargin) {
                destination = wrapperSize ? lowerMargin - wrapperSize / 2.5 * (speed / 8) : lowerMargin;
                distance = Math.abs(destination - current);
                duration = distance / speed;
            } else if (destination > 0) {
                destination = wrapperSize ? wrapperSize / 2.5 * (speed / 8) : 0;
                distance = Math.abs(current) + destination;
                duration = distance / speed;
            }

            return {
                destination: Math.round(destination),
                duration: duration
            };
        };

        var _transform = _prefixStyle('transform');

        me.extend(me, {
            hasTransform: _transform !== false,
            hasPerspective: _prefixStyle('perspective') in _elementStyle,
            hasTouch: 'ontouchstart' in window,
            hasPointer: window.PointerEvent || window.MSPointerEvent, // IE10 is prefixed
            hasTransition: _prefixStyle('transition') in _elementStyle
        });

        // This should find all Android browsers lower than build 535.19 (both stock browser and webview)
        me.isBadAndroid = /Android /.test(window.navigator.appVersion) && !/Chrome\/\d/.test(window.navigator.appVersion);

        me.extend(me.style = {}, {
            transform: _transform,
            transitionTimingFunction: _prefixStyle('transitionTimingFunction'),
            transitionDuration: _prefixStyle('transitionDuration'),
            transitionDelay: _prefixStyle('transitionDelay'),
            transformOrigin: _prefixStyle('transformOrigin')
        });

        me.hasClass = function (e, c) {
            var re = new RegExp("(^|\\s)" + c + "(\\s|$)");
            return re.test(e.className);
        };

        me.addClass = function (e, c) {
            if (me.hasClass(e, c)) {
                return;
            }

            var newclass = e.className.split(' ');
            newclass.push(c);
            e.className = newclass.join(' ');
        };

        me.removeClass = function (e, c) {
            if (!me.hasClass(e, c)) {
                return;
            }

            var re = new RegExp("(^|\\s)" + c + "(\\s|$)", 'g');
            e.className = e.className.replace(re, ' ');
        };

        me.offset = function (el) {
            var left = -el.offsetLeft,
                top = -el.offsetTop;

            // jshint -W084
            while (el = el.offsetParent) {
                left -= el.offsetLeft;
                top -= el.offsetTop;
            }
            // jshint +W084

            return {
                left: left,
                top: top
            };
        };

        me.preventDefaultException = function (el, exceptions) {
            for (var i in exceptions) {
                if (exceptions[i].test(el[i])) {
                    return true;
                }
            }

            return false;
        };

        me.extend(me.eventType = {}, {
            touchstart: 1,
            touchmove: 1,
            touchend: 1,

            mousedown: 2,
            mousemove: 2,
            mouseup: 2,

            pointerdown: 3,
            pointermove: 3,
            pointerup: 3,

            MSPointerDown: 3,
            MSPointerMove: 3,
            MSPointerUp: 3
        });

        me.extend(me.ease = {}, {
            quadratic: {
                style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                fn: function fn(k) {
                    return k * (2 - k);
                }
            },
            circular: {
                style: 'cubic-bezier(0.1, 0.57, 0.1, 1)', // Not properly "circular" but this looks better, it should be (0.075, 0.82, 0.165, 1)
                fn: function fn(k) {
                    return Math.sqrt(1 - --k * k);
                }
            },
            back: {
                style: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                fn: function fn(k) {
                    var b = 4;
                    return (k = k - 1) * k * ((b + 1) * k + b) + 1;
                }
            },
            bounce: {
                style: '',
                fn: function fn(k) {
                    if ((k /= 1) < 1 / 2.75) {
                        return 7.5625 * k * k;
                    } else if (k < 2 / 2.75) {
                        return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
                    } else if (k < 2.5 / 2.75) {
                        return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
                    } else {
                        return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
                    }
                }
            },
            elastic: {
                style: '',
                fn: function fn(k) {
                    var f = 0.22,
                        e = 0.4;

                    if (k === 0) {
                        return 0;
                    }
                    if (k == 1) {
                        return 1;
                    }

                    return e * Math.pow(2, -10 * k) * Math.sin((k - f / 4) * (2 * Math.PI) / f) + 1;
                }
            }
        });

        me.tap = function (e, eventName) {
            var ev = document.createEvent('Event');
            ev.initEvent(eventName, true, true);
            ev.pageX = e.pageX;
            ev.pageY = e.pageY;
            e.target.dispatchEvent(ev);
        };

        me.click = function (e) {
            var target = e.target,
                ev;

            if (!/(SELECT|INPUT|TEXTAREA)/i.test(target.tagName)) {
                ev = document.createEvent('MouseEvents');
                ev.initMouseEvent('click', true, true, e.view, 1, target.screenX, target.screenY, target.clientX, target.clientY, e.ctrlKey, e.altKey, e.shiftKey, e.metaKey, 0, null);

                ev._constructed = true;
                target.dispatchEvent(ev);
            }
        };

        return me;
    }();

    function IScroll(el, options) {
        this.wrapper = typeof el == 'string' ? document.querySelector(el) : el;
        this.scroller = this.wrapper.children[0];
        this.scrollerStyle = this.scroller.style; // cache style for better performance

        this.options = {

            resizeScrollbars: true,

            mouseWheelSpeed: 20,

            snapThreshold: 0.334,

            // INSERT POINT: OPTIONS 

            startX: 0,
            startY: 0,
            scrollY: true,
            directionLockThreshold: 5,
            momentum: true,

            bounce: true,
            bounceTime: 600,
            bounceEasing: '',

            preventDefault: true,
            preventDefaultException: { tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT)$/ },

            HWCompositing: true,
            useTransition: true,
            useTransform: true
        };

        for (var i in options) {
            this.options[i] = options[i];
        }

        // Normalize options
        this.translateZ = this.options.HWCompositing && utils.hasPerspective ? ' translateZ(0)' : '';

        this.options.useTransition = utils.hasTransition && this.options.useTransition;
        this.options.useTransform = utils.hasTransform && this.options.useTransform;

        this.options.eventPassthrough = this.options.eventPassthrough === true ? 'vertical' : this.options.eventPassthrough;
        this.options.preventDefault = !this.options.eventPassthrough && this.options.preventDefault;

        // If you want eventPassthrough I have to lock one of the axes
        this.options.scrollY = this.options.eventPassthrough == 'vertical' ? false : this.options.scrollY;
        this.options.scrollX = this.options.eventPassthrough == 'horizontal' ? false : this.options.scrollX;

        // With eventPassthrough we also need lockDirection mechanism
        this.options.freeScroll = this.options.freeScroll && !this.options.eventPassthrough;
        this.options.directionLockThreshold = this.options.eventPassthrough ? 0 : this.options.directionLockThreshold;

        this.options.bounceEasing = typeof this.options.bounceEasing == 'string' ? utils.ease[this.options.bounceEasing] || utils.ease.circular : this.options.bounceEasing;

        this.options.resizePolling = this.options.resizePolling === undefined ? 60 : this.options.resizePolling;

        if (this.options.tap === true) {
            this.options.tap = 'tap';
        }

        if (this.options.shrinkScrollbars == 'scale') {
            this.options.useTransition = false;
        }

        this.options.invertWheelDirection = this.options.invertWheelDirection ? -1 : 1;

        // INSERT POINT: NORMALIZATION

        // Some defaults    
        this.x = 0;
        this.y = 0;
        this.directionX = 0;
        this.directionY = 0;
        this._events = {};

        // INSERT POINT: DEFAULTS

        this._init();
        this.refresh();
        console.log(this.options.startX);
        this.scrollTo(this.options.startX, this.options.startY);
        this.enable();
    }

    IScroll.prototype = {
        version: '5.1.2',

        _init: function _init() {
            this._initEvents();

            if (this.options.scrollbars || this.options.indicators) {
                this._initIndicators();
            }

            if (this.options.mouseWheel) {
                this._initWheel();
            }

            if (this.options.snap) {
                this._initSnap();
            }

            if (this.options.keyBindings) {
                this._initKeys();
            }

            // INSERT POINT: _init
        },

        destroy: function destroy() {
            this._initEvents(true);

            this._execEvent('destroy');
        },

        _transitionEnd: function _transitionEnd(e) {
            if (e.target != this.scroller || !this.isInTransition) {
                return;
            }

            this._transitionTime();
            if (!this.resetPosition(this.options.bounceTime)) {
                this.isInTransition = false;
                this._execEvent('scrollEnd');
            }
        },

        _start: function _start(e) {
            // React to left mouse button only
            if (utils.eventType[e.type] != 1) {
                if (e.button !== 0) {
                    return;
                }
            }

            if (!this.enabled || this.initiated && utils.eventType[e.type] !== this.initiated) {
                return;
            }

            if (this.options.preventDefault && !utils.isBadAndroid && !utils.preventDefaultException(e.target, this.options.preventDefaultException)) {
                e.preventDefault();
            }

            var point = e.touches ? e.touches[0] : e,
                pos;

            this.initiated = utils.eventType[e.type];
            this.moved = false;
            this.distX = 0;
            this.distY = 0;
            this.directionX = 0;
            this.directionY = 0;
            this.directionLocked = 0;

            this._transitionTime();

            this.startTime = utils.getTime();

            if (this.options.useTransition && this.isInTransition) {
                this.isInTransition = false;
                pos = this.getComputedPosition();
                this._translate(Math.round(pos.x), Math.round(pos.y));
                this._execEvent('scrollEnd');
            } else if (!this.options.useTransition && this.isAnimating) {
                this.isAnimating = false;
                this._execEvent('scrollEnd');
            }

            this.startX = this.x;
            this.startY = this.y;
            this.absStartX = this.x;
            this.absStartY = this.y;
            this.pointX = point.pageX;
            this.pointY = point.pageY;

            this._execEvent('beforeScrollStart');
        },

        _move: function _move(e) {
            if (!this.enabled || utils.eventType[e.type] !== this.initiated) {
                return;
            }

            if (this.options.preventDefault) {
                // increases performance on Android? TODO: check!
                e.preventDefault();
            }

            var point = e.touches ? e.touches[0] : e,
                deltaX = point.pageX - this.pointX,
                deltaY = point.pageY - this.pointY,
                timestamp = utils.getTime(),
                newX,
                newY,
                absDistX,
                absDistY;

            this.pointX = point.pageX;
            this.pointY = point.pageY;

            this.distX += deltaX;
            this.distY += deltaY;
            absDistX = Math.abs(this.distX);
            absDistY = Math.abs(this.distY);

            // We need to move at least 10 pixels for the scrolling to initiate
            if (timestamp - this.endTime > 300 && absDistX < 10 && absDistY < 10) {
                return;
            }

            // If you are scrolling in one direction lock the other
            if (!this.directionLocked && !this.options.freeScroll) {
                if (absDistX > absDistY + this.options.directionLockThreshold) {
                    this.directionLocked = 'h'; // lock horizontally
                } else if (absDistY >= absDistX + this.options.directionLockThreshold) {
                    this.directionLocked = 'v'; // lock vertically
                } else {
                    this.directionLocked = 'n'; // no lock
                }
            }

            if (this.directionLocked == 'h') {
                if (this.options.eventPassthrough == 'vertical') {
                    e.preventDefault();
                } else if (this.options.eventPassthrough == 'horizontal') {
                    this.initiated = false;
                    return;
                }

                deltaY = 0;
            } else if (this.directionLocked == 'v') {
                if (this.options.eventPassthrough == 'horizontal') {
                    e.preventDefault();
                } else if (this.options.eventPassthrough == 'vertical') {
                    this.initiated = false;
                    return;
                }

                deltaX = 0;
            }

            deltaX = this.hasHorizontalScroll ? deltaX : 0;
            deltaY = this.hasVerticalScroll ? deltaY : 0;

            newX = this.x + deltaX;
            newY = this.y + deltaY;

            // Slow down if outside of the boundaries
            if (newX > 0 || newX < this.maxScrollX) {
                newX = this.options.bounce ? this.x + deltaX / 3 : newX > 0 ? 0 : this.maxScrollX;
            }
            if (newY > 0 || newY < this.maxScrollY) {
                newY = this.options.bounce ? this.y + deltaY / 3 : newY > 0 ? 0 : this.maxScrollY;
            }

            this.directionX = deltaX > 0 ? -1 : deltaX < 0 ? 1 : 0;
            this.directionY = deltaY > 0 ? -1 : deltaY < 0 ? 1 : 0;

            if (!this.moved) {
                this._execEvent('scrollStart');
            }

            this.moved = true;

            this._translate(newX, newY);

            /* REPLACE START: _move */

            if (timestamp - this.startTime > 300) {
                this.startTime = timestamp;
                this.startX = this.x;
                this.startY = this.y;
            }

            /* REPLACE END: _move */
        },

        _end: function _end(e) {
            if (!this.enabled || utils.eventType[e.type] !== this.initiated) {
                return;
            }

            if (this.options.preventDefault && !utils.preventDefaultException(e.target, this.options.preventDefaultException)) {
                e.preventDefault();
            }

            var point = e.changedTouches ? e.changedTouches[0] : e,
                momentumX,
                momentumY,
                duration = utils.getTime() - this.startTime,
                newX = Math.round(this.x),
                newY = Math.round(this.y),
                distanceX = Math.abs(newX - this.startX),
                distanceY = Math.abs(newY - this.startY),
                time = 0,
                easing = '';

            this.isInTransition = 0;
            this.initiated = 0;
            this.endTime = utils.getTime();

            // reset if we are outside of the boundaries
            if (this.resetPosition(this.options.bounceTime)) {
                return;
            }

            this.scrollTo(newX, newY); // ensures that the last position is rounded

            // we scrolled less than 10 pixels
            if (!this.moved) {
                if (this.options.tap) {
                    utils.tap(e, this.options.tap);
                }

                if (this.options.click) {
                    utils.click(e);
                }

                this._execEvent('scrollCancel');
                return;
            }

            if (this._events.flick && duration < 200 && distanceX < 100 && distanceY < 100) {
                this._execEvent('flick');
                return;
            }

            // start momentum animation if needed
            if (this.options.momentum && duration < 300) {
                momentumX = this.hasHorizontalScroll ? utils.momentum(this.x, this.startX, duration, this.maxScrollX, this.options.bounce ? this.wrapperWidth : 0, this.options.deceleration) : { destination: newX, duration: 0 };
                momentumY = this.hasVerticalScroll ? utils.momentum(this.y, this.startY, duration, this.maxScrollY, this.options.bounce ? this.wrapperHeight : 0, this.options.deceleration) : { destination: newY, duration: 0 };
                newX = momentumX.destination;
                newY = momentumY.destination;
                time = Math.max(momentumX.duration, momentumY.duration);
                this.isInTransition = 1;
            }

            if (this.options.snap) {
                var snap = this._nearestSnap(newX, newY);
                this.currentPage = snap;
                time = this.options.snapSpeed || Math.max(Math.max(Math.min(Math.abs(newX - snap.x), 1000), Math.min(Math.abs(newY - snap.y), 1000)), 300);
                newX = snap.x;
                newY = snap.y;

                this.directionX = 0;
                this.directionY = 0;
                easing = this.options.bounceEasing;
            }

            // INSERT POINT: _end

            if (newX != this.x || newY != this.y) {
                // change easing function when scroller goes out of the boundaries
                if (newX > 0 || newX < this.maxScrollX || newY > 0 || newY < this.maxScrollY) {
                    easing = utils.ease.quadratic;
                }

                this.scrollTo(newX, newY, time, easing);
                return;
            }

            this._execEvent('scrollEnd');
        },

        _resize: function _resize() {
            var that = this;

            clearTimeout(this.resizeTimeout);

            this.resizeTimeout = setTimeout(function () {
                that.refresh();
            }, this.options.resizePolling);
        },

        resetPosition: function resetPosition(time) {
            var x = this.x,
                y = this.y;

            time = time || 0;

            if (!this.hasHorizontalScroll || this.x > 0) {
                x = 0;
            } else if (this.x < this.maxScrollX) {
                x = this.maxScrollX;
            }

            if (!this.hasVerticalScroll || this.y > 0) {
                y = 0;
            } else if (this.y < this.maxScrollY) {
                y = this.maxScrollY;
            }

            if (x == this.x && y == this.y) {
                return false;
            }

            this.scrollTo(x, y, time, this.options.bounceEasing);

            return true;
        },

        disable: function disable() {
            this.enabled = false;
        },

        enable: function enable() {
            this.enabled = true;
        },

        refresh: function refresh() {
            var rf = this.wrapper.offsetHeight; // Force reflow

            this.wrapperWidth = this.wrapper.clientWidth;
            this.wrapperHeight = this.wrapper.clientHeight;

            /* REPLACE START: refresh */

            this.scrollerWidth = this.scroller.offsetWidth;
            this.scrollerHeight = this.scroller.offsetHeight;

            this.maxScrollX = this.wrapperWidth - this.scrollerWidth;
            this.maxScrollY = this.wrapperHeight - this.scrollerHeight;

            /* REPLACE END: refresh */

            this.hasHorizontalScroll = this.options.scrollX && this.maxScrollX < 0;
            this.hasVerticalScroll = this.options.scrollY && this.maxScrollY < 0;

            if (!this.hasHorizontalScroll) {
                this.maxScrollX = 0;
                this.scrollerWidth = this.wrapperWidth;
            }

            if (!this.hasVerticalScroll) {
                this.maxScrollY = 0;
                this.scrollerHeight = this.wrapperHeight;
            }

            this.endTime = 0;
            this.directionX = 0;
            this.directionY = 0;

            this.wrapperOffset = utils.offset(this.wrapper);

            this._execEvent('refresh');

            this.resetPosition();

            // INSERT POINT: _refresh
        },

        on: function on(type, fn) {
            if (!this._events[type]) {
                this._events[type] = [];
            }

            this._events[type].push(fn);
        },

        off: function off(type, fn) {
            if (!this._events[type]) {
                return;
            }

            var index = this._events[type].indexOf(fn);

            if (index > -1) {
                this._events[type].splice(index, 1);
            }
        },

        _execEvent: function _execEvent(type) {
            if (!this._events[type]) {
                return;
            }

            var i = 0,
                l = this._events[type].length;

            if (!l) {
                return;
            }

            for (; i < l; i++) {
                this._events[type][i].apply(this, [].slice.call(arguments, 1));
            }
        },

        scrollBy: function scrollBy(x, y, time, easing) {
            x = this.x + x;
            y = this.y + y;
            time = time || 0;

            this.scrollTo(x, y, time, easing);
        },

        scrollTo: function scrollTo(x, y, time, easing) {
            easing = easing || utils.ease.circular;

            this.isInTransition = this.options.useTransition && time > 0;

            if (!time || this.options.useTransition && easing.style) {
                this._transitionTimingFunction(easing.style);
                this._transitionTime(time);
                this._translate(x, y);
            } else {
                this._animate(x, y, time, easing.fn);
            }
        },

        scrollToElement: function scrollToElement(el, time, offsetX, offsetY, easing) {
            el = el.nodeType ? el : this.scroller.querySelector(el);

            if (!el) {
                return;
            }

            var pos = utils.offset(el);

            pos.left -= this.wrapperOffset.left;
            pos.top -= this.wrapperOffset.top;

            // if offsetX/Y are true we center the element to the screen
            if (offsetX === true) {
                offsetX = Math.round(el.offsetWidth / 2 - this.wrapper.offsetWidth / 2);
            }
            if (offsetY === true) {
                offsetY = Math.round(el.offsetHeight / 2 - this.wrapper.offsetHeight / 2);
            }

            pos.left -= offsetX || 0;
            pos.top -= offsetY || 0;

            pos.left = pos.left > 0 ? 0 : pos.left < this.maxScrollX ? this.maxScrollX : pos.left;
            pos.top = pos.top > 0 ? 0 : pos.top < this.maxScrollY ? this.maxScrollY : pos.top;

            time = time === undefined || time === null || time === 'auto' ? Math.max(Math.abs(this.x - pos.left), Math.abs(this.y - pos.top)) : time;

            this.scrollTo(pos.left, pos.top, time, easing);
        },

        _transitionTime: function _transitionTime(time) {
            time = time || 0;

            this.scrollerStyle[utils.style.transitionDuration] = time + 'ms';

            if (!time && utils.isBadAndroid) {
                this.scrollerStyle[utils.style.transitionDuration] = '0.001s';
            }

            if (this.indicators) {
                for (var i = this.indicators.length; i--;) {
                    this.indicators[i].transitionTime(time);
                }
            }

            // INSERT POINT: _transitionTime
        },

        _transitionTimingFunction: function _transitionTimingFunction(easing) {
            this.scrollerStyle[utils.style.transitionTimingFunction] = easing;

            if (this.indicators) {
                for (var i = this.indicators.length; i--;) {
                    this.indicators[i].transitionTimingFunction(easing);
                }
            }

            // INSERT POINT: _transitionTimingFunction
        },

        _translate: function _translate(x, y) {
            if (this.options.useTransform) {

                /* REPLACE START: _translate */

                this.scrollerStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.translateZ;

                /* REPLACE END: _translate */
            } else {
                x = Math.round(x);
                y = Math.round(y);
                this.scrollerStyle.left = x + 'px';
                this.scrollerStyle.top = y + 'px';
            }

            this.x = x;
            this.y = y;

            if (this.indicators) {
                for (var i = this.indicators.length; i--;) {
                    this.indicators[i].updatePosition();
                }
            }

            // INSERT POINT: _translate
        },

        _initEvents: function _initEvents(remove) {
            var eventType = remove ? utils.removeEvent : utils.addEvent,
                target = this.options.bindToWrapper ? this.wrapper : window;

            eventType(window, 'orientationchange', this);
            eventType(window, 'resize', this);

            if (this.options.click) {
                eventType(this.wrapper, 'click', this, true);
            }

            if (!this.options.disableMouse) {
                eventType(this.wrapper, 'mousedown', this);
                eventType(target, 'mousemove', this);
                eventType(target, 'mousecancel', this);
                eventType(target, 'mouseup', this);
            }

            if (utils.hasPointer && !this.options.disablePointer) {
                eventType(this.wrapper, utils.prefixPointerEvent('pointerdown'), this);
                eventType(target, utils.prefixPointerEvent('pointermove'), this);
                eventType(target, utils.prefixPointerEvent('pointercancel'), this);
                eventType(target, utils.prefixPointerEvent('pointerup'), this);
            }

            if (utils.hasTouch && !this.options.disableTouch) {
                eventType(this.wrapper, 'touchstart', this);
                eventType(target, 'touchmove', this);
                eventType(target, 'touchcancel', this);
                eventType(target, 'touchend', this);
            }

            eventType(this.scroller, 'transitionend', this);
            eventType(this.scroller, 'webkitTransitionEnd', this);
            eventType(this.scroller, 'oTransitionEnd', this);
            eventType(this.scroller, 'MSTransitionEnd', this);
        },

        getComputedPosition: function getComputedPosition() {
            var matrix = window.getComputedStyle(this.scroller, null),
                x,
                y;

            if (this.options.useTransform) {
                matrix = matrix[utils.style.transform].split(')')[0].split(', ');
                x = +(matrix[12] || matrix[4]);
                y = +(matrix[13] || matrix[5]);
            } else {
                x = +matrix.left.replace(/[^-\d.]/g, '');
                y = +matrix.top.replace(/[^-\d.]/g, '');
            }

            return { x: x, y: y };
        },

        _initIndicators: function _initIndicators() {
            var interactive = this.options.interactiveScrollbars,
                customStyle = typeof this.options.scrollbars != 'string',
                indicators = [],
                indicator;

            var that = this;

            this.indicators = [];

            if (this.options.scrollbars) {
                // Vertical scrollbar
                if (this.options.scrollY) {
                    indicator = {
                        el: createDefaultScrollbar('v', interactive, this.options.scrollbars),
                        interactive: interactive,
                        defaultScrollbars: true,
                        customStyle: customStyle,
                        resize: this.options.resizeScrollbars,
                        shrink: this.options.shrinkScrollbars,
                        fade: this.options.fadeScrollbars,
                        listenX: false
                    };

                    this.wrapper.appendChild(indicator.el);
                    indicators.push(indicator);
                }

                // Horizontal scrollbar
                if (this.options.scrollX) {
                    indicator = {
                        el: createDefaultScrollbar('h', interactive, this.options.scrollbars),
                        interactive: interactive,
                        defaultScrollbars: true,
                        customStyle: customStyle,
                        resize: this.options.resizeScrollbars,
                        shrink: this.options.shrinkScrollbars,
                        fade: this.options.fadeScrollbars,
                        listenY: false
                    };

                    this.wrapper.appendChild(indicator.el);
                    indicators.push(indicator);
                }
            }

            if (this.options.indicators) {
                // TODO: check concat compatibility
                indicators = indicators.concat(this.options.indicators);
            }

            for (var i = indicators.length; i--;) {
                this.indicators.push(new Indicator(this, indicators[i]));
            }

            // TODO: check if we can use array.map (wide compatibility and performance issues)
            function _indicatorsMap(fn) {
                for (var i = that.indicators.length; i--;) {
                    fn.call(that.indicators[i]);
                }
            }

            if (this.options.fadeScrollbars) {
                this.on('scrollEnd', function () {
                    _indicatorsMap(function () {
                        this.fade();
                    });
                });

                this.on('scrollCancel', function () {
                    _indicatorsMap(function () {
                        this.fade();
                    });
                });

                this.on('scrollStart', function () {
                    _indicatorsMap(function () {
                        this.fade(1);
                    });
                });

                this.on('beforeScrollStart', function () {
                    _indicatorsMap(function () {
                        this.fade(1, true);
                    });
                });
            }

            this.on('refresh', function () {
                _indicatorsMap(function () {
                    this.refresh();
                });
            });

            this.on('destroy', function () {
                _indicatorsMap(function () {
                    this.destroy();
                });

                delete this.indicators;
            });
        },

        _initWheel: function _initWheel() {
            utils.addEvent(this.wrapper, 'wheel', this);
            utils.addEvent(this.wrapper, 'mousewheel', this);
            utils.addEvent(this.wrapper, 'DOMMouseScroll', this);

            this.on('destroy', function () {
                utils.removeEvent(this.wrapper, 'wheel', this);
                utils.removeEvent(this.wrapper, 'mousewheel', this);
                utils.removeEvent(this.wrapper, 'DOMMouseScroll', this);
            });
        },

        _wheel: function _wheel(e) {
            if (!this.enabled) {
                return;
            }

            e.preventDefault();
            e.stopPropagation();

            var wheelDeltaX,
                wheelDeltaY,
                newX,
                newY,
                that = this;

            if (this.wheelTimeout === undefined) {
                that._execEvent('scrollStart');
            }

            // Execute the scrollEnd event after 400ms the wheel stopped scrolling
            clearTimeout(this.wheelTimeout);
            this.wheelTimeout = setTimeout(function () {
                that._execEvent('scrollEnd');
                that.wheelTimeout = undefined;
            }, 400);

            if ('deltaX' in e) {
                wheelDeltaX = -e.deltaX;
                wheelDeltaY = -e.deltaY;
            } else if ('wheelDeltaX' in e) {
                wheelDeltaX = e.wheelDeltaX / 120 * this.options.mouseWheelSpeed;
                wheelDeltaY = e.wheelDeltaY / 120 * this.options.mouseWheelSpeed;
            } else if ('wheelDelta' in e) {
                wheelDeltaX = wheelDeltaY = e.wheelDelta / 120 * this.options.mouseWheelSpeed;
            } else if ('detail' in e) {
                wheelDeltaX = wheelDeltaY = -e.detail / 3 * this.options.mouseWheelSpeed;
            } else {
                return;
            }

            wheelDeltaX *= this.options.invertWheelDirection;
            wheelDeltaY *= this.options.invertWheelDirection;

            if (!this.hasVerticalScroll) {
                wheelDeltaX = wheelDeltaY;
                wheelDeltaY = 0;
            }

            if (this.options.snap) {
                newX = this.currentPage.pageX;
                newY = this.currentPage.pageY;

                if (wheelDeltaX > 0) {
                    newX--;
                } else if (wheelDeltaX < 0) {
                    newX++;
                }

                if (wheelDeltaY > 0) {
                    newY--;
                } else if (wheelDeltaY < 0) {
                    newY++;
                }

                this.goToPage(newX, newY);

                return;
            }

            newX = this.x + Math.round(this.hasHorizontalScroll ? wheelDeltaX : 0);
            newY = this.y + Math.round(this.hasVerticalScroll ? wheelDeltaY : 0);

            if (newX > 0) {
                newX = 0;
            } else if (newX < this.maxScrollX) {
                newX = this.maxScrollX;
            }

            if (newY > 0) {
                newY = 0;
            } else if (newY < this.maxScrollY) {
                newY = this.maxScrollY;
            }

            this.scrollTo(newX, newY, 0);

            // INSERT POINT: _wheel
        },

        _initSnap: function _initSnap() {
            this.currentPage = {};

            if (typeof this.options.snap == 'string') {
                this.options.snap = this.scroller.querySelectorAll(this.options.snap);
            }

            this.on('refresh', function () {
                var i = 0,
                    l,
                    m = 0,
                    n,
                    cx,
                    cy,
                    x = 0,
                    y,
                    stepX = this.options.snapStepX || this.wrapperWidth,
                    stepY = this.options.snapStepY || this.wrapperHeight,
                    el;

                this.pages = [];

                if (!this.wrapperWidth || !this.wrapperHeight || !this.scrollerWidth || !this.scrollerHeight) {
                    return;
                }

                if (this.options.snap === true) {
                    cx = Math.round(stepX / 2);
                    cy = Math.round(stepY / 2);

                    while (x > -this.scrollerWidth) {
                        this.pages[i] = [];
                        l = 0;
                        y = 0;

                        while (y > -this.scrollerHeight) {
                            this.pages[i][l] = {
                                x: Math.max(x, this.maxScrollX),
                                y: Math.max(y, this.maxScrollY),
                                width: stepX,
                                height: stepY,
                                cx: x - cx,
                                cy: y - cy
                            };

                            y -= stepY;
                            l++;
                        }

                        x -= stepX;
                        i++;
                    }
                } else {
                    el = this.options.snap;
                    l = el.length;
                    n = -1;

                    for (; i < l; i++) {
                        if (i === 0 || el[i].offsetLeft <= el[i - 1].offsetLeft) {
                            m = 0;
                            n++;
                        }

                        if (!this.pages[m]) {
                            this.pages[m] = [];
                        }

                        x = Math.max(-el[i].offsetLeft, this.maxScrollX);
                        y = Math.max(-el[i].offsetTop, this.maxScrollY);
                        cx = x - Math.round(el[i].offsetWidth / 2);
                        cy = y - Math.round(el[i].offsetHeight / 2);

                        this.pages[m][n] = {
                            x: x,
                            y: y,
                            width: el[i].offsetWidth,
                            height: el[i].offsetHeight,
                            cx: cx,
                            cy: cy
                        };

                        if (x > this.maxScrollX) {
                            m++;
                        }
                    }
                }

                this.goToPage(this.currentPage.pageX || 0, this.currentPage.pageY || 0, 0);

                // Update snap threshold if needed
                if (this.options.snapThreshold % 1 === 0) {
                    this.snapThresholdX = this.options.snapThreshold;
                    this.snapThresholdY = this.options.snapThreshold;
                } else {
                    this.snapThresholdX = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].width * this.options.snapThreshold);
                    this.snapThresholdY = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].height * this.options.snapThreshold);
                }
            });

            this.on('flick', function () {
                var time = this.options.snapSpeed || Math.max(Math.max(Math.min(Math.abs(this.x - this.startX), 1000), Math.min(Math.abs(this.y - this.startY), 1000)), 300);

                this.goToPage(this.currentPage.pageX + this.directionX, this.currentPage.pageY + this.directionY, time);
            });
        },

        _nearestSnap: function _nearestSnap(x, y) {
            if (!this.pages.length) {
                return { x: 0, y: 0, pageX: 0, pageY: 0 };
            }

            var i = 0,
                l = this.pages.length,
                m = 0;

            // Check if we exceeded the snap threshold
            if (Math.abs(x - this.absStartX) < this.snapThresholdX && Math.abs(y - this.absStartY) < this.snapThresholdY) {
                return this.currentPage;
            }

            if (x > 0) {
                x = 0;
            } else if (x < this.maxScrollX) {
                x = this.maxScrollX;
            }

            if (y > 0) {
                y = 0;
            } else if (y < this.maxScrollY) {
                y = this.maxScrollY;
            }

            for (; i < l; i++) {
                if (x >= this.pages[i][0].cx) {
                    x = this.pages[i][0].x;
                    break;
                }
            }

            l = this.pages[i].length;

            for (; m < l; m++) {
                if (y >= this.pages[0][m].cy) {
                    y = this.pages[0][m].y;
                    break;
                }
            }

            if (i == this.currentPage.pageX) {
                i += this.directionX;

                if (i < 0) {
                    i = 0;
                } else if (i >= this.pages.length) {
                    i = this.pages.length - 1;
                }

                x = this.pages[i][0].x;
            }

            if (m == this.currentPage.pageY) {
                m += this.directionY;

                if (m < 0) {
                    m = 0;
                } else if (m >= this.pages[0].length) {
                    m = this.pages[0].length - 1;
                }

                y = this.pages[0][m].y;
            }

            return {
                x: x,
                y: y,
                pageX: i,
                pageY: m
            };
        },

        goToPage: function goToPage(x, y, time, easing) {
            easing = easing || this.options.bounceEasing;

            if (x >= this.pages.length) {
                x = this.pages.length - 1;
            } else if (x < 0) {
                x = 0;
            }

            if (y >= this.pages[x].length) {
                y = this.pages[x].length - 1;
            } else if (y < 0) {
                y = 0;
            }

            var posX = this.pages[x][y].x,
                posY = this.pages[x][y].y;

            time = time === undefined ? this.options.snapSpeed || Math.max(Math.max(Math.min(Math.abs(posX - this.x), 1000), Math.min(Math.abs(posY - this.y), 1000)), 300) : time;

            this.currentPage = {
                x: posX,
                y: posY,
                pageX: x,
                pageY: y
            };

            this.scrollTo(posX, posY, time, easing);
        },

        next: function next(time, easing) {
            var x = this.currentPage.pageX,
                y = this.currentPage.pageY;

            x++;

            if (x >= this.pages.length && this.hasVerticalScroll) {
                x = 0;
                y++;
            }

            this.goToPage(x, y, time, easing);
        },

        prev: function prev(time, easing) {
            var x = this.currentPage.pageX,
                y = this.currentPage.pageY;

            x--;

            if (x < 0 && this.hasVerticalScroll) {
                x = 0;
                y--;
            }

            this.goToPage(x, y, time, easing);
        },

        _initKeys: function _initKeys(e) {
            // default key bindings
            var keys = {
                pageUp: 33,
                pageDown: 34,
                end: 35,
                home: 36,
                left: 37,
                up: 38,
                right: 39,
                down: 40
            };
            var i;

            // if you give me characters I give you keycode
            if (_typeof(this.options.keyBindings) == 'object') {
                for (i in this.options.keyBindings) {
                    if (typeof this.options.keyBindings[i] == 'string') {
                        this.options.keyBindings[i] = this.options.keyBindings[i].toUpperCase().charCodeAt(0);
                    }
                }
            } else {
                this.options.keyBindings = {};
            }

            for (i in keys) {
                this.options.keyBindings[i] = this.options.keyBindings[i] || keys[i];
            }

            utils.addEvent(window, 'keydown', this);

            this.on('destroy', function () {
                utils.removeEvent(window, 'keydown', this);
            });
        },

        _key: function _key(e) {
            if (!this.enabled) {
                return;
            }

            var snap = this.options.snap,
                // we are using this alot, better to cache it
            newX = snap ? this.currentPage.pageX : this.x,
                newY = snap ? this.currentPage.pageY : this.y,
                now = utils.getTime(),
                prevTime = this.keyTime || 0,
                acceleration = 0.250,
                pos;

            if (this.options.useTransition && this.isInTransition) {
                pos = this.getComputedPosition();

                this._translate(Math.round(pos.x), Math.round(pos.y));
                this.isInTransition = false;
            }

            this.keyAcceleration = now - prevTime < 200 ? Math.min(this.keyAcceleration + acceleration, 50) : 0;

            switch (e.keyCode) {
                case this.options.keyBindings.pageUp:
                    if (this.hasHorizontalScroll && !this.hasVerticalScroll) {
                        newX += snap ? 1 : this.wrapperWidth;
                    } else {
                        newY += snap ? 1 : this.wrapperHeight;
                    }
                    break;
                case this.options.keyBindings.pageDown:
                    if (this.hasHorizontalScroll && !this.hasVerticalScroll) {
                        newX -= snap ? 1 : this.wrapperWidth;
                    } else {
                        newY -= snap ? 1 : this.wrapperHeight;
                    }
                    break;
                case this.options.keyBindings.end:
                    newX = snap ? this.pages.length - 1 : this.maxScrollX;
                    newY = snap ? this.pages[0].length - 1 : this.maxScrollY;
                    break;
                case this.options.keyBindings.home:
                    newX = 0;
                    newY = 0;
                    break;
                case this.options.keyBindings.left:
                    newX += snap ? -1 : 5 + this.keyAcceleration >> 0;
                    break;
                case this.options.keyBindings.up:
                    newY += snap ? 1 : 5 + this.keyAcceleration >> 0;
                    break;
                case this.options.keyBindings.right:
                    newX -= snap ? -1 : 5 + this.keyAcceleration >> 0;
                    break;
                case this.options.keyBindings.down:
                    newY -= snap ? 1 : 5 + this.keyAcceleration >> 0;
                    break;
                default:
                    return;
            }

            if (snap) {
                this.goToPage(newX, newY);
                return;
            }

            if (newX > 0) {
                newX = 0;
                this.keyAcceleration = 0;
            } else if (newX < this.maxScrollX) {
                newX = this.maxScrollX;
                this.keyAcceleration = 0;
            }

            if (newY > 0) {
                newY = 0;
                this.keyAcceleration = 0;
            } else if (newY < this.maxScrollY) {
                newY = this.maxScrollY;
                this.keyAcceleration = 0;
            }

            this.scrollTo(newX, newY, 0);

            this.keyTime = now;
        },

        _animate: function _animate(destX, destY, duration, easingFn) {
            var that = this,
                startX = this.x,
                startY = this.y,
                startTime = utils.getTime(),
                destTime = startTime + duration;

            function step() {
                var now = utils.getTime(),
                    newX,
                    newY,
                    easing;

                if (now >= destTime) {
                    that.isAnimating = false;
                    that._translate(destX, destY);

                    if (!that.resetPosition(that.options.bounceTime)) {
                        that._execEvent('scrollEnd');
                    }

                    return;
                }

                now = (now - startTime) / duration;
                easing = easingFn(now);
                newX = (destX - startX) * easing + startX;
                newY = (destY - startY) * easing + startY;
                that._translate(newX, newY);

                if (that.isAnimating) {
                    rAF(step);
                }
            }

            this.isAnimating = true;
            step();
        },
        handleEvent: function handleEvent(e) {
            switch (e.type) {
                case 'touchstart':
                case 'pointerdown':
                case 'MSPointerDown':
                case 'mousedown':
                    this._start(e);
                    break;
                case 'touchmove':
                case 'pointermove':
                case 'MSPointerMove':
                case 'mousemove':
                    this._move(e);
                    break;
                case 'touchend':
                case 'pointerup':
                case 'MSPointerUp':
                case 'mouseup':
                case 'touchcancel':
                case 'pointercancel':
                case 'MSPointerCancel':
                case 'mousecancel':
                    this._end(e);
                    break;
                case 'orientationchange':
                case 'resize':
                    this._resize();
                    break;
                case 'transitionend':
                case 'webkitTransitionEnd':
                case 'oTransitionEnd':
                case 'MSTransitionEnd':
                    this._transitionEnd(e);
                    break;
                case 'wheel':
                case 'DOMMouseScroll':
                case 'mousewheel':
                    this._wheel(e);
                    break;
                case 'keydown':
                    this._key(e);
                    break;
                case 'click':
                    if (!e._constructed) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                    break;
            }
        }
    };
    function createDefaultScrollbar(direction, interactive, type) {
        var scrollbar = document.createElement('div'),
            indicator = document.createElement('div');

        if (type === true) {
            scrollbar.style.cssText = 'position:absolute;z-index:9999';
            indicator.style.cssText = '-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:absolute;background:rgba(0,0,0,0.5);border:0.03125rem solid rgba(255,255,255,0.9);border-radius:0.09375rem';
        }

        indicator.className = 'iScrollIndicator';

        if (direction == 'h') {
            if (type === true) {
                scrollbar.style.cssText += ';height:0.21875rem;left:0.0625rem;right:0.0625rem;bottom:0';
                indicator.style.height = '100%';
            }
            scrollbar.className = 'iScrollHorizontalScrollbar';
        } else {
            if (type === true) {
                scrollbar.style.cssText += ';width:0.21875rem;bottom:0.0625rem;top:0.0625rem;right:0.03125rem';
                indicator.style.width = '100%';
            }
            scrollbar.className = 'iScrollVerticalScrollbar';
        }

        scrollbar.style.cssText += ';overflow:hidden';

        if (!interactive) {
            scrollbar.style.pointerEvents = 'none';
        }

        scrollbar.appendChild(indicator);

        return scrollbar;
    }

    function Indicator(scroller, options) {
        this.wrapper = typeof options.el == 'string' ? document.querySelector(options.el) : options.el;
        this.wrapperStyle = this.wrapper.style;
        this.indicator = this.wrapper.children[0];
        this.indicatorStyle = this.indicator.style;
        this.scroller = scroller;

        this.options = {
            listenX: true,
            listenY: true,
            interactive: false,
            resize: true,
            defaultScrollbars: false,
            shrink: false,
            fade: false,
            speedRatioX: 0,
            speedRatioY: 0
        };

        for (var i in options) {
            this.options[i] = options[i];
        }

        this.sizeRatioX = 1;
        this.sizeRatioY = 1;
        this.maxPosX = 0;
        this.maxPosY = 0;

        if (this.options.interactive) {
            if (!this.options.disableTouch) {
                utils.addEvent(this.indicator, 'touchstart', this);
                utils.addEvent(window, 'touchend', this);
            }
            if (!this.options.disablePointer) {
                utils.addEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
                utils.addEvent(window, utils.prefixPointerEvent('pointerup'), this);
            }
            if (!this.options.disableMouse) {
                utils.addEvent(this.indicator, 'mousedown', this);
                utils.addEvent(window, 'mouseup', this);
            }
        }

        if (this.options.fade) {
            this.wrapperStyle[utils.style.transform] = this.scroller.translateZ;
            this.wrapperStyle[utils.style.transitionDuration] = utils.isBadAndroid ? '0.001s' : '0ms';
            this.wrapperStyle.opacity = '0';
        }
    }

    Indicator.prototype = {
        handleEvent: function handleEvent(e) {
            switch (e.type) {
                case 'touchstart':
                case 'pointerdown':
                case 'MSPointerDown':
                case 'mousedown':
                    this._start(e);
                    break;
                case 'touchmove':
                case 'pointermove':
                case 'MSPointerMove':
                case 'mousemove':
                    this._move(e);
                    break;
                case 'touchend':
                case 'pointerup':
                case 'MSPointerUp':
                case 'mouseup':
                case 'touchcancel':
                case 'pointercancel':
                case 'MSPointerCancel':
                case 'mousecancel':
                    this._end(e);
                    break;
            }
        },

        destroy: function destroy() {
            if (this.options.interactive) {
                utils.removeEvent(this.indicator, 'touchstart', this);
                utils.removeEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
                utils.removeEvent(this.indicator, 'mousedown', this);

                utils.removeEvent(window, 'touchmove', this);
                utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
                utils.removeEvent(window, 'mousemove', this);

                utils.removeEvent(window, 'touchend', this);
                utils.removeEvent(window, utils.prefixPointerEvent('pointerup'), this);
                utils.removeEvent(window, 'mouseup', this);
            }

            if (this.options.defaultScrollbars) {
                this.wrapper.parentNode.removeChild(this.wrapper);
            }
        },

        _start: function _start(e) {
            var point = e.touches ? e.touches[0] : e;

            e.preventDefault();
            e.stopPropagation();

            this.transitionTime();

            this.initiated = true;
            this.moved = false;
            this.lastPointX = point.pageX;
            this.lastPointY = point.pageY;

            this.startTime = utils.getTime();

            if (!this.options.disableTouch) {
                utils.addEvent(window, 'touchmove', this);
            }
            if (!this.options.disablePointer) {
                utils.addEvent(window, utils.prefixPointerEvent('pointermove'), this);
            }
            if (!this.options.disableMouse) {
                utils.addEvent(window, 'mousemove', this);
            }

            this.scroller._execEvent('beforeScrollStart');
        },

        _move: function _move(e) {
            var point = e.touches ? e.touches[0] : e,
                deltaX,
                deltaY,
                newX,
                newY,
                timestamp = utils.getTime();

            if (!this.moved) {
                this.scroller._execEvent('scrollStart');
            }

            this.moved = true;

            deltaX = point.pageX - this.lastPointX;
            this.lastPointX = point.pageX;

            deltaY = point.pageY - this.lastPointY;
            this.lastPointY = point.pageY;

            newX = this.x + deltaX;
            newY = this.y + deltaY;

            this._pos(newX, newY);

            // INSERT POINT: indicator._move

            e.preventDefault();
            e.stopPropagation();
        },

        _end: function _end(e) {
            if (!this.initiated) {
                return;
            }

            this.initiated = false;

            e.preventDefault();
            e.stopPropagation();

            utils.removeEvent(window, 'touchmove', this);
            utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
            utils.removeEvent(window, 'mousemove', this);

            if (this.scroller.options.snap) {
                var snap = this.scroller._nearestSnap(this.scroller.x, this.scroller.y);

                var time = this.options.snapSpeed || Math.max(Math.max(Math.min(Math.abs(this.scroller.x - snap.x), 1000), Math.min(Math.abs(this.scroller.y - snap.y), 1000)), 300);

                if (this.scroller.x != snap.x || this.scroller.y != snap.y) {
                    this.scroller.directionX = 0;
                    this.scroller.directionY = 0;
                    this.scroller.currentPage = snap;
                    this.scroller.scrollTo(snap.x, snap.y, time, this.scroller.options.bounceEasing);
                }
            }

            if (this.moved) {
                this.scroller._execEvent('scrollEnd');
            }
        },

        transitionTime: function transitionTime(time) {
            time = time || 0;
            this.indicatorStyle[utils.style.transitionDuration] = time + 'ms';

            if (!time && utils.isBadAndroid) {
                this.indicatorStyle[utils.style.transitionDuration] = '0.001s';
            }
        },

        transitionTimingFunction: function transitionTimingFunction(easing) {
            this.indicatorStyle[utils.style.transitionTimingFunction] = easing;
        },

        refresh: function refresh() {
            this.transitionTime();

            if (this.options.listenX && !this.options.listenY) {
                this.indicatorStyle.display = this.scroller.hasHorizontalScroll ? 'block' : 'none';
            } else if (this.options.listenY && !this.options.listenX) {
                this.indicatorStyle.display = this.scroller.hasVerticalScroll ? 'block' : 'none';
            } else {
                this.indicatorStyle.display = this.scroller.hasHorizontalScroll || this.scroller.hasVerticalScroll ? 'block' : 'none';
            }

            if (this.scroller.hasHorizontalScroll && this.scroller.hasVerticalScroll) {
                utils.addClass(this.wrapper, 'iScrollBothScrollbars');
                utils.removeClass(this.wrapper, 'iScrollLoneScrollbar');

                if (this.options.defaultScrollbars && this.options.customStyle) {
                    if (this.options.listenX) {
                        this.wrapper.style.right = '0.25rem';
                    } else {
                        this.wrapper.style.bottom = '0.25rem';
                    }
                }
            } else {
                utils.removeClass(this.wrapper, 'iScrollBothScrollbars');
                utils.addClass(this.wrapper, 'iScrollLoneScrollbar');

                if (this.options.defaultScrollbars && this.options.customStyle) {
                    if (this.options.listenX) {
                        this.wrapper.style.right = '0.0625rem';
                    } else {
                        this.wrapper.style.bottom = '0.0625rem';
                    }
                }
            }

            var r = this.wrapper.offsetHeight; // force refresh

            if (this.options.listenX) {
                this.wrapperWidth = this.wrapper.clientWidth;
                if (this.options.resize) {
                    this.indicatorWidth = Math.max(Math.round(this.wrapperWidth * this.wrapperWidth / (this.scroller.scrollerWidth || this.wrapperWidth || 1)), 8);
                    this.indicatorStyle.width = this.indicatorWidth + 'px';
                } else {
                    this.indicatorWidth = this.indicator.clientWidth;
                }

                this.maxPosX = this.wrapperWidth - this.indicatorWidth;

                if (this.options.shrink == 'clip') {
                    this.minBoundaryX = -this.indicatorWidth + 8;
                    this.maxBoundaryX = this.wrapperWidth - 8;
                } else {
                    this.minBoundaryX = 0;
                    this.maxBoundaryX = this.maxPosX;
                }

                this.sizeRatioX = this.options.speedRatioX || this.scroller.maxScrollX && this.maxPosX / this.scroller.maxScrollX;
            }

            if (this.options.listenY) {
                this.wrapperHeight = this.wrapper.clientHeight;
                if (this.options.resize) {
                    this.indicatorHeight = Math.max(Math.round(this.wrapperHeight * this.wrapperHeight / (this.scroller.scrollerHeight || this.wrapperHeight || 1)), 8);
                    this.indicatorStyle.height = this.indicatorHeight + 'px';
                } else {
                    this.indicatorHeight = this.indicator.clientHeight;
                }

                this.maxPosY = this.wrapperHeight - this.indicatorHeight;

                if (this.options.shrink == 'clip') {
                    this.minBoundaryY = -this.indicatorHeight + 8;
                    this.maxBoundaryY = this.wrapperHeight - 8;
                } else {
                    this.minBoundaryY = 0;
                    this.maxBoundaryY = this.maxPosY;
                }

                this.maxPosY = this.wrapperHeight - this.indicatorHeight;
                this.sizeRatioY = this.options.speedRatioY || this.scroller.maxScrollY && this.maxPosY / this.scroller.maxScrollY;
            }

            this.updatePosition();
        },

        updatePosition: function updatePosition() {
            var x = this.options.listenX && Math.round(this.sizeRatioX * this.scroller.x) || 0,
                y = this.options.listenY && Math.round(this.sizeRatioY * this.scroller.y) || 0;

            if (!this.options.ignoreBoundaries) {
                if (x < this.minBoundaryX) {
                    if (this.options.shrink == 'scale') {
                        this.width = Math.max(this.indicatorWidth + x, 8);
                        this.indicatorStyle.width = this.width + 'px';
                    }
                    x = this.minBoundaryX;
                } else if (x > this.maxBoundaryX) {
                    if (this.options.shrink == 'scale') {
                        this.width = Math.max(this.indicatorWidth - (x - this.maxPosX), 8);
                        this.indicatorStyle.width = this.width + 'px';
                        x = this.maxPosX + this.indicatorWidth - this.width;
                    } else {
                        x = this.maxBoundaryX;
                    }
                } else if (this.options.shrink == 'scale' && this.width != this.indicatorWidth) {
                    this.width = this.indicatorWidth;
                    this.indicatorStyle.width = this.width + 'px';
                }

                if (y < this.minBoundaryY) {
                    if (this.options.shrink == 'scale') {
                        this.height = Math.max(this.indicatorHeight + y * 3, 8);
                        this.indicatorStyle.height = this.height + 'px';
                    }
                    y = this.minBoundaryY;
                } else if (y > this.maxBoundaryY) {
                    if (this.options.shrink == 'scale') {
                        this.height = Math.max(this.indicatorHeight - (y - this.maxPosY) * 3, 8);
                        this.indicatorStyle.height = this.height + 'px';
                        y = this.maxPosY + this.indicatorHeight - this.height;
                    } else {
                        y = this.maxBoundaryY;
                    }
                } else if (this.options.shrink == 'scale' && this.height != this.indicatorHeight) {
                    this.height = this.indicatorHeight;
                    this.indicatorStyle.height = this.height + 'px';
                }
            }

            this.x = x;
            this.y = y;

            if (this.scroller.options.useTransform) {
                this.indicatorStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.scroller.translateZ;
            } else {
                this.indicatorStyle.left = x + 'px';
                this.indicatorStyle.top = y + 'px';
            }
        },

        _pos: function _pos(x, y) {
            if (x < 0) {
                x = 0;
            } else if (x > this.maxPosX) {
                x = this.maxPosX;
            }

            if (y < 0) {
                y = 0;
            } else if (y > this.maxPosY) {
                y = this.maxPosY;
            }

            x = this.options.listenX ? Math.round(x / this.sizeRatioX) : this.scroller.x;
            y = this.options.listenY ? Math.round(y / this.sizeRatioY) : this.scroller.y;

            this.scroller.scrollTo(x, y);
        },

        fade: function fade(val, hold) {
            if (hold && !this.visible) {
                return;
            }

            clearTimeout(this.fadeTimeout);
            this.fadeTimeout = null;

            var time = val ? 250 : 500,
                delay = val ? 0 : 300;

            val = val ? '1' : '0';

            this.wrapperStyle[utils.style.transitionDuration] = time + 'ms';

            this.fadeTimeout = setTimeout(function (val) {
                this.wrapperStyle.opacity = val;
                this.visible = +val;
            }.bind(this, val), delay);
        }
    };

    IScroll.utils = utils;

    if (typeof module != 'undefined' && module.exports) {
        module.exports = IScroll;
    } else {
        window.IScroll = IScroll;
    }
})(window, document, Math);

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 *  点击加载
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    var Base = __webpack_require__(1);

    var Refresh = Base.extend({
        defaults: {
            template: '<div class="ui-refresh" id="J-Refresh"><span></span></div>'
        },

        initialize: function initialize() {
            this.Parent.apply(this, arguments);
        },

        render: function render() {
            this.destory();
            this.buidDOM();
            this.bindEvent();
        },

        buidDOM: function buidDOM() {
            this.el = $(this.get('template'));
            $(document.body).append(this.el);
        },
        bindEvent: function bindEvent() {
            var _this = this;

            this.el.on('click', function () {
                _this.anim();
                _this.emit('refresh');
            });
        },
        anim: function anim() {
            var node = this.el;

            node.addClass('anim-spin');

            this.timer && clearTimeout(this.timer);

            this.timer = setTimeout(function () {
                node.removeClass('anim-spin');
            }, 400);
        },


        destory: function destory() {
            if (this.el) {
                this.el.off('click');
                this.el.remove();
            }
        }
    });

    UpAct.refresh = new Refresh();
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 45 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;
(function (win, UpAct) {
    var CONFIG = {
        /**
         * JAVA域名配置
         */
        originMap: {
            dev: 'http://up-events.xingyunzhi.cn', // 开发环境
            stage: 'http://sg-events.pengpengla.com', // 测试环境－新加坡
            pro: 'http://events.upliveapp.com' // 线上环境
        },
        /**
         * PHP域名配置
         */
        originPhpMap: {
            dev: 'http://awsbj-ranking.game.xingyunzhi.cn',
            stage: 'http://sg-ranking.game.xingyunzhi.cn',
            pro: 'https://ranking-game.upliveapps.com'

        },
        /**
         * PHP TAST域名配置
         */
        originPhpTaskMap: {
            dev: 'http://awsbj-ranking.game.xingyunzhi.cn',
            stage: 'http://sg-task.game.xingyunzhi.cn',
            pro: 'http://task.game.upliveapp.com'
        },
        /**
         * 根据环境获取Java接口域名
         * @name getOrigin
         */
        getOrigin: function getOrigin() {
            // 当前开发环境
            var env = UpAct.BaseUtil.query('env');

            if (!env || env == 'null') {
                env = 'pro';
            }

            var target = this.originMap[env] || this.originMap['pro'];

            if (location.host.indexOf('mact') >= 0) {
                target = target.replace('upliveapp.com', 'upliveapps.com');
            }

            return target;
        },

        /**
         * 根据环境获取PHP接口
         */
        getOriginPhpTask: function getOriginPhpTask() {
            // 当前开发环境
            var env = UpAct.BaseUtil.query('env');

            if (!env || env == 'null') {
                env = 'pro';
            }

            var target = this.originPhpTaskMap[env] || this.originPhpTaskMap['pro'];

            if (location.host.indexOf('mact') >= 0) {
                target = target.replace('upliveapp.com', 'upliveapps.com');
            }

            return target;
        },

        /**
         * 根据环境获取PHP接口
         */
        getOriginPhp: function getOriginPhp() {
            // 当前开发环境
            var env = UpAct.BaseUtil.query('env');

            if (!env || env == 'null') {
                env = 'pro';
            }

            var target = this.originPhpMap[env] || this.originPhpMap['pro'];

            if (location.host.indexOf('mact') >= 0) {
                target = target.replace('upliveapp.com', 'upliveapps.com');
            }

            return target;
        },

        /**
         * 获取活动id
         */
        getActivityId: function getActivityId() {
            var acidConfig = this.acidConfig;
            var ret = this.parseAcid(acidConfig.acid);
            return ret;
        },

        parseAcid: function parseAcid(acid) {
            var self = this;
            var result = [];

            if ($.isArray(acid)) {
                var arr = [];
                if (acid.length > 0) {
                    acid.forEach(function (item, index) {
                        if (item.acid) {
                            var _acid = self.parseAcid(item.acid);

                            if (_acid) {
                                arr[arr.length] = _acid;
                            }
                        }
                    });
                }
                result = arr.join(',');
            } else if ((typeof acid === 'undefined' ? 'undefined' : _typeof(acid)) == 'object') {
                var _arr = [];
                var newAcid = void 0;
                if (acid.acid) {
                    var _acid = self.parseAcid(acid.acid);

                    if (_acid) {
                        _arr[_arr.length] = _acid;
                    }
                }

                result = _arr.join(',');
            } else if (typeof acid == 'string' || typeof acid == 'number') {
                result = acid;
            }
            return result;
        },
        getTaskActId: function getTaskActId() {
            var acid = this.taskAcid;
            return acid;
        },
        /**
         * 获取活动信息
         */
        getActInfo: function getActInfo() {
            var acid = this.getActivityId();
            var url = void 0;

            if ((acid + '').indexOf(',') > -1) {
                url = this.getOriginPhp() + '/activity/get-multiple-infos?activityIds=' + acid;
            } else {
                url = this.getOriginPhp() + '/activity/get-info?activityId=' + acid;
            }

            return this.mockMode == 1 ? 'http://www.mocky.io/v2/58c240611100000f065abb5a' : url;
        },

        /**
         * 主播列表［总榜、日榜］
         */
        getHostList: function getHostList() {

            return this.mockMode == 1 ? 'http://www.mocky.io/v2/58a570192900007d086d6a1d' : this.getOrigin() + '/event/gifts/integralList';
        },

        /**
         * 土豪榜单
         */
        getSendHostList: function getSendHostList() {

            return this.mockMode == 1 ? 'http://www.mocky.io/v2/58a570192900007d086d6a1d' : this.getOrigin() + '/event/gifts/sendIntegralList';
        },

        /**达成类*/
        getReachList: function getReachList() {
            return this.mockMode == 1 ? 'http://www.mocky.io/v2/5a0e91e830000085244335ed' : this.getOrigin() + '/event/top/hostanchor/list';
        },
        /**
         * 守护榜
         */
        getSendUserList: function getSendUserList() {
            return this.mockMode == 1 ? 'http://www.mocky.io/v2/58be947b260000bc16f07bb9' : this.getOrigin() + '/event/gifts/giftSendUserIntegralList';
        },
        /**配对榜单*/
        getTrueLoveList: function getTrueLoveList() {
            // return 'https://up-b.pengpengla.com/events/event/guard/buy/list'
            return this.getOrigin() + '/event/guard/buy/list';
        },

        getActStatus: function getActStatus() {
            return this.getOriginPhpTask() + '/activity/status';
        },

        doExchange: function doExchange() {
            return this.getOriginPhpTask() + "/activity/reward";
        },
        /**
         * 收集类列表 按U币排序［总榜、日榜］
         */
        getGiftGatherList: function getGiftGatherList() {

            return this.mockMode == 1 ? 'http://www.mocky.io/v2/58a570192900007d086d6a1d' : this.getOrigin() + '/event/chinausergiftlist3/top';
        },

        /**
         * 收集类列表 按套数排序  支持多礼物［总榜、日榜］
         */
        getGiftGatherCollectionList: function getGiftGatherCollectionList() {

            return this.mockMode == 1 ? 'http://www.mocky.io/v2/58a570192900007d086d6a1d' : this.getOrigin() + '/event/chinaGifts/hostList';
        },

        /**
         * 收集类列表［财富榜］按套数排序 多礼物
         */
        getGiftGatherSendList: function getGiftGatherSendList() {

            return this.mockMode == 1 ? 'http://www.mocky.io/v2/58a570192900007d086d6a1d' : this.getOrigin() + '/event/chinaGift/sendhostlist';
        },

        /**
         * 按时长统计列表  直播时长（时间段）
         */
        getDurationList: function getDurationList() {

            return this.getOriginPhp() + "/ranking/board";
        },

        /**
         * 按时长统计列表  白名单 直播时长-U币速度榜
         */
        getDurationRankList: function getDurationRankList() {

            return this.mockMode == 1 ? 'http://www.mocky.io/v2/58a570192900007d086d6a1d' : this.getOriginPhp() + '/ranking/time-rank';
        },

        /**
         * 按最先完成统计列表 直播时长 时长速度榜
         
         */
        getEarlestReachList: function getEarlestReachList() {

            return this.mockMode == 1 ? 'http://www.mocky.io/v2/58a570192900007d086d6a1d' : this.getOriginPhp() + '/ranking/host-online-time-speed-rank';
        },

        //新榜单
        board: function board() {
            return this.getOriginPhp() + "/ranking/board";
        }
    };

    UpAct.CONFIG = CONFIG;
})(window, window['UpAct'] || (window['UpAct'] = {}));

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * 榜单活动核心流程的封装
 */
;(function (win, UpAct) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {
        var Base = __webpack_require__(1);
        var Fastclick = __webpack_require__(47);
        var native = __webpack_require__(4);

        var Activity = __webpack_require__(48);

        var MSL = ["MA", "AE", "AF", "BH", "CY", "DJ", "DZ", "EG", "IL", "IQ", "JO", "KM", "KW", "LB", "LY", "MR", "OM", "PK", "PS", "QA", "SA", "SD", "SO", "SS", "SSD", "SY", "TN", "TR", "UG", "YE"];

        var AppBase = Base.extend({
            defaults: {
                title: '',
                wrap: '#wrap'
            },

            initialize: function initialize() {
                this.Parent.apply(this, arguments);

                FastClick.attach(document.body);

                var title = this.get('title');

                title && UpAct.BaseUtil.setTitle(title);

                this.bindEvent();
            },

            bindEvent: function bindEvent() {
                var _this = this;

                var wrap = $(document.body);

                wrap.delegate('[node-id=profile]', 'click', function (e) {
                    _this.goProfile(e);
                });

                wrap.delegate('[node-id=liveRoom]', 'click', function (e) {
                    _this.goLivineRoom(e);
                });
            },

            goLivineRoom: function goLivineRoom(e) {
                var target = e.currentTarget;
                var uid = $(target).attr('data-uid');
                var rid = $(target).attr('data-rid');
                if (uid && rid) {
                    native.goRoom({
                        uid: uid,
                        roomid: rid
                    });
                }
            },
            goProfile: function goProfile(e) {
                var target = e.currentTarget;
                var uid = $(target).attr('data-uid');
                var country = $(target).attr('data-country');
                var platform = native.getPlatform();
                if (country && UpAct.lang.langType == 'areg' && MSL.indexOf(country) < 0) {
                    return;
                }

                if (uid) {

                    if (platform == "uplive") {
                        native.profile({
                            uid: uid
                        });
                    } else {
                        UpLive.invoke('profile', { uid: uid });
                    };
                }
            },


            // 用户活动数据
            getActInfo: function getActInfo() {
                this.loadActData();
            },


            // 活动信息
            loadActData: function loadActData() {
                var _this2 = this;

                var activity = new Activity({
                    url: UpAct.CONFIG.getActInfo()
                });

                var promise = activity.getData();

                promise.done(function (actData) {
                    UpAct.actData = actData;
                    _this2.emit('getActInfo');
                });

                promise.fail(function () {
                    $(_this2.get('wrap')).empty();
                    UpAct.notification.simple('activity error');
                });
            }
        });

        UpAct.AppBase = AppBase;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
})(window, window['UpAct'] || (window['UpAct'] = {}));

/***/ }),
/* 47 */
/***/ (function(module, exports) {



;(function () {
	'use strict';

	/**
  * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
  *
  * @codingstandard ftlabs-jsv2
  * @copyright The Financial Times Limited [All Rights Reserved]
  * @license MIT License (see LICENSE.txt)
  */

	/*jslint browser:true, node:true*/
	/*global define, Event, Node*/

	/**
  * Instantiate fast-clicking listeners on the specified layer.
  *
  * @constructor
  * @param {Element} layer The layer to listen on
  * @param {Object} [options={}] The options to override the defaults
  */

	function FastClick(layer, options) {
		var oldOnClick;

		options = options || {};

		/**
   * Whether a click is currently being tracked.
   *
   * @type boolean
   */
		this.trackingClick = false;

		/**
   * Timestamp for when click tracking started.
   *
   * @type number
   */
		this.trackingClickStart = 0;

		/**
   * The element being tracked for a click.
   *
   * @type EventTarget
   */
		this.targetElement = null;

		/**
   * X-coordinate of touch start event.
   *
   * @type number
   */
		this.touchStartX = 0;

		/**
   * Y-coordinate of touch start event.
   *
   * @type number
   */
		this.touchStartY = 0;

		/**
   * ID of the last touch, retrieved from Touch.identifier.
   *
   * @type number
   */
		this.lastTouchIdentifier = 0;

		/**
   * Touchmove boundary, beyond which a click will be cancelled.
   *
   * @type number
   */
		this.touchBoundary = options.touchBoundary || 10;

		/**
   * The FastClick layer.
   *
   * @type Element
   */
		this.layer = layer;

		/**
   * The minimum time between tap(touchstart and touchend) events
   *
   * @type number
   */
		this.tapDelay = options.tapDelay || 200;

		/**
   * The maximum time for a tap
   *
   * @type number
   */
		this.tapTimeout = options.tapTimeout || 700;

		if (FastClick.notNeeded(layer)) {
			return;
		}

		// Some old versions of Android don't have Function.prototype.bind
		function bind(method, context) {
			return function () {
				return method.apply(context, arguments);
			};
		}

		var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
		var context = this;
		for (var i = 0, l = methods.length; i < l; i++) {
			context[methods[i]] = bind(context[methods[i]], context);
		}

		// Set up event handlers as required
		if (deviceIsAndroid) {
			layer.addEventListener('mouseover', this.onMouse, true);
			layer.addEventListener('mousedown', this.onMouse, true);
			layer.addEventListener('mouseup', this.onMouse, true);
		}

		layer.addEventListener('click', this.onClick, true);
		layer.addEventListener('touchstart', this.onTouchStart, false);
		layer.addEventListener('touchmove', this.onTouchMove, false);
		layer.addEventListener('touchend', this.onTouchEnd, false);
		layer.addEventListener('touchcancel', this.onTouchCancel, false);

		// Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
		// which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
		// layer when they are cancelled.
		if (!Event.prototype.stopImmediatePropagation) {
			layer.removeEventListener = function (type, callback, capture) {
				var rmv = Node.prototype.removeEventListener;
				if (type === 'click') {
					rmv.call(layer, type, callback.hijacked || callback, capture);
				} else {
					rmv.call(layer, type, callback, capture);
				}
			};

			layer.addEventListener = function (type, callback, capture) {
				var adv = Node.prototype.addEventListener;
				if (type === 'click') {
					adv.call(layer, type, callback.hijacked || (callback.hijacked = function (event) {
						if (!event.propagationStopped) {
							callback(event);
						}
					}), capture);
				} else {
					adv.call(layer, type, callback, capture);
				}
			};
		}

		// If a handler is already declared in the element's onclick attribute, it will be fired before
		// FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
		// adding it as listener.
		if (typeof layer.onclick === 'function') {

			// Android browser on at least 3.2 requires a new reference to the function in layer.onclick
			// - the old one won't work if passed to addEventListener directly.
			oldOnClick = layer.onclick;
			layer.addEventListener('click', function (event) {
				oldOnClick(event);
			}, false);
			layer.onclick = null;
		}
	}

	/**
 * Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
 *
 * @type boolean
 */
	var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;

	/**
  * Android requires exceptions.
  *
  * @type boolean
  */
	var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;

	/**
  * iOS requires exceptions.
  *
  * @type boolean
  */
	var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;

	/**
  * iOS 4 requires an exception for select elements.
  *
  * @type boolean
  */
	var deviceIsIOS4 = deviceIsIOS && /OS 4_\d(_\d)?/.test(navigator.userAgent);

	/**
  * iOS 6.0-7.* requires the target element to be manually derived
  *
  * @type boolean
  */
	var deviceIsIOSWithBadTarget = deviceIsIOS && /OS [6-7]_\d/.test(navigator.userAgent);

	/**
  * BlackBerry requires exceptions.
  *
  * @type boolean
  */
	var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;

	/**
  * Determine whether a given element requires a native click.
  *
  * @param {EventTarget|Element} target Target DOM element
  * @returns {boolean} Returns true if the element needs a native click
  */
	FastClick.prototype.needsClick = function (target) {
		switch (target.nodeName.toLowerCase()) {

			// Don't send a synthetic click to disabled inputs (issue #62)
			case 'button':
			case 'select':
			case 'textarea':
				if (target.disabled) {
					return true;
				}

				break;
			case 'input':

				// File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
				if (deviceIsIOS && target.type === 'file' || target.disabled) {
					return true;
				}

				break;
			case 'label':
			case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
			case 'video':
				return true;
		}

		return (/\bneedsclick\b/.test(target.className)
		);
	};

	/**
  * Determine whether a given element requires a call to focus to simulate click into element.
  *
  * @param {EventTarget|Element} target Target DOM element
  * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
  */
	FastClick.prototype.needsFocus = function (target) {
		switch (target.nodeName.toLowerCase()) {
			case 'textarea':
				return true;
			case 'select':
				return !deviceIsAndroid;
			case 'input':
				switch (target.type) {
					case 'button':
					case 'checkbox':
					case 'file':
					case 'image':
					case 'radio':
					case 'submit':
						return false;
				}

				// No point in attempting to focus disabled inputs
				return !target.disabled && !target.readOnly;
			default:
				return (/\bneedsfocus\b/.test(target.className)
				);
		}
	};

	/**
  * Send a click event to the specified element.
  *
  * @param {EventTarget|Element} targetElement
  * @param {Event} event
  */
	FastClick.prototype.sendClick = function (targetElement, event) {
		var clickEvent, touch;

		// On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
		if (document.activeElement && document.activeElement !== targetElement) {
			document.activeElement.blur();
		}

		touch = event.changedTouches[0];

		// Synthesise a click event, with an extra attribute so it can be tracked
		clickEvent = document.createEvent('MouseEvents');
		clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
		clickEvent.forwardedTouchEvent = true;
		targetElement.dispatchEvent(clickEvent);
	};

	FastClick.prototype.determineEventType = function (targetElement) {

		//Issue #159: Android Chrome Select Box does not open with a synthetic click event
		if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
			return 'mousedown';
		}

		return 'click';
	};

	/**
  * @param {EventTarget|Element} targetElement
  */
	FastClick.prototype.focus = function (targetElement) {
		var length;

		// Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
		if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
			length = targetElement.value.length;
			targetElement.setSelectionRange(length, length);
		} else {
			targetElement.focus();
		}
	};

	/**
  * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
  *
  * @param {EventTarget|Element} targetElement
  */
	FastClick.prototype.updateScrollParent = function (targetElement) {
		var scrollParent, parentElement;

		scrollParent = targetElement.fastClickScrollParent;

		// Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
		// target element was moved to another parent.
		if (!scrollParent || !scrollParent.contains(targetElement)) {
			parentElement = targetElement;
			do {
				if (parentElement.scrollHeight > parentElement.offsetHeight) {
					scrollParent = parentElement;
					targetElement.fastClickScrollParent = parentElement;
					break;
				}

				parentElement = parentElement.parentElement;
			} while (parentElement);
		}

		// Always update the scroll top tracker if possible.
		if (scrollParent) {
			scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
		}
	};

	/**
  * @param {EventTarget} targetElement
  * @returns {Element|EventTarget}
  */
	FastClick.prototype.getTargetElementFromEventTarget = function (eventTarget) {

		// On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
		if (eventTarget.nodeType === Node.TEXT_NODE) {
			return eventTarget.parentNode;
		}

		return eventTarget;
	};

	/**
  * On touch start, record the position and scroll offset.
  *
  * @param {Event} event
  * @returns {boolean}
  */
	FastClick.prototype.onTouchStart = function (event) {
		var targetElement, touch, selection;

		// Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
		if (event.targetTouches.length > 1) {
			return true;
		}

		targetElement = this.getTargetElementFromEventTarget(event.target);
		touch = event.targetTouches[0];

		if (deviceIsIOS) {

			// Only trusted events will deselect text on iOS (issue #49)
			selection = window.getSelection();
			if (selection.rangeCount && !selection.isCollapsed) {
				return true;
			}

			if (!deviceIsIOS4) {

				// Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
				// when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
				// with the same identifier as the touch event that previously triggered the click that triggered the alert.
				// Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
				// immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
				// Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
				// which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
				// random integers, it's safe to to continue if the identifier is 0 here.
				if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
					event.preventDefault();
					return false;
				}

				this.lastTouchIdentifier = touch.identifier;

				// If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
				// 1) the user does a fling scroll on the scrollable layer
				// 2) the user stops the fling scroll with another tap
				// then the event.target of the last 'touchend' event will be the element that was under the user's finger
				// when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
				// is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
				this.updateScrollParent(targetElement);
			}
		}

		this.trackingClick = true;
		this.trackingClickStart = event.timeStamp;
		this.targetElement = targetElement;

		this.touchStartX = touch.pageX;
		this.touchStartY = touch.pageY;

		// Prevent phantom clicks on fast double-tap (issue #36)
		if (event.timeStamp - this.lastClickTime < this.tapDelay) {
			event.preventDefault();
		}

		return true;
	};

	/**
  * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
  *
  * @param {Event} event
  * @returns {boolean}
  */
	FastClick.prototype.touchHasMoved = function (event) {
		var touch = event.changedTouches[0],
		    boundary = this.touchBoundary;

		if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
			return true;
		}

		return false;
	};

	/**
  * Update the last position.
  *
  * @param {Event} event
  * @returns {boolean}
  */
	FastClick.prototype.onTouchMove = function (event) {
		if (!this.trackingClick) {
			return true;
		}

		// If the touch has moved, cancel the click tracking
		if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
			this.trackingClick = false;
			this.targetElement = null;
		}

		return true;
	};

	/**
  * Attempt to find the labelled control for the given label element.
  *
  * @param {EventTarget|HTMLLabelElement} labelElement
  * @returns {Element|null}
  */
	FastClick.prototype.findControl = function (labelElement) {

		// Fast path for newer browsers supporting the HTML5 control attribute
		if (labelElement.control !== undefined) {
			return labelElement.control;
		}

		// All browsers under test that support touch events also support the HTML5 htmlFor attribute
		if (labelElement.htmlFor) {
			return document.getElementById(labelElement.htmlFor);
		}

		// If no for attribute exists, attempt to retrieve the first labellable descendant element
		// the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
		return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
	};

	/**
  * On touch end, determine whether to send a click event at once.
  *
  * @param {Event} event
  * @returns {boolean}
  */
	FastClick.prototype.onTouchEnd = function (event) {
		var forElement,
		    trackingClickStart,
		    targetTagName,
		    scrollParent,
		    touch,
		    targetElement = this.targetElement;

		if (!this.trackingClick) {
			return true;
		}

		// Prevent phantom clicks on fast double-tap (issue #36)
		if (event.timeStamp - this.lastClickTime < this.tapDelay) {
			this.cancelNextClick = true;
			return true;
		}

		if (event.timeStamp - this.trackingClickStart > this.tapTimeout) {
			return true;
		}

		// Reset to prevent wrong click cancel on input (issue #156).
		this.cancelNextClick = false;

		this.lastClickTime = event.timeStamp;

		trackingClickStart = this.trackingClickStart;
		this.trackingClick = false;
		this.trackingClickStart = 0;

		// On some iOS devices, the targetElement supplied with the event is invalid if the layer
		// is performing a transition or scroll, and has to be re-detected manually. Note that
		// for this to function correctly, it must be called *after* the event target is checked!
		// See issue #57; also filed as rdar://13048589 .
		if (deviceIsIOSWithBadTarget) {
			touch = event.changedTouches[0];

			// In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
			targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
			targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
		}

		targetTagName = targetElement.tagName.toLowerCase();
		if (targetTagName === 'label') {
			forElement = this.findControl(targetElement);
			if (forElement) {
				this.focus(targetElement);
				if (deviceIsAndroid) {
					return false;
				}

				targetElement = forElement;
			}
		} else if (this.needsFocus(targetElement)) {

			// Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
			// Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
			if (event.timeStamp - trackingClickStart > 100 || deviceIsIOS && window.top !== window && targetTagName === 'input') {
				this.targetElement = null;
				return false;
			}

			this.focus(targetElement);
			this.sendClick(targetElement, event);

			// Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
			// Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
			if (!deviceIsIOS || targetTagName !== 'select') {
				this.targetElement = null;
				event.preventDefault();
			}

			return false;
		}

		if (deviceIsIOS && !deviceIsIOS4) {

			// Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
			// and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
			scrollParent = targetElement.fastClickScrollParent;
			if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
				return true;
			}
		}

		// Prevent the actual click from going though - unless the target node is marked as requiring
		// real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
		if (!this.needsClick(targetElement)) {
			event.preventDefault();
			this.sendClick(targetElement, event);
		}

		return false;
	};

	/**
  * On touch cancel, stop tracking the click.
  *
  * @returns {void}
  */
	FastClick.prototype.onTouchCancel = function () {
		this.trackingClick = false;
		this.targetElement = null;
	};

	/**
  * Determine mouse events which should be permitted.
  *
  * @param {Event} event
  * @returns {boolean}
  */
	FastClick.prototype.onMouse = function (event) {

		// If a target element was never set (because a touch event was never fired) allow the event
		if (!this.targetElement) {
			return true;
		}

		if (event.forwardedTouchEvent) {
			return true;
		}

		// Programmatically generated events targeting a specific element should be permitted
		if (!event.cancelable) {
			return true;
		}

		// Derive and check the target element to see whether the mouse event needs to be permitted;
		// unless explicitly enabled, prevent non-touch click events from triggering actions,
		// to prevent ghost/doubleclicks.
		if (!this.needsClick(this.targetElement) || this.cancelNextClick) {

			// Prevent any user-added listeners declared on FastClick element from being fired.
			if (event.stopImmediatePropagation) {
				event.stopImmediatePropagation();
			} else {

				// Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
				event.propagationStopped = true;
			}

			// Cancel the event
			event.stopPropagation();
			event.preventDefault();

			return false;
		}

		// If the mouse event is permitted, return true for the action to go through.
		return true;
	};

	/**
  * On actual clicks, determine whether this is a touch-generated click, a click action occurring
  * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
  * an actual click which should be permitted.
  *
  * @param {Event} event
  * @returns {boolean}
  */
	FastClick.prototype.onClick = function (event) {
		var permitted;

		// It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
		if (this.trackingClick) {
			this.targetElement = null;
			this.trackingClick = false;
			return true;
		}

		// Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
		if (event.target.type === 'submit' && event.detail === 0) {
			return true;
		}

		permitted = this.onMouse(event);

		// Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
		if (!permitted) {
			this.targetElement = null;
		}

		// If clicks are permitted, return true for the action to go through.
		return permitted;
	};

	/**
  * Remove all FastClick's event listeners.
  *
  * @returns {void}
  */
	FastClick.prototype.destroy = function () {
		var layer = this.layer;

		if (deviceIsAndroid) {
			layer.removeEventListener('mouseover', this.onMouse, true);
			layer.removeEventListener('mousedown', this.onMouse, true);
			layer.removeEventListener('mouseup', this.onMouse, true);
		}

		layer.removeEventListener('click', this.onClick, true);
		layer.removeEventListener('touchstart', this.onTouchStart, false);
		layer.removeEventListener('touchmove', this.onTouchMove, false);
		layer.removeEventListener('touchend', this.onTouchEnd, false);
		layer.removeEventListener('touchcancel', this.onTouchCancel, false);
	};

	/**
  * Check whether FastClick is needed.
  *
  * @param {Element} layer The layer to listen on
  */
	FastClick.notNeeded = function (layer) {
		var metaViewport;
		var chromeVersion;
		var blackberryVersion;
		var firefoxVersion;

		// Devices that don't support touch don't need FastClick
		if (typeof window.ontouchstart === 'undefined') {
			return true;
		}

		// Chrome version - zero for other browsers
		chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1];

		if (chromeVersion) {

			if (deviceIsAndroid) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// Chrome 32 and above with width=device-width or less don't need FastClick
					if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}

				// Chrome desktop doesn't need FastClick (issue #15)
			} else {
				return true;
			}
		}

		if (deviceIsBlackBerry10) {
			blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);

			// BlackBerry 10.3+ does not require Fastclick library.
			// https://github.com/ftlabs/fastclick/issues/251
			if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// user-scalable=no eliminates click delay.
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// width=device-width (or less than device-width) eliminates click delay.
					if (document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}
			}
		}

		// IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
		if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		// Firefox version - zero for other browsers
		firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1];

		if (firefoxVersion >= 27) {
			// Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896

			metaViewport = document.querySelector('meta[name=viewport]');
			if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
				return true;
			}
		}

		// IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
		// http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
		if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		return false;
	};

	/**
  * Factory method for creating a FastClick object
  *
  * @param {Element} layer The layer to listen on
  * @param {Object} [options={}] The options to override the defaults
  */
	FastClick.attach = function (layer, options) {
		return new FastClick(layer, options);
	};

	window.FastClick = FastClick;

	module.exports = FastClick;
	// if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) {

	// 	// AMD. Register as an anonymous module.
	// 	define(function() {
	// 		return FastClick;
	// 	});
	// } else if (typeof module !== 'undefined' && module.exports) {
	// 	module.exports = FastClick.attach;
	// 	module.exports.FastClick = FastClick;
	// } else {
	// 	window.FastClick = FastClick;
	// }
})();

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 活动信息
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _http = __webpack_require__(3);

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Activity = function () {
    function Activity() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$url = _ref.url,
            url = _ref$url === undefined ? '' : _ref$url;

        _classCallCheck(this, Activity);

        this.url = url;
        this.actData = {}; // 存储用户信息 {活动ID：活动信息}
    }

    _createClass(Activity, [{
        key: 'getData',
        value: function getData() {
            var _this = this;

            var promise = $.Deferred();
            var params = {};

            var promiseGetData = _http2.default.fetch({
                url: this.url
            });

            promiseGetData.done(function (res) {
                if (res.errcode == 0) {
                    _this.parseData(res.data);
                    promise.resolve(_this.actData);
                } else {
                    promise.reject();
                }
            });

            promiseGetData.fail(function () {
                promise.reject();
            });

            return promise;
        }
    }, {
        key: 'parseData',
        value: function parseData(data) {
            var _this2 = this;

            if (data.list) {
                data.list.forEach(function (item, index) {
                    if (!_this2.actData[item.id]) {
                        item.serverTime = data.serverTime;
                        _this2.actData[item.id] = _this2.parseActData(item);
                    }
                });
            } else {
                this.actData[data.id] = this.parseActData(data);
            }
        }
    }, {
        key: 'parseActData',
        value: function parseActData(data) {
            var self = this;
            var today = data.serverTime;
            var gift = data.gift;
            var giftMap = {};
            var zb = data.periodList[0];
            var rb = data.periodList.slice(1);

            var currentDay = void 0;

            for (var i = gift.length - 1; i >= 0; i--) {
                var item = gift[i];

                if (!giftMap[item.id]) {
                    giftMap[item.id] = item;
                }
            }

            data.giftMap = giftMap;
            data.overallRanking = zb;
            data.dailyRanking = rb;

            if (rb.length > 0) {
                // 总榜 + 日榜
                rb.forEach(function (item, index) {
                    item.index = index;
                    item.name = 'day' + (index + 1);

                    if (today >= item.startTime && today < item.endTime) {
                        currentDay = item;
                    }
                });

                if (currentDay) {
                    // 活动期间
                    data.currentDay = currentDay;
                    data.status = 1;
                } else {
                    // 活动未开始。第一天
                    if (today < rb[0].startTime) {
                        data.currentDay = rb[0];
                        data.status = 0;
                    } else if (today > rb[rb.length - 1].endTime) {
                        // 活动已结束。最后一天
                        data.currentDay = rb[rb.length - 1];
                        data.status = 2;
                    }
                }
            } else {
                // 仅总榜
                if (today < zb.startTime) {
                    // 活动未开始
                    data.status = 0;
                } else if (today > zb.endTime) {
                    data.status = 2;
                } else {
                    data.status = 1;
                }
            }

            return data;
        }
    }]);

    return Activity;
}();

module.exports = Activity;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * 榜单列表
 * data-threshold优先级高于实例化时候传入的统一配置参数。
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {
    var RankList = __webpack_require__(2);
    var ItemTpl = __webpack_require__(50);

    var HostList = RankList.extend({
        defaults: {
            wrap: '#J-HostList',
            itemTpl: ItemTpl,
            getListData: function getListData(data) {
                return data.list || [];
            }
        },

        initialize: function initialize() {
            var self = this;

            self.Parent.apply(self, arguments);

            self.set('url', UpAct.CONFIG.board());

            self.acidInfo = self.get("acidInfo");

            self.actInfo = UpAct.actData[self.acid];

            self.set('initParams', { area: self.acidInfo.areaCode });
        },


        formatResult: function formatResult(res) {
            if (res.errcode === 0) {
                return {
                    code: "SC_SUCCESS",
                    data: res.data
                };
            } else {
                return {
                    code: "",
                    data: {}
                };
            }
            return res;
        }
    });

    UpAct.HostList = HostList;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<li>\n	<div class="item host-item ';
 if(data.index%2){
__p+='odd';
}
__p+='" data-rank="'+
((__t=(data.index))==null?'':__t)+
'">\n		<div class="main">\n			<div class="rank">'+
((__t=(data.index))==null?'':__t)+
'</div>\n			<div class="user">\n	            <div class="avatar">\n	            	<span class="ui-img ui-circle" node-id="profile" data-uid="'+
((__t=(data.uid))==null?'':__t)+
'">\n	            		<img node-id="img" data-src="'+
((__t=(data.avatar))==null?'':__t)+
'" data-size="42"/>\n	            	</span>\n	            	';
if(data.status ==1){
__p+='\n		              <div class="show" node-id="liveRoom"  data-uid="'+
((__t=(data.uid))==null?'':__t)+
'" data-rid="'+
((__t=(data.roomid))==null?'':__t)+
'">\n		              	<span></span>\n		              	<span></span>\n		              </div>\n		         	';
}
__p+='\n	            </div>\n	            <div class="info">\n	                <dl>\n	                  	<dd class="nickname">\n	                  		<span>'+
((__t=(data.username))==null?'':__t)+
'</span>\n	                  		<div class="ui-gender" data-gender="'+
((__t=(data.gender))==null?'':__t)+
'"></div>\n	                  		<div class="ui-grade" node-id="grade" data-grade="'+
((__t=(data.grade))==null?'':__t)+
'"></div>\n	                  	</dd>\n	                  	';
if(data.upliveCode){
__p+='\n	                  	<dd class="uplive-code">\n	                    	'+
((__t=(UpAct.lang.template('Up号:{code}',{code:data.upliveCode})))==null?'':__t)+
'\n	                  	</dd>\n	                  	';
 }
__p+='\n	                  	<dd class="giftcount">\n	                    	'+
((__t=(UpAct.lang.template('总u币数:{count}', {count: UpAct.NumberUtil.separate(data.giftPoint, ',')}) ))==null?'':__t)+
'\n	                  	</dd>\n	                </dl>\n	            </div>\n	        </div>\n	        \n	    </div>\n	    \n	    <div class="extend">\n	    	\n	    	<div class="gift" node-id="xxx">\n	    		';

					_.each(UpAct.actData[acid].gift,function(item,index){
				
__p+='\n					<div class="gift-info" >\n		    			<span class="gift-pic"><img src="'+
((__t=(item.image))==null?'':__t)+
'" /></span>\n		    			<span class="gift-name">x'+
((__t=(data.giftInfo[index].giftCount ))==null?'':__t)+
'</span>\n		    		</div>\n				\n				';
	
				})
		    	
__p+='\n	    		\n	    	</div>\n	    	\n	    </div>\n	    \n	</div>\n</li>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * 榜单列表
 * data-threshold优先级高于实例化时候传入的统一配置参数。
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {
    var RankList = __webpack_require__(2);
    var ItemTmpl = __webpack_require__(52);

    var emptyItemTmpl = __webpack_require__(53);

    var HostList = RankList.extend({
        defaults: {
            wrap: '#J-HostList',
            itemTpl: ItemTmpl
        },

        initialize: function initialize() {
            var self = this;

            self.Parent.apply(self, arguments);
            this.set('initParams', { eventType: 'max' });
            self.set('url', UpAct.CONFIG.getReachList());
            self.set('itemEmptyTpl', emptyItemTmpl);
        }
    });

    UpAct.ReachList = HostList;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<li>\n	<div class="item reach-item ';
 if(data.index%2){
__p+='odd';
}
__p+='" data-rank="'+
((__t=(data.index))==null?'':__t)+
'">\n		<div class="main">\n			<div class="rank">'+
((__t=(data.index))==null?'':__t)+
'</div>\n			<div class="user">\n	            <div class="avatar">\n	            	<span class="ui-img ui-circle" node-id="profile" data-uid="'+
((__t=(data.uid))==null?'':__t)+
'">\n	            		<img node-id="img" data-src="'+
((__t=(data.avatar))==null?'':__t)+
'" data-size="42"/>\n	            	</span>\n	            	';
if(data.showStatus ==1){
__p+='\n		              <div class="show" node-id="liveRoom"  data-uid="'+
((__t=(data.uid))==null?'':__t)+
'" data-rid="'+
((__t=(data.roomId))==null?'':__t)+
'">\n		              	<span></span>\n		              	<span></span>\n		              </div>\n		         	';
}
__p+='\n	            </div>\n	            <div class="info">\n	                <dl>\n	                  	<dd class="nickname">\n	                  		<span>'+
((__t=(data.username))==null?'':__t)+
'</span>\n	                  		<div class="ui-gender" data-gender="'+
((__t=(data.gender))==null?'':__t)+
'"></div>\n	                  		<div class="ui-grade" node-id="grade" data-grade="'+
((__t=(data.grade))==null?'':__t)+
'"></div>\n	                  	</dd>\n	                  	';
if(data.upLiveCode){
__p+='\n	                  	<dd class="uplive-code">\n	                    	'+
((__t=(UpAct.lang.template('Up号:{code}',{code:data.upLiveCode})))==null?'':__t)+
'\n	                  	</dd>\n	                  	';
 }
__p+='\n	                </dl>\n	            </div>\n	        </div>\n	    </div>\n	    <div class="extend">\n	    	'+
((__t=(UpAct.lang.template('总u币数:{count}', {count: UpAct.NumberUtil.separate(data.giftBill, ',')}) ))==null?'':__t)+
'\n	    </div>\n	</div>\n</li>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<li>\n	<div class="item empty-item ';
 if(data.index%2){
__p+='odd';
}
__p+='" data-rank="'+
((__t=(data.index))==null?'':__t)+
'">\n		<div class="main">\n			<div class="rank">'+
((__t=(data.index))==null?'':__t)+
'</div>\n			<div class="user">\n	            <div class="avatar">\n	            	<span class="ui-img ui-circle" node-id="profile" >?\n	            	</span>\n	            </div>\n	            <div class="info">\n	                <dl>\n	                  	<dd class="giftcount">\n	                    	'+
((__t=(UpAct.lang.template("虚位以待")))==null?'':__t)+
'\n	                  	</dd>\n	                </dl>\n	            </div>\n	        </div>\n	    </div>\n\n	</div>\n</li>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * 榜单列表
 * data-threshold优先级高于实例化时候传入的统一配置参数。
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {
    var RankList = __webpack_require__(2);
    var ItemTpl = __webpack_require__(55);
    var tipTpl = __webpack_require__(56);

    var GalaPop = __webpack_require__(5);

    var HostList = RankList.extend({
        defaults: {
            wrap: '#J-SendHostList',
            itemTpl: ItemTpl,
            getListData: function getListData(data) {
                return data.list || [];
            }
        },

        initialize: function initialize() {
            var self = this;

            self.Parent.apply(self, arguments);

            self.set('url', UpAct.CONFIG.board());

            self.acidInfo = self.get("acidInfo");

            self.actInfo = UpAct.actData[self.acid];

            self.set('initParams', { area: self.acidInfo.areaCode });

            self.getAreaIndex();

            self.selectedInfo = UpAct.CONFIG.acidConfig.acid[self.selectedAreaIndex];

            self.renderTip(self.selectedInfo.uniqueId, self.selectedInfo.text);

            this.bindSendEvent();
        },
        renderTip: function renderTip(code, name) {

            var self = this;

            var wrap = $(self.get('wrap').find(".list-wrap .content"));
            wrap.prepend(tipTpl({
                areaName: name
            }));
        },
        getAreaIndex: function getAreaIndex() {

            var self = this;

            console.log("vewfw");

            $.each(UpAct.CONFIG.acidConfig.acid, function (index, items) {
                if (items.uniqueId.indexOf(self.acidInfo["uniqueId"].split("-")[0]) > -1) {
                    self.selectedAreaIndex = index;
                }
            });
        },
        bindSendEvent: function bindSendEvent() {
            var self = this;
            var wrap = $(self.get('wrap').find(".list-wrap .content"));

            console.log("vaewnor");
            wrap.delegate(".cf-tip-btn", "click", function () {
                var pop = new GalaPop({
                    title: UpAct.lang.areaTemplate(self.selectedInfo.uniqueId, '财富奖励标题'),
                    context: UpAct.lang.areaTemplate(self.selectedInfo.uniqueId, '财富榜奖励') + (self.selectedInfo.uniqueId === 'zhtw' ? '<div class="rule-gift2"><img src="' + __webpack_require__(11) + '"></div>' : ''),

                    //btnContext: ,
                    onCreate: function onCreate(el, popup, gala) {
                        el.addClass('widget-poplayer-rule');
                    },
                    onClose: function onClose(el) {}
                });

                pop.create();
            });
        },


        formatResult: function formatResult(res) {
            if (res.errcode === 0) {
                return {
                    code: "SC_SUCCESS",
                    data: res.data
                };
            } else {
                return {
                    code: "",
                    data: {}
                };
            }
            return res;
        }
    });

    UpAct.SendHostList = HostList;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<li>\n	<div class="item send-host-item" data-rank="'+
((__t=(data.index))==null?'':__t)+
'">\n		<div class="main">\n			<div class="rank">'+
((__t=(data.index))==null?'':__t)+
'</div>\n			<div class="user">\n	            <div class="avatar">\n	            	<span class="ui-img ui-circle" node-id="profile" data-uid="'+
((__t=(data.uid))==null?'':__t)+
'">\n	            		<img node-id="img" data-src="'+
((__t=(data.avatar))==null?'':__t)+
'" data-size="42"/>\n	            	</span>\n	            	';
if(data.showStatus ==1){
__p+='\n		              <div class="show" node-id="liveRoom"  data-uid="'+
((__t=(data.uid))==null?'':__t)+
'" data-rid="'+
((__t=(data.roomId))==null?'':__t)+
'">\n		              	<span></span>\n		              	<span></span>\n		              </div>\n		         	';
}
__p+='\n	            </div>\n	            <div class="info">\n	                <dl>\n	                  	<dd class="nickname">\n	                  		<span>'+
((__t=(data.username))==null?'':__t)+
'</span>\n	                  	</dd>\n	                  	<dd>\n	                  		<div class="ui-gender" data-gender="'+
((__t=(data.gender))==null?'':__t)+
'"></div>\n	                  		<div class="ui-grade" node-id="grade" data-grade="'+
((__t=(data.grade))==null?'':__t)+
'"></div>\n	                  	</dd>\n	                  	';
if(data.upliveCode){
__p+='\n	                  	<dd class="uplive-code">\n	                    	'+
((__t=(UpAct.lang.template('Up号:{code}',{code:data.upliveCode})))==null?'':__t)+
'\n	                  	</dd>\n	                  	';
 }
__p+='                 	\n	                </dl>\n	            </div>\n	        </div>\n	        \n	    </div>\n	    \n	    <div class="extend">\n	    	\n	    	<div class="gift" node-id="xxx">\n	    		';

					_.each(UpAct.actData[acid].gift,function(item,index){
				
__p+='\n					<div class="gift-info" >\n		    			<span class="gift-pic"><img src="'+
((__t=(item.image))==null?'':__t)+
'" /></span>\n		    			<span class="gift-name">x'+
((__t=(data.giftInfo[index].giftCount ))==null?'':__t)+
'</span>\n		    		</div>\n				';
	
					})
		    	
__p+='\n	    		\n	    	</div>\n	    	\n	    </div>\n	    \n	</div>\n</li>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="cf-tip">\n	<p>'+
((__t=( UpAct.lang.template('财富榜解释文案{area}',{area: UpAct.lang.template(areaName)},1) ))==null?'':__t)+
'</p>\n	<div class="cf-tip-btn">'+
((__t=( UpAct.lang.template('财富榜规则按钮{area}',{area: UpAct.lang.template(areaName)},1) ))==null?'':__t)+
'</div>\n</div>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * 守护榜
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    var Base = __webpack_require__(1);
    var http = __webpack_require__(3);
    var itemTpl = __webpack_require__(58);
    var itemEmptyTpl = __webpack_require__(59);

    var SendUserList = Base.extend({
        defaults: {
            wrap: '#J-SendUserList',
            content: '[node-id=list]',
            loading: '[node-id=loading]',
            itemEmptyTpl: itemEmptyTpl,
            itemTpl: itemTpl,
            minSize: 3
        },

        initialize: function initialize() {
            var self = this;
            self.Parent.apply(self, arguments);

            var nodeWrap = this.nodeWrap = $(this.get('wrap'));
            var nodeContent = this.nodeContent = nodeWrap.find(this.get('content'));

            this.nodeLoading = nodeWrap.find(this.get('loading'));
            this.nodeError = nodeWrap.find(this.get('error'));
            this.nodeEmpty = nodeWrap.find(this.get('empty'));

            var params = nodeContent.data('params');

            if (params) {
                this.params = eval("(" + params + ")");
                this.acid = this.params.eventId.split(':')[0];
            }

            this.minSize = nodeContent.data('minsize') || this.get('minSize');

            this._showLoading();

            return this;
        },

        render: function render() {
            UpAct.loading.show();
            this.loadData();

            return this;
        },
        refresh: function refresh() {
            UpAct.loading.show();
            this.loadData();
        },
        loadData: function loadData() {
            var _this = this;

            var self = this;

            var promise = http.fetch({
                url: UpAct.CONFIG.getSendUserList(),
                data: this.params
            });

            promise.done(function (res) {
                if (res.code == "SC_SUCCESS") {
                    self.emit('success', res.data.user);
                    self.renderUI(res.data.user);
                }
                UpAct.loading.hide();
                _this._hideLoading();
            });
        },


        renderUI: function renderUI(data) {

            this.data = data;

            this.renderList(data.sendList);

            UpAct.img();
            UpAct.grade();
        },
        /**
         * 渲染列表内容
         * @param data 数据
         * @param append 是否插入到列表中
         */
        renderList: function renderList(data) {
            var self = this;
            var pageCount = this.pageCount;
            var nodeList = $('<ul>');
            var itemTpl = this.get('itemTpl');
            var itemEmptyTpl = this.get('itemEmptyTpl');
            var dataNum = data.length;

            $.each(data, function (i, item) {
                item.index = i + 1;

                var nodeItem = itemTpl({
                    data: item,
                    acid: self.acid
                });
                if (nodeItem) {
                    nodeList.append(nodeItem);
                }
            });

            if (dataNum < this.minSize) {
                for (var i = 0; i < this.minSize - dataNum; i++) {
                    var nodeItem = itemEmptyTpl({
                        data: {
                            index: i + dataNum + 1
                        }
                    });
                    if (nodeItem) {
                        nodeList.append(nodeItem);
                    }
                }
            }

            this.nodeContent.html(nodeList);
        },

        /**
         * 显示loading
         */
        _showLoading: function _showLoading() {
            if (this.nodeLoading) {
                this.nodeLoading.removeClass('hidden');
            }
        },
        /**
         * 隐藏loading
         */
        _hideLoading: function _hideLoading() {
            if (this.nodeLoading) {
                this.nodeLoading.addClass('hidden');
            }
        }
    });

    UpAct.SendUserList = SendUserList;

    module.exports = SendUserList;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<li class="item send-item" data-rank="'+
((__t=(data.index))==null?'':__t)+
'">\n	<div class="main">\n		<div class="rank">'+
((__t=(data.index))==null?'':__t)+
'</div>\n		<div class="user">\n            <div class="avatar">\n            	<span class="ui-img ui-circle" node-id="profile" data-country="'+
((__t=(data.countryCode))==null?'':__t)+
'" data-uid="'+
((__t=(data.uid))==null?'':__t)+
'">\n            		<img node-id="img" data-src="'+
((__t=(data.avatar))==null?'':__t)+
'" data-size="42"/>\n            	</span>\n            </div>\n            <div class="info">\n                <dl>\n                  	\n                    <dd class="nickname">\n	                  		'+
((__t=(data.username))==null?'':__t)+
'\n	                </dd>\n                  	<dd>\n                  		<div class="ui-gender" data-gender="'+
((__t=(data.gender))==null?'':__t)+
'"></div>\n                  		<div class="ui-grade" node-id="grade" data-grade="'+
((__t=(data.grade))==null?'':__t)+
'"></div>\n                  	</dd>\n              	\n                  	<dd class="giftcount">\n                    	'+
((__t=(UpAct.lang.template('贡献值:{count}', {count: UpAct.NumberUtil.separate(data.giftPoint, ',')}) ))==null?'':__t)+
'\n                  	</dd>\n                </dl>\n            </div>\n        </div>\n    </div>\n\n</li>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<li>\n	<div class="item send-item empty-item" data-rank="'+
((__t=(data.index))==null?'':__t)+
'">\n		<div class="main">\n			<div class="rank">'+
((__t=(data.index))==null?'':__t)+
'</div>\n			<div class="user">\n	            <div class="avatar">\n	            	<span class="ui-img ui-circle" node-id="profile" >?\n	            	</span>\n	            </div>\n	            <div class="info">\n	                <dl>\n	                  	<dd class="giftcount">\n	                    	'+
((__t=(UpAct.lang.template("虚位以待")))==null?'':__t)+
'\n	                  	</dd>\n	                </dl>\n	            </div>\n	        </div>\n	    </div>\n\n	</div>\n</li>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * 榜单列表
 * data-threshold优先级高于实例化时候传入的统一配置参数。
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {
    var RankList = __webpack_require__(2);

    var HostList = RankList.extend({
        defaults: {
            wrap: '#J-HostList'
        },

        initialize: function initialize() {
            var self = this;

            self.Parent.apply(self, arguments);

            self.set('url', UpAct.CONFIG.getEarlestReachList());
        },
        formatResult: function formatResult(res) {
            var endRes = {};
            if (res.errcode == 0) {
                endRes.code = 'SC_SUCCESS';
                endRes.data = res.data;
            } else {
                endRes.code = res.errcode;
            }
            return endRes;
        }
    });

    UpAct.SuDuList = HostList;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * 榜单列表
 * data-threshold优先级高于实例化时候传入的统一配置参数。
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {
    var RankList = __webpack_require__(2);
    var ItemTpl = __webpack_require__(62);

    var HostList = RankList.extend({
        defaults: {
            wrap: '#J-HostList',
            itemTpl: ItemTpl,
            getListData: function getListData(data) {
                return data.list || [];
            }
        },

        initialize: function initialize() {
            var self = this;

            self.Parent.apply(self, arguments);

            self.set('url', UpAct.CONFIG.getDurationList());
        },
        formatResult: function formatResult(res) {
            var endRes = {};
            if (res.errcode == 0) {
                endRes.code = 'SC_SUCCESS';
                endRes.data = res.data;
            } else {
                endRes.code = res.errcode;
            }
            return endRes;
        }
    });

    UpAct.DurationList = HostList;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

	var timenum = parseInt(data.rankingCount)

__p+='\n<li>\n	<div class="item duration-item ';
 if(data.index%2){
__p+='odd';
}
__p+='" data-rank="'+
((__t=(data.index))==null?'':__t)+
'">\n		<div class="main">\n			<div class="rank">'+
((__t=(data.index))==null?'':__t)+
'</div>\n			<div class="user">\n	            <div class="avatar">\n	            	<span class="ui-img ui-circle" node-id="profile" data-uid="'+
((__t=(data.uid))==null?'':__t)+
'">\n	            		<img node-id="img" data-src="'+
((__t=(data.avatar))==null?'':__t)+
'" data-size="42"/>\n	            	</span>\n	            	';
if(data.showStatus ==1){
__p+='\n		              <div class="show" node-id="liveRoom"  data-uid="'+
((__t=(data.uid))==null?'':__t)+
'" data-rid="'+
((__t=(data.roomId))==null?'':__t)+
'">\n		              	<span></span>\n		              	<span></span>\n		              </div>\n		         	';
}
__p+='\n	            </div>\n	            <div class="info">\n	                <dl>\n	                  	<dd class="nickname">\n	                  		'+
((__t=(data.username))==null?'':__t)+
'\n	                  	</dd>\n	                  	<dd>\n	                  		<div class="ui-gender" data-gender="'+
((__t=(data.gender))==null?'':__t)+
'"></div>\n	                  		<div class="ui-grade" node-id="grade" data-grade="'+
((__t=(data.grade))==null?'':__t)+
'"></div>\n	                  	</dd>\n	                  	\n	                  	\n	                  	<dd class="giftcount">\n	                    	'+
((__t=(UpAct.lang.template('开播时长{count}', {count: UpAct.NumberUtil.separate(timenum, ',')}) ))==null?'':__t)+
'\n	                  	</dd>\n	                </dl>\n	            </div>\n	        </div>\n	        \n	    </div>\n	    \n	</div>\n</li>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * 购买守护真爱榜单列表
 * data-threshold优先级高于实例化时候传入的统一配置参数。
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {
    var RankList = __webpack_require__(2);
    var itemTpl = __webpack_require__(64);
    var emptyTpl = __webpack_require__(65);

    var HostList = RankList.extend({
        defaults: {
            wrap: '#J-HostList',
            itemTpl: itemTpl,
            itemEmptyTpl: emptyTpl
        },

        initialize: function initialize() {
            var self = this;
            this.set('itemEmptyTpl', emptyTpl);
            self.Parent.apply(self, arguments);

            self.set('url', UpAct.CONFIG.getTrueLoveList());
        }
    });

    UpAct.TrueLoveList = HostList;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

	var sendUser = data.rUser;

__p+='\n\n<li>\n	<div class="item truelove-item" data-rank="'+
((__t=(data.index))==null?'':__t)+
'">\n		\n		<div class="user host">\n	        <div class="avatar">\n	            <span class="ui-img ui-circle" node-id="profile" data-uid="'+
((__t=(data.uid))==null?'':__t)+
'">\n            		<img node-id="img" data-src="'+
((__t=(data.avatar))==null?'':__t)+
'" data-size="42"/>\n            	</span>\n	            ';
if(data.showStatus ==1){
__p+='\n	             <i class="uplived" node-id="liveroom" data-uid="'+
((__t=(data.uid ))==null?'':__t)+
'" data-country="'+
((__t=(data.countryCode))==null?'':__t)+
'" data-roomid="'+
((__t=(data.roomId ))==null?'':__t)+
'"></i>\n	          ';
}
__p+='\n	        </div>\n	        <div class="info">\n            	<dl>\n                  	<dd class="nickname">\n                  		'+
((__t=(data.username))==null?'':__t)+
'\n                  	</dd>\n                  	\n                  	<dd class="giftcount">\n                    	'+
((__t=(UpAct.lang.template('U钻数量:{count}', {count: UpAct.NumberUtil.separate(data.diamond, ',')}) ))==null?'':__t)+
'\n                  	</dd>\n                </dl>\n	        </div>\n	    </div> \n	    \n	    <div class="user sender">\n	        <div class="avatar">\n	        	<span class="ui-img ui-circle" node-id="profile" data-uid="'+
((__t=(data.rUser.uid))==null?'':__t)+
'">\n	        		<img node-id="img" data-src="'+
((__t=(data.rUser.avatar))==null?'':__t)+
'" data-size="42"/>\n	        	</span>\n	        </div>\n	        <div class="info">\n	            <dl>\n	                <dd class="nickname">\n	                    '+
((__t=(sendUser.username))==null?'':__t)+
'\n	                </dd>\n	                <dd>\n	                    <div class="ui-gender" data-gender="'+
((__t=(sendUser.gender))==null?'':__t)+
'"></div>\n	                    <div class="ui-grade" node-id="grade" data-grade="'+
((__t=(sendUser.grade))==null?'':__t)+
'"></div>\n	                </dd>\n	                <dd class="giftcount">\n	                    '+
((__t=(UpAct.lang.template('总u钻数:{count}', {count: UpAct.NumberUtil.separate(sendUser.giftDiamond, ',')}) ))==null?'':__t)+
'\n	                </dd>\n	            </dl>\n	        </div>\n	    </div>\n	</div>\n</li>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<li>\n	<div class="item truelove-item  peidui" data-rank="'+
((__t=(data.index))==null?'':__t)+
'">\n		\n	    <div class="user empty-item">\n	        <div class="avatar">\n	            <span class="ui-img ui-circle" node-id="profile" >?</span>\n	        </div>\n	        <div class="info">\n	            <dl>\n	                <dd class="giftcount">\n	                    '+
((__t=(UpAct.lang.template("虚位以待")))==null?'':__t)+
'\n	                </dd>\n	            </dl>\n	        </div>\n	    </div>\n	    <div class="user send-user empty-item ">\n	        <div class="avatar">\n	            <span class="ui-img ui-circle" node-id="profile" >?</span>\n	        </div>\n	        <div class="info">\n	            <dl>\n	                <dd class="giftcount">\n	                    '+
((__t=(UpAct.lang.template("虚位以待")))==null?'':__t)+
'\n	                </dd>\n	            </dl>\n	        </div>\n	    </div>\n	</div>\n</li>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * 榜单列表
 * data-threshold优先级高于实例化时候传入的统一配置参数。
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {
    var RankList = __webpack_require__(2);
    var ItemTpl = __webpack_require__(67);

    var HostList = RankList.extend({
        defaults: {
            wrap: '#J-HostList',
            itemTpl: ItemTpl
        },

        initialize: function initialize() {
            var self = this;

            self.Parent.apply(self, arguments);

            self.set('url', UpAct.CONFIG.getGiftGatherList());
        }
    });

    UpAct.GiftGatherList = HostList;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<li>\n	<div class="item gift-gather-item" data-rank="'+
((__t=(data.index))==null?'':__t)+
'">\n		<div class="main">\n			<div class="rank">'+
((__t=(data.index))==null?'':__t)+
'</div>\n			<div class="user">\n	            <div class="avatar">\n	            	<span class="ui-img ui-circle" node-id="profile" data-uid="'+
((__t=(data.uid))==null?'':__t)+
'">\n	            		<img node-id="img" data-src="'+
((__t=(data.avatar))==null?'':__t)+
'" data-size="42"/>\n	            	</span>\n	            	';
if(data.showStatus ==1){
__p+='\n		              <div class="show" node-id="liveRoom"  data-uid="'+
((__t=(data.uid))==null?'':__t)+
'" data-rid="'+
((__t=(data.roomId))==null?'':__t)+
'">\n		              	<span></span>\n		              	<span></span>\n		              </div>\n		         	';
}
__p+='\n	            </div>\n	            <div class="info">\n	                <dl>\n	                  	<dd class="nickname">\n	                  		'+
((__t=(data.nickname))==null?'':__t)+
'\n	                  	</dd>\n	                  	<dd>\n	                  		<div class="ui-gender" data-gender="'+
((__t=(data.gender))==null?'':__t)+
'"></div>\n	                  		<div class="ui-grade" node-id="grade" data-grade="'+
((__t=(data.uplevel))==null?'':__t)+
'"></div>\n	                  	</dd>\n	                  	\n	                  	<dd class="giftcount">\n	                    	'+
((__t=(UpAct.lang.template('总U币数:{count}', {count: UpAct.NumberUtil.separate(data.giftBill, ',')}) ))==null?'':__t)+
'\n	                  	</dd>\n	                  	<dd class="giftcount">\n	                    	'+
((__t=(UpAct.lang.template('总套数:{count}', {count: UpAct.NumberUtil.separate(data.giftCount, ',')}) ))==null?'':__t)+
'\n	                  	</dd>\n	                </dl>\n	            </div>\n	        </div>\n	        \n	    </div>\n	    \n	    <div class="extend">\n	    	\n	    	<div class="gift" node-id="xxx">\n	    		';

					_.each(UpAct.actData[acid].gift,function(item,index){
				
__p+='\n					<div class="gift-info" >\n		    			<span class="gift-pic"><img src="'+
((__t=(item.image))==null?'':__t)+
'" /></span>\n		    			<span class="gift-name">'+
((__t=(data.gifts[item.id] ))==null?'':__t)+
'</span>\n		    		</div>\n				\n				';
	
				})
		    	
__p+='\n	    		\n	    	</div>\n	    	\n	    </div>\n	    \n	</div>\n</li>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));


/***/ }),
/* 68 */
/***/ (function(module, exports) {

/**
 * 活动配置信息
 */

var areaCode = {
    中东: "MSL",
    大陆: "CN",
    台湾: "TW",
    香港: "HK",
    越南: "VN",
    日本: "JP",
    x: "GLOBAL",
    华语区: "Chinese",
    ZTXMA: "ZTXMA",
    中台港日: "ztgr",
    新加坡: "SG",
    中港越: "ZGY",
    马来西亚: "MALAI",
    印度尼西亚: "RID",
    韩国: "Korea",
    印尼: "RID",
    USA: "USA",
    美国: "USA"
};

Object.assign(UpAct.CONFIG, {
    // 活动ID｛String | Array｝。若不设置。默认获取的是URL参数acid=xxx
    acid: '',
    acidConfig: {
        acid: [{
            uniqueId: 'idol',
            text: '总榜',
            acid: [{
                uniqueId: 'idol-jajp',
                text: '日本',
                acid: [{
                    uniqueId: 'idol-jajp-zb',
                    text: '预赛总榜',
                    listType: 'HostList',
                    listStyle: 'zb',
                    acid: 1985,
                    areaCode: 'JP'
                }, {
                    uniqueId: 'idol-js-zb',
                    text: '决赛总榜',
                    listType: 'HostList',
                    listStyle: 'zb',
                    acid: 1986,
                    areaCode: 'JP'
                }, {
                    uniqueId: 'idol-jajp-sc',
                    text: '时长榜',
                    listType: 'DurationList',
                    listStyle: 'zb',
                    acid: 1987,
                    areaCode: 'JP'
                }]
            }]
        }]
    }

});

if (UpAct.BaseUtil.query('env') == 'stage') {
    UpAct.CONFIG.taskAcid = 124;
    UpAct.CONFIG.acidConfig = {
        acid: [{
            uniqueId: 'idol',
            text: '总榜',
            acid: [{
                uniqueId: 'idol-jajp',
                text: '日本',
                acid: [{
                    uniqueId: 'idol-jajp-sc',
                    text: '预赛总榜',
                    listType: 'HostList',
                    listStyle: 'zb',
                    acid: 100143,
                    areaCode: 'CN'
                }, {
                    uniqueId: 'idol-jajp-zb',
                    text: '决赛总榜',
                    listType: 'HostList',
                    listStyle: 'zb',
                    acid: 100143,
                    areaCode: 'CN'
                }, {
                    uniqueId: 'idol-jajp-sc',
                    text: '时长榜',
                    listType: 'DurationList',
                    listStyle: 'zb',
                    acid: 100173,
                    areaCode: 'CN'
                }]
            }]
        }]

    };
}

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(70);


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; // css文件中不要使用import


// 基础


__webpack_require__(13);

__webpack_require__(14);

__webpack_require__(15);

__webpack_require__(16);

__webpack_require__(71);

__webpack_require__(72);

__webpack_require__(73);

var _home = __webpack_require__(74);

var _home2 = _interopRequireDefault(_home);

var _shouhu = __webpack_require__(83);

var _shouhu2 = _interopRequireDefault(_shouhu);

var _cUpNative = __webpack_require__(4);

var _cUpNative2 = _interopRequireDefault(_cUpNative);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 语言
__webpack_require__(12);

__webpack_require__(29);
__webpack_require__(68);

var Game = {

    init: function init() {
        var self = this;
        var app = new UpAct.AppBase({
            title: UpAct.lang.template('h5页面标题')
        });
        this.app = app;
        app.on('getActInfo', function (data) {
            var defaultAcid = self.getDefaultAcid();
            //self.countdown(defaultAcid);
            $.channel.on('goShouHu', function (data) {
                self.goShouHu(data.uid, data.acid);
            });
            $.channel.on('goHome', function (uid) {
                self.goHome(defaultAcid);
            });
            // let uid = 5025226;
            // self.goShouHu(uid,defaultAcid);
            // return;
            if (!UpAct.platform.isUplive) {
                self.goHome(defaultAcid);
            } else {
                _cUpNative2.default.getHostInfo({
                    complete: function complete(opt) {
                        //
                        self.goHome(defaultAcid);
                        // if (opt.uid > 0 && !location.hash) {
                        //     // 在直播间
                        //     self.goShouHu(opt.uid,defaultAcid);
                        // } else {
                        //     self.goHome(defaultAcid);
                        // }
                    },
                    errtip: function errtip() {
                        self.goHome(defaultAcid);
                    }
                });
            }
        });
        app.getActInfo();
    },
    goHome: function goHome(acid) {
        var homeApp = new _home2.default(this.app.userToken, this.app.uid, acid);
        homeApp.renderHomePage();
    },
    goShouHu: function goShouHu(hostId, acid) {

        var shohuApp = new _shouhu2.default(hostId, acid);
        shohuApp.render();
    },
    getDefaultAcid: function getDefaultAcid() {
        var acid = UpAct.CONFIG.acidConfig.acid[0].acid;
        var areaAcidConfig = void 0;
        if ($.isArray(acid)) {
            $.each(acid, function (index, item) {
                if (item.uniqueId.indexOf(UpAct.lang.langType) > -1) {
                    areaAcidConfig = item;
                }
            });
        } else if ((typeof acid === 'undefined' ? 'undefined' : _typeof(acid)) == 'object') {
            areaAcidConfig = acid;
        }

        var areaAcids = UpAct.CONFIG.parseAcid(areaAcidConfig.acid);
        var acidArr = areaAcids.split(',');
        return Number(acidArr[0]);
    },
    countdown: function countdown(acid) {

        var mapObj = this.acidMap;
        var actInfo = UpAct.actData[acid];
        if (actInfo.status == 1) {

            var remainTime = actInfo.overallRanking.endTime - actInfo.serverTime;
            UpAct.countdown.on('end', function () {
                UpAct.notification.simple(UpAct.lang.template('今日榜单活动已结束'));
                setTimeout(function () {
                    location.reload();
                }, 2000);
            });
            UpAct.countdown.start(remainTime);
            UpAct.countdown.set("wrap", ".countdown");
        }
    }
};

$.getScript("//h.cdn.pengpengla.com/upact/jajp-comic2/1.0.1/assets/pack.js" + '?t=' + +new Date(), function () {
    UpAct.lang.init();
    $.channel.on('gameInit', function () {
        Game.init();
    });
    Game.init();
});

$(function () {
    var isPageHide = false;
    window.addEventListener('pageshow', function () {
        if (isPageHide) {
            window.location.reload();
        }
    });

    window.addEventListener('pagehide', function () {
        isPageHide = true;
    });
});

/***/ }),
/* 71 */
/***/ (function(module, exports) {

if (typeof Object.assign != 'function') {
  Object.assign = function (target) {
    'use strict';

    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    target = Object(target);
    for (var index = 1; index < arguments.length; index++) {
      var source = arguments[index];
      if (source != null) {
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
    }
    return target;
  };
}

/***/ }),
/* 72 */
/***/ (function(module, exports) {

//////////////////////////////////////////////////////////////////////////////
// the status constants
var PENDING = 0,
    FULFILLED = 1,
    REJECTED = 2;

//////////////////////////////////////////////////////////////////////////////
// Some utils
function isFunction(obj) {
    return typeof obj === "function";
}

function isThenable(obj) {
    return obj && isFunction(obj.then);
}

function checkArray(obj) {
    if (!Array.isArray(obj)) {
        throw new TypeError(obj + " is not array");
    }
}

//////////////////////////////////////////////////////////////////////////////
function resolve(value) {
    if (this._status !== PENDING) {
        return;
    }

    this._v = value;
    this._status = FULFILLED;

    var fn;
    while (fn = this._resolves.shift()) {
        fn.call(this, value);
    }
}

function reject(reason) {
    if (this._status !== PENDING) {
        return;
    }

    this._v = reason;
    this._status = REJECTED;

    var fn;
    while (fn = this._rejects.shift()) {
        fn.call(this, reason);
    }
}

//////////////////////////////////////////////////////////////////////////////
// The constructor function
function Promise(fn) {
    if (!isFunction(fn)) {
        throw new TypeError("Promise argument error:" + fn.toString());
    }

    this._status = PENDING;
    this._resolves = [];
    this._rejects = [];
    this._v = undefined;

    fn(resolve.bind(this), reject.bind(this));
}

//////////////////////////////////////////////////////////////////////////////
// The most important function for Promise is `then`

// `resolve` have different rules against `reject`:
// `resolve` will always trigger the `resolve` of next Promise, while
// `reject` may trigger the `reject` or `resolve` of next Promise.

function resolveWrapper(nRes, nRej, pResFn) {
    return function (value) {
        if (!isFunction(pResFn)) {
            return nRes(value);
        }

        try {
            var ret = pResFn(value);
            if (isThenable(ret)) {
                ret.then(nRes, nRej);
            } else {
                nRes(ret);
            }
        } catch (e) {
            nRej(e);
        }
    };
}

function rejectWrapper(nRes, nRej, pRejFn) {
    return function (reason) {
        if (!isFunction(pRejFn)) {
            return nRej(reason);
        }

        try {
            var ret = pRejFn(reason);
            if (isThenable(ret)) {
                ret.then(nRes, nRej);
            } else {
                nRes(ret);
            }
        } catch (e) {
            nRej(e);
        }
    };
}

function thenHandler(nRes, nRej, pResFn, pRejFn, pP) {
    var rsFn = resolveWrapper(nRes, nRej, pResFn);
    var rjFn = rejectWrapper(nRes, nRej, pRejFn);

    switch (pP._status) {
        case PENDING:
            pP._resolves.push(rsFn);
            pP._rejects.push(rjFn);
            break;
        case FULFILLED:
            rsFn(pP._v);
            break;
        case REJECTED:
            rjFn(pP._v);
            break;
        default:
            throw new Error("invalid status:" + pP._status);
    }
}

Promise.prototype.then = function (resFn, rejFn) {
    var pP = this;
    return new Promise(function (res, rej) {
        return thenHandler(res, rej, resFn, rejFn, pP);
    });
};

//////////////////////////////////////////////////////////////////////////////
// Some utils
Promise.prototype.catch = function (reason) {
    return this.then(null, reason);
};
Promise.resolve = function (value) {
    return new Promise(function (res, _) {
        return res(value);
    });
};
Promise.reject = function (reason) {
    return new Promise(function (_, rej) {
        return rej(reason);
    });
};

//////////////////////////////////////////////////////////////////////////////
// Promise.all
function handleAll(promises, resolve, reject) {
    // all promises share the same `count` and `result`.
    var count = promises.length;
    var result = [];

    function handle(i) {
        return function (value) {
            result[i] = value;
            if (--count === 0) {
                resolve(result);
            }
        };
    }
    promises.forEach(function (p, i) {
        return p.then(handle(i), reject);
    });
}

Promise.all = function (promises) {
    checkArray(promises);
    return new Promise(function (res, rej) {
        return handleAll(promises, res, rej);
    });
};

//////////////////////////////////////////////////////////////////////////////
// Promise.race
Promise.race = function (promises) {
    checkArray(promises);
    return new Promise(function (res, rej) {
        return promises.forEach(function (p) {
            return p.then(res, rej);
        });
    });
};

if (typeof window.Promise != 'function') {
    window.Promise = Promise;
}

//////////////////////////////////////////////////////////////////////////////
// For nodejs
module.exports = Promise;

/***/ }),
/* 73 */
/***/ (function(module, exports) {

;(function (win, UpAct, $) {
    var ua = window.navigator.userAgent;
    var isIOS = /iPhone|iPad|iPod/i.test(ua);

    var query = function query(name, scope) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
            scope = scope || 'search',
            r = location[scope].substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
    };

    var addParam = function addParam(url, data) {
        if (typeof data === 'undefined') {
            return;
        }

        var hashReg = /#.*$/gi,
            hashMatch = url.match(hashReg),
            hash = '';

        if (hashMatch) {
            hash = hashMatch[0];
        }

        // 去除hash值的url
        var preUrl = url.replace(hash, '');

        var searchReg = /\?(.*?)$/gi;
        var result = searchReg.exec(preUrl);
        var query, newUrl;
        if (result) {
            query = result[1].split('#')[0];
        }

        var id = !query ? '' : '&';

        return preUrl + (query && query.length > 0 ? '' : '?') + (id + $.param(data)) + hash;
    };

    var delQuery = function delQuery(url, key) {
        var path = '',
            param = '',
            hash = '';
        if (url.indexOf('?') == -1) {
            path = url;
        } else {
            path = url.substr(0, url.indexOf('?'));
            param = url.substr(url.indexOf('?') + 1);
            if (param.indexOf('#') != -1) {
                hash = param.substr(param.indexOf('#') + 1);
                param = param.substr(0, param.indexOf('#'));
            }
        }
        var params = param.split('&');
        for (var i = params.length - 1; i >= 0; i--) {
            if (params[i].indexOf(key + '=') > -1) {
                params.splice(i, 1);
                break;
            }
        }

        return path + (params.join('&') ? '?' + params.join('&') : '') + (hash ? '#' + hash : '');
    };

    var envi = function (ua) {
        var platform = {};
        var device = {};
        var env = void 0;

        if (ua.match(/uplive/i) || query('pl', 'hash') == 'uplive') {
            platform = {
                val: 2002,
                name: 'uplive',
                isUplive: true
            };
        } else if (ua.match(/micromessenger/i)) {
            // 微信
            platform = {
                val: 1,
                name: 'wechat',
                isWeixin: true
            };
        } else if (ua.match(/qq/i) || ua.match(/and_sq_/i)) {
            // QQ
            platform = {
                val: 4001,
                name: 'qq',
                isQQ: true
            };
        } else if (ua.match(/weibo/i)) {
            // 微博
            platform = {
                val: 8001,
                name: 'weibo',
                isWeibo: true
            };
        } else if (ua.match(/[Tt]witter/i)) {
            // twitter
            platform = {
                val: 2,
                name: 'twitter',
                isTwitter: true
            };
        } else if (ua.match(/FB_IAB/i)) {
            // facebook
            platform = {
                val: 3,
                name: 'facebook',
                isFacebook: true
            };
        } else {
            platform = {
                val: 0,
                name: 'unknown',
                isOther: true
            };
        }

        if (ua.match(/android/i)) {
            device = {
                val: 1,
                name: 'android',
                isAndroid: true
            };
        } else if (ua.match(/iphone|ipad|itouch/i)) {
            device = {
                val: 2,
                name: 'ios',
                isIOS: true
            };
        } else {
            device = {
                val: 3,
                name: 'unknown',
                isOther: true
            };
        }

        var _env = query('env');

        if (!_env || _env == 'null') {
            env = 'pro';
        } else {
            env = _env;
        }

        return {
            device: device,
            platform: platform,
            env: env
        };
    }(navigator.userAgent);

    var setTitle = function setTitle(value) {
        var nodeTitle = $('title').eq(0);

        if (value && value !== '') {
            nodeTitle.html(value);
        }

        if (isIOS) {
            var $iframe = void 0;

            $iframe = $('<iframe src=""https://g.cdn.upliveapp.com/oauthgame/739266613_b5c5a72bcbb1abe5fdc109b1953f65af%20%281%29.png" style="display:none;border:0;width:0;height:0;"></iframe>');
            $iframe.on('load', function () {
                setTimeout(function () {
                    $iframe.off('load').remove();
                }, 300);
            }).appendTo('body');
        }
    };
    UpAct.device = envi.device;
    UpAct.platform = envi.platform;
    UpAct.BaseUtil = {
        query: query,
        addParam: addParam,
        delQuery: delQuery,
        envi: envi,
        setTitle: setTitle

    };
    $.getScript = function (url, options) {

        var script = document.createElement('script'),
            isFunction = $.isFunction(options),
            timer;

        // 清除定时器
        function clearTimer() {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
        }

        // success
        if (isFunction || options && options.success) {
            script.onload = function () {
                clearTimer();
                isFunction ? options() : options.success.call(options.context);
            };
        }

        if (!isFunction && options) {
            // failure
            if (options.error) {
                script.onerror = function () {
                    clearTimer();
                    options.error.call(options.context);
                };
            }
            // timeout
            if (options.timeout) {
                timer = setTimeout(function () {
                    timer = null;
                    if (options.error) {
                        options.error.call(options.context);
                    }
                }, options.timeout);
            }
        }

        script.setAttribute('data-path', url);

        script.src = url;

        return document.body.appendChild(script);
    };
})(window, window['UpAct'] || (window['UpAct'] = {}), Zepto);

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
/***进入主页*/


var _page = __webpack_require__(75);

var _page2 = _interopRequireDefault(_page);

var _pageContent = __webpack_require__(76);

var _pageContent2 = _interopRequireDefault(_pageContent);

var _index = __webpack_require__(77);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(10);

var _index4 = _interopRequireDefault(_index3);

var _normalPop = __webpack_require__(5);

var _normalPop2 = _interopRequireDefault(_normalPop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Home = function () {
    function Home(userToken, uid, acid) {
        _classCallCheck(this, Home);

        this.getBtnContext = function () {
            return '\n            <div class="gala-pop-btn" node-id="guardBtn">\n                ' + UpAct.lang.template('知道了') + '\n            </div>';
        };

        this.userToken = userToken;
        this.uid = uid;
        this.acid = acid;
        this.actInfo = UpAct.actData[acid];
        this.showTask = false;
        this.selectedAreaIndex = 0;
        this.getAreaIndex();
    }

    _createClass(Home, [{
        key: 'renderHomePage',
        value: function renderHomePage() {

            var self = this;
            this.renderHTML();
            this.showTask && this.renderTaskHTML();
            this.bindEvent();
        }
    }, {
        key: 'setActTime',
        value: function setActTime(actInfo) {
            var cfg = actInfo.overallRanking;
            var time = UpAct.TimeUtil.getDailyTimeWithDate(cfg.startTime * 1000, cfg.endTime * 1000, UpAct.lang.lang);
            $(".header .act-time").html(UpAct.lang.template('活动时间:{time}', { time: time }));
        }
    }, {
        key: 'getAreaIndex',
        value: function getAreaIndex() {
            var _this = this;

            var self = this;
            var langType = UpAct.lang.langType;

            $.each(UpAct.CONFIG.acidConfig.acid, function (index, items) {
                if (items.uniqueId.indexOf(langType) > -1) {
                    _this.selectedAreaIndex = index;
                }
            });
        }
    }, {
        key: 'renderHTML',
        value: function renderHTML() {
            var _this2 = this;

            var self = this;
            var html = (0, _page2.default)({
                actInfo: self.actInfo,
                showTask: self.showTask
            });

            $('#wrap').html(html);

            var panel = $("#page-content");

            var tabsList = new _index2.default(this.acid, panel);

            tabsList.renderTabs(UpAct.CONFIG.acidConfig, panel);

            // if(self.actInfo.status == 1){
            //     $("#J-Countdown").removeClass('hidden');
            // }

            return;

            var pageContentHtml = (0, _pageContent2.default)({
                actInfo: self.actInfo,
                tabs: UpAct.CONFIG.acid
            });
            $("#page-content").html(pageContentHtml);
            console.log(this.selectedAreaIndex);

            var tabView = new UpAct.TabView({
                wrap: '#J-List',
                selectedIndex: this.selectedAreaIndex,
                direction: UpAct.lang.langType == 'areg' ? 'right' : 'left',
                scrollable: true
            });
            tabView.on('select', function (e) {

                var panel = e.panel;

                _this2.selectedAreaIndex = e.index;

                var tabsList = new _index2.default(_this2.acid, panel);

                tabsList.renderTabs(UpAct.CONFIG.acidConfig.acid[_this2.selectedAreaIndex], panel, 1);
            });

            tabView.render();
        }
    }, {
        key: 'renderTaskHTML',
        value: function renderTaskHTML() {
            var taskComponent = new _index4.default({
                wrap: $('.task-info'),
                userToken: this.userToken,
                acid: UpAct.CONFIG.getTaskActId()
            });
            taskComponent.render();
        }
    }, {
        key: 'bindEvent',
        value: function bindEvent() {
            var self = this;

            $('#wrap').delegate('[node-id="goshouhu"]', 'click', function (e) {
                e.stopPropagation();
                var target = e.currentTarget;
                var uid = $(target).data('uid');
                var acid = $(target).data('acid');
                $.channel.emit('goShouHu', { uid: uid, acid: acid });
            });
            var wrap = $(document.body);

            wrap.delegate('[node-id="rule-btn"]', 'click', function () {
                var pop = new _normalPop2.default({
                    title: UpAct.lang.template('活动规则'),
                    context: UpAct.lang.template('活动规则的内容') + (UpAct.lang.langType === 'zhtw' ? '<div class="rule-gift2"><img src="' + __webpack_require__(11) + '"></div>' : ''),
                    //btnContext: ,
                    onCreate: function onCreate(el, popup, gala) {
                        el.addClass('widget-poplayer-rule');
                    },
                    onClose: function onClose(el) {}
                });

                pop.create();
            });

            wrap.delegate('.tab[data-tabindex="0"]', 'click', function (e) {
                var index = $('.tab[data-tabindex="0"]').index(this);
                var acid = UpAct.CONFIG.acidConfig.acid[index].acid[0].acid[0].acid;
                var actInfo = UpAct.actData[acid];
                self.setActTime(actInfo);
                console.log(index, $(this));
            });

            var toggle = 1;

            $('#wrap').delegate('.intro-toggle', 'click', function (e) {
                $('.intro')[!toggle ? 'addClass' : 'removeClass']('intro-hidden');
                toggle ^= 1;
            });
        }
    }]);

    return Home;
}();

module.exports = Home;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

	var lang = UpAct.lang;
	var cfg = actInfo.overallRanking;
	var time = UpAct.TimeUtil.getDailyTimeWithDate(cfg.startTime*1000,cfg.endTime*1000,UpAct.lang.lang)

__p+='\n<div class="app-page">\n	<div class="header">\n		<div class="girl"></div>\n		<div class="act-time">'+
((__t=(lang.template("活动时间")))==null?'':__t)+
'</div>\n	</div>\n	\n	<div class="page-body" >\n		<div class="intro intro-hidden">\n			\n			<div class="intro-cont">\n				'+
((__t=(lang.template('活动简介内容')))==null?'':__t)+
'\n			</div>\n			<div class="intro-toggle"><span></span></div>\n		</div>\n		<div class="panel gift-block">\n			\n			<div class="panel-content">\n				<div class="gifts">\n				';

					_.each(actInfo.gift,function(item,index){
				
__p+='\n					<div class="gift gift'+
((__t=(index+1))==null?'':__t)+
'">\n						<p class="giftpic"><img src="'+
((__t=(item.image))==null?'':__t)+
'"/></p>\n						<span class="gift-name">'+
((__t=(lang.template('gift'+(index+1))))==null?'':__t)+
'</span>\n					</div>\n				';

					});
				
__p+='\n				</div>\n			</div>\n		</div>\n		<div class="rule" node-id="rule-btn">\n			<h2 class="title">'+
((__t=(lang.template('活动规则')))==null?'':__t)+
'</h2>\n		</div>\n	</div>\n	<div class="page-content" id="page-content"></div>	\n</div>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

	var lang = UpAct.lang;

__p+='\n\n<div class="list-content" id="J-List">\n	<div class="tabs-wrapper arealist">\n		<div class="ui-tabs-nav-container-scrolling">\n			<div class="prev ui-tabs-nav-prev" node-id="prev"></div>\n			<div class="ui-tabs-nav-wrap" node-id="scrollWrap">\n				<div class="ui-tabs-nav-scroll" node-id="scroll">\n					<ul class="area-tab-wrap">\n						';

							_.each( UpAct.CONFIG.acidConfig.acid,function(item,index){
						
__p+='\n						<li><div class="tab" node-id="tab"><span class="text">'+
((__t=(lang.template(item.text)))==null?'':__t)+
'</span></div></li>\n\n						';

						})
						
__p+='\n					</ul>\n				</div>\n			</div>\n			<div class="next ui-tabs-nav-next" node-id="next"></div>\n		</div>\n	</div>\n	<div class="data-list">\n		<div class="list-wrapper">\n			';

				_.each(UpAct.CONFIG.acidConfig.acid,function(item,index){
			
__p+='\n			<div node-id="panel" data-code="'+
((__t=(item.uniqueId))==null?'':__t)+
'"></div>\n			';

			})
			
__p+='\n			\n		</div>\n	</div>\n</div>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
/**生成多层级Tab**/


var _tabs = __webpack_require__(78);

var _tabs2 = _interopRequireDefault(_tabs);

var _dailyTabsTpl = __webpack_require__(79);

var _dailyTabsTpl2 = _interopRequireDefault(_dailyTabsTpl);

var _list = __webpack_require__(80);

var _list2 = _interopRequireDefault(_list);

var _dailyList = __webpack_require__(81);

var _dailyList2 = _interopRequireDefault(_dailyList);

var _emptyItem = __webpack_require__(82);

var _emptyItem2 = _interopRequireDefault(_emptyItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CreateTabAndList = function () {
    function CreateTabAndList(acid, container) {
        _classCallCheck(this, CreateTabAndList);

        this.index = 0;
        this.acid = acid;
        var configs = UpAct.CONFIG.acidConfig;
        var actIdMap = this.renderacidMap(configs);
        this.actIdMap = actIdMap;
        //this.renderTabs(configs,container);
        this.refresh();
    }

    _createClass(CreateTabAndList, [{
        key: 'renderacidMap',
        value: function renderacidMap(acidInfo) {
            var actIdMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var self = this;
            var acid = acidInfo.acid;
            if ($.isArray(acid)) {
                if (acid.length > 0) {
                    acid.forEach(function (item, index) {
                        actIdMap[item.uniqueId] = item;

                        if (item.acid) {
                            self.renderacidMap(item, actIdMap);
                        }
                    });
                    return actIdMap;
                }
            } else {
                actIdMap[acidInfo.uniqueId] = acidInfo;

                return actIdMap;
            }
        }
    }, {
        key: 'renderTabs',
        value: function renderTabs(tabsConfig, panel) {
            var tabIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

            var self = this;
            var tabs = tabsConfig.acid;
            if ($.isArray(tabs)) {
                var length = tabs.length;
                var html = (0, _tabs2.default)({
                    tabs: tabs,
                    tabObjIndex: tabIndex,
                    tabLength: length
                });
                $(panel).html(html);
                var selectIndex = self.getSelectIndex(tabIndex);
                var tabView = new UpAct.TabView({
                    wrap: $(panel),
                    selectedIndex: selectIndex,
                    direction: UpAct.lang.langType == 'areg' ? 'right' : 'left'
                });
                self.index++;
                tabView.on('select', function (e) {
                    var currentTarget = $(e.tab);
                    var _panel = e.panel;
                    var _index = e.index;
                    var tabIndex = currentTarget.data('tabindex');
                    var _uniqueId = currentTarget.data('uniqueid');
                    var _acidInfo = self.actIdMap[_uniqueId];
                    self.renderTabs(_acidInfo, _panel, tabIndex + 1);
                });
                tabView.render();
            } else if ((typeof tabs === 'undefined' ? 'undefined' : _typeof(tabs)) == 'object') {
                self.renderTabs(tabs, panel, tabIndex);
            } else {
                var listStyle = tabsConfig.listStyle;
                var acid = tabsConfig.acid;

                var actInfo = UpAct.actData[acid];
                self.actInfo = actInfo;
                if (listStyle == 'rb') {
                    self.renderDailyTabs(tabsConfig, panel);
                } else {
                    var cfg = actInfo.overallRanking;
                    var _html = (0, _list2.default)({
                        actInfo: actInfo,
                        cfg: cfg
                    });
                    $(panel).html(_html);
                    self.renderList(tabsConfig, panel);
                }
            }
        }
    }, {
        key: 'getSelectIndex',
        value: function getSelectIndex(tabIndex) {
            var selectIndex = 0;
            switch (tabIndex) {
                case 0:
                    selectIndex = 0;
                    break;
                case 1:
                    selectIndex = this.renderArea();
                    break;
                case 2:
                    //selectIndex = this.getDefaultTab();

                    selectIndex = 0;
                    break;

                case 3:
                    selectIndex = 1;
                    break;

                default:
                    selectIndex = 0;
                    break;
            }
            return selectIndex;
        }
    }, {
        key: 'renderArea',
        value: function renderArea() {
            var self = this;
            var langType = UpAct.lang.langType;
            var currentAcid = void 0,
                selectedAreaIndex = void 0;
            $.each(UpAct.CONFIG.acidConfig.acid, function (index, items) {
                if (items.uniqueId.indexOf(langType) > -1) {
                    selectedAreaIndex = index;
                }
            });
            return selectedAreaIndex;
        }
    }, {
        key: 'getDefaultTab',
        value: function getDefaultTab() {
            var actInfo = UpAct.actData[this.acid];
            var defaultTabIndex = actInfo.status == 1 ? 1 : 0;
            if (UpAct.lang.langType == 'areg') {
                defaultTabIndex = actInfo.status == 1 ? 0 : 1;
            }
            return defaultTabIndex;
        }
    }, {
        key: 'renderDailyTabs',
        value: function renderDailyTabs(tabsConfig, panel) {
            var self = this;
            var acid = tabsConfig.acid;
            self.actInfo = UpAct.actData[acid];
            var html = (0, _dailyTabsTpl2.default)({
                actInfo: self.actInfo,
                dailyTabs: self.actInfo.dailyRanking
            });
            $(panel).html(html);
            var tabView = new UpAct.TabView({
                wrap: $(panel),
                selectedIndex: self.actInfo.status == 1 ? self.actInfo.currentDay.index : 0,
                direction: UpAct.lang.langType == 'areg' ? 'right' : 'left',
                scrollable: true
            });
            tabView.on('select', function (e) {
                var _panel = e.panel;
                var _index = e.index;
                var actInfo = self.actInfo;

                var showCountDown = actInfo.status == 1 && actInfo.currentDay.index == _index ? true : false;
                var cfg = actInfo.dailyRanking[_index];
                var html = (0, _dailyList2.default)({
                    actInfo: actInfo,
                    cfg: cfg,
                    showCountDown: showCountDown
                });
                $(_panel).html(html);
                self.renderList(tabsConfig, _panel);
            });
            tabView.render();
        }
    }, {
        key: 'renderList',
        value: function renderList(acidInfo, panel) {
            var self = this;
            var actInfo = self.actInfo;

            var listType = acidInfo.listType;

            if (UpAct[listType]) {
                self.hostList = new UpAct[listType]({
                    wrap: $(panel),
                    itemEmptyTpl: _emptyItem2.default,
                    acidInfo: acidInfo
                }).render();
            }
        }
    }, {
        key: 'refresh',
        value: function refresh() {
            var self = this;
            UpAct.refresh.off('refresh');
            UpAct.refresh.on('refresh', function () {
                self.hostList.refresh();
            });
            UpAct.refresh.render();
        }
    }]);

    return CreateTabAndList;
}();

module.exports = CreateTabAndList;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

	var lang = UpAct.lang;
	var tabClass = '';
	if(tabLength == 1){
		tabClass = 'hidden'
	}

__p+='\n<div class="list-content list-content-'+
((__t=(tabObjIndex))==null?'':__t)+
'">\n	<div class="tabs-wrapper '+
((__t=(tabClass))==null?'':__t)+
'">\n		<ul class="rank-tabs rank-tabs-'+
((__t=(tabObjIndex))==null?'':__t)+
' ">\n			';

				_.each( tabs ,function(item,index){
			
__p+='\n			<li><div class="tab" node-id="tab" data-uniqueid="'+
((__t=(item.uniqueId))==null?'':__t)+
'" data-tabindex="'+
((__t=(tabObjIndex))==null?'':__t)+
'"><span class="text">'+
((__t=(lang.template(item.text)))==null?'':__t)+
'</span></div></li>\n\n			';

			})
			
__p+='\n		</ul>\n	</div>\n	<div class="data-list">\n		<div class="list-wrapper">\n			';

				_.each(tabs,function(item,index){
			
__p+='\n			<div node-id="panel"></div>\n			';

			})
			
__p+='\n			\n		</div>\n	</div>\n</div>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

	var lang = UpAct.lang;

__p+='\n\n<div class="daily-list-wrap">\n	<div class="">\n		<div class="dailly-tabs-wrap  ui-tabs-nav-container-scrolling">\n			<div class="prev ui-tabs-nav-prev" node-id="prev">&lt;</div>\n			<div class="daily-tabs ui-tabs-nav-wrap daily-tabs-nav-wrap" node-id="scrollWrap">\n				<div class="ui-tabs-nav-scroll" node-id="scroll">\n					<ul>\n					';

						_.forEach(dailyTabs,function(item,index){
					
__p+='\n						<li><div class="daily-btn" node-id="tab" data-acid="'+
((__t=(item.id))==null?'':__t)+
'">'+
((__t=(lang.template(item.name)))==null?'':__t)+
'</div></li>\n					';

						});
					
__p+='\n					</ul>\n				</div>\n			</div>\n			<div class="next" node-id="next">&gt;</div>\n		</div>\n		\n		';

			_.forEach(dailyTabs,function(item,index){
		
__p+='\n			<div node-id="panel"></div>\n		';

			});
		
__p+='\n	</div>\n</div>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

	var lang = UpAct.lang;

__p+='\n<div class="list-wrap">\n	<div class="content">\n		<div class="act-time">'+
((__t=(UpAct.TimeUtil.getDailyTimeWithDate(cfg.startTime * 1000, cfg.endTime * 1000, UpAct.lang.lang)))==null?'':__t)+
'</div>\n		<div class="countdown J-Countdown hidden" id="J-Countdown" >\n			<h2>'+
((__t=(lang.template('距离活动结束还有')))==null?'':__t)+
'</h2>\n			<div class="main">\n				<em node-id="day">0</em><span>'+
((__t=(lang.template('天')))==null?'':__t)+
'</span>\n				<em node-id="hour">00</em><span>'+
((__t=(lang.template('小时')))==null?'':__t)+
'</span>\n				<em node-id="minute">00</em><span>'+
((__t=(lang.template('分钟')))==null?'':__t)+
'</span>\n				<em node-id="second">00</em><span>'+
((__t=(lang.template('秒')))==null?'':__t)+
'</span>\n			</div>\n		</div>\n		<div class="list" node-id="list" data-pagesize="10" data-params="{area:\''+
((__t=(actInfo.area))==null?'':__t)+
'\', eventId:\''+
((__t=(cfg.id))==null?'':__t)+
'\',activityId:\''+
((__t=(actInfo.id))==null?'':__t)+
'\'}"></div>\n		<div class="ui-tip hidden" node-id="loading">'+
((__t=(UpAct.lang.template('正在加载数据...')))==null?'':__t)+
'</div>\n		<div class="ui-tip hidden" node-id="end">'+
((__t=(UpAct.lang.template('没有更多数据了哦')))==null?'':__t)+
'</div>\n		<div class="ui-tip hidden" node-id="error">'+
((__t=(UpAct.lang.template('系统异常')))==null?'':__t)+
'</div>\n	</div>\n</div>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

	var lang = UpAct.lang;
	if ("undefined" == typeof newListClass){
		var newListClass  = '';
	}
	

__p+='\n<div class="daily-list '+
((__t=(newListClass))==null?'':__t)+
'">\n	\n	<div class="act-time">'+
((__t=(UpAct.TimeUtil.getDailyTimeWithDate(cfg.startTime * 1000, cfg.endTime * 1000, UpAct.lang.lang)))==null?'':__t)+
'</div>	\n	';

		if(showCountDown){
	
__p+='\n	<div class="countdown J-Countdown" id="J-Countdown" >\n		<h2>'+
((__t=(lang.template('今日榜单活动结束还有')))==null?'':__t)+
'</h2>\n		<div class="main">\n			<em node-id="day">0</em><span>'+
((__t=(lang.template('天')))==null?'':__t)+
'</span>\n			<em node-id="hour">00</em><span>'+
((__t=(lang.template('小时')))==null?'':__t)+
'</span>\n			<em node-id="minute">00</em><span>'+
((__t=(lang.template('分钟')))==null?'':__t)+
'</span>\n			<em node-id="second">00</em><span>'+
((__t=(lang.template('秒')))==null?'':__t)+
'</span>\n		</div>\n	</div>\n	';

		}
	
__p+='\n	<div class="list">\n		<div class="list" node-id="list" data-pagesize="10" data-params="{area:\''+
((__t=(actInfo.area))==null?'':__t)+
'\', eventId:\''+
((__t=(cfg.id))==null?'':__t)+
'\',activityId:\''+
((__t=(actInfo.id))==null?'':__t)+
'\'}"></div>\n		<div class="ui-tip hidden" node-id="loading">'+
((__t=(UpAct.lang.template('正在加载数据...')))==null?'':__t)+
'</div>\n		<div class="ui-tip hidden" node-id="end">'+
((__t=(UpAct.lang.template('没有更多数据了哦')))==null?'':__t)+
'</div>\n		<div class="ui-tip hidden" node-id="error">'+
((__t=(UpAct.lang.template('系统异常')))==null?'':__t)+
'</div>\n	</div>\n</div>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<li>\n	<div class="item empty-item ';
 if(data.index%2){
__p+='odd';
}
__p+='" data-rank="'+
((__t=(data.index))==null?'':__t)+
'">\n		<div class="main">\n			<div class="rank">'+
((__t=(data.index))==null?'':__t)+
'</div>\n			<div class="user">\n	            <div class="avatar">\n	            	<span class="ui-img ui-circle" node-id="profile" >?\n	            	</span>\n	            </div>\n	            <div class="info">\n	                <dl>\n	                  	<dd class="giftcount">\n	                    	'+
((__t=(UpAct.lang.template("虚位以待")))==null?'':__t)+
'\n	                  	</dd>\n	                </dl>\n	            </div>\n	        </div>\n	    </div>\n\n	</div>\n</li>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
/**进入守护页*/


var _pageShouhu = __webpack_require__(84);

var _pageShouhu2 = _interopRequireDefault(_pageShouhu);

var _index = __webpack_require__(85);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ShouHuPage = function () {
    function ShouHuPage(hostId, acid) {
        _classCallCheck(this, ShouHuPage);

        this.hostId = hostId;
        this.acid = acid;
    }

    _createClass(ShouHuPage, [{
        key: 'render',
        value: function render() {
            var self = this;

            this.renderHTML();
            this.bindEvent();
        }
    }, {
        key: 'renderHTML',
        value: function renderHTML() {
            var self = this;
            var actInfo = UpAct.actData[self.acid];
            self.actInfo = actInfo;

            var html = (0, _pageShouhu2.default)({
                actInfo: actInfo
            });
            $('#wrap').html(html);

            var shouhuApp = new _index2.default({
                wrap: ".page-content",
                hostId: this.hostId,
                acid: this.acid
            });
            shouhuApp.render();
        }
    }, {
        key: 'bindEvent',
        value: function bindEvent() {
            $('#wrap').delegate('.gohome', 'click', function (e) {
                var target = e.currentTarget;
                $.channel.emit('goHome');
            });
        }
    }]);

    return ShouHuPage;
}();

module.exports = ShouHuPage;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

    var lang = UpAct.lang;
    var cfg = actInfo.overallRanking;
    var time = UpAct.TimeUtil.getActTimeWithDate(cfg.startTime*1000,cfg.endTime*1000,UpAct.lang.lang)

__p+='\n<div class="app-page shouhu">\n	<div class="back gohome" >'+
((__t=(lang.template('返回')))==null?'':__t)+
'</div>\n    <div class="header">\n        <div class="act-time">'+
((__t=(lang.template('活动时间:{time}',{time: time})))==null?'':__t)+
'</div>\n    </div>\n    \n    <div class="page-content" id="page-content">\n        \n    </div>  \n\n</div>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
/**守护**/


var _shouhu = __webpack_require__(86);

var _shouhu2 = _interopRequireDefault(_shouhu);

var _shouhuUser = __webpack_require__(87);

var _shouhuUser2 = _interopRequireDefault(_shouhuUser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ShouHu = function () {
  function ShouHu() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$hostId = _ref.hostId,
        hostId = _ref$hostId === undefined ? 0 : _ref$hostId,
        _ref$acid = _ref.acid,
        acid = _ref$acid === undefined ? 0 : _ref$acid,
        _ref$wrap = _ref.wrap,
        wrap = _ref$wrap === undefined ? "" : _ref$wrap;

    _classCallCheck(this, ShouHu);

    this.nodeWrap = $(wrap);
    this.hostId = hostId;
    this.acid = acid;
  }

  _createClass(ShouHu, [{
    key: 'render',
    value: function render() {
      var actInfo = UpAct.actData[this.acid];
      var pageSize = UpAct.lang.langType == 'zhhk' ? 60 : 10;
      var params = '{eventId:\'' + actInfo.overallRanking.id + '\',uid:\'' + this.hostId + '\',pageCount:\'' + pageSize + '\'}';

      var html = (0, _shouhu2.default)({
        params: params
      });
      this.nodeWrap.html(html);
      $(window).off("scroll");
      window.scrollTo(0, 0);
      var container = $('#J-USER-SHOUHU-LIST');
      var hostListObj = new UpAct.SendUserList({
        wrap: container
      });
      hostListObj.on('success', function (data) {
        var shouhuUserHtml = (0, _shouhuUser2.default)({
          data: data
        });
        $('#wrap').find('#SHOUHU-USER').html(shouhuUserHtml);
      });
      this.hostList = hostListObj.render();
      this.refresh();
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      var self = this;
      UpAct.refresh.off('refresh');
      UpAct.refresh.on('refresh', function () {
        self.hostList.refresh();
      });
      UpAct.refresh.render();
    }
  }]);

  return ShouHu;
}();

module.exports = ShouHu;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="user-shouhu-page">\n    \n    <div class="app-content">\n        <div class="shouhu-special-block block">\n            <div class="title">'+
((__t=(UpAct.lang.template('贡献榜')))==null?'':__t)+
'</div>\n            <div class="content" id="SHOUHU-USER">\n                \n            </div>\n            \n        </div>  \n        <div class="shouhu-list block" id="J-USER-SHOUHU-LIST">\n            <div class="list-wrapper content" > \n                <div node-id="list"  data-params="'+
((__t=(params))==null?'':__t)+
'" ></div>\n                <div class="ui-tip hidden" node-id="loading">'+
((__t=(UpAct.lang.template('正在加载数据...')))==null?'':__t)+
'</div>\n                <div class="ui-tip hidden" node-id="end">'+
((__t=(UpAct.lang.template('没有更多数据了哦')))==null?'':__t)+
'</div>\n                <div class="ui-tip hidden" node-id="error">'+
((__t=(UpAct.lang.template('系统异常')))==null?'':__t)+
'</div>\n            </div>\n        </div>      \n    </div>\n    \n</div>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n';

	var sendUser =data.sendList[0];


__p+='\n<div class="shouhu-special peidui">\n	<div class="user host">\n        <div class="avatar">\n            <span class="ui-img ui-circle" node-id="profile" data-country="'+
((__t=(data.countryCode))==null?'':__t)+
'" data-uid="'+
((__t=(data.uid))==null?'':__t)+
'">\n                <img node-id="img" data-src="'+
((__t=(data.avatar))==null?'':__t)+
'" data-size="42"/>\n            </span>\n            ';
if(data.showStatus ==1){
__p+='\n             <i class="uplived" node-id="liveroom" data-uid="'+
((__t=(data.uid ))==null?'':__t)+
'" data-country="'+
((__t=(data.countryCode))==null?'':__t)+
'" data-roomid="'+
((__t=(data.roomId ))==null?'':__t)+
'"></i>\n          ';
}
__p+='\n        </div>\n        <div class="info">\n            <dl>\n                <dd class="nickname">\n                    '+
((__t=(data.username))==null?'':__t)+
'\n                </dd>\n                \n                <dd class="uplive-code">\n                    '+
((__t=(UpAct.lang.template('Up号:{code}',{code:data.upLiveCode})))==null?'':__t)+
'\n                </dd>\n                \n                \n            </dl>\n        </div>\n    </div> \n    ';

        if(!sendUser){
    
__p+='\n\n    <div class="user empty-item">\n        <div class="avatar">\n            <span class="ui-img ui-circle" node-id="profile" >?</span>\n        </div>\n        <div class="info">\n            <dl>\n                <dd class="giftcount">\n                    '+
((__t=(UpAct.lang.template("虚位以待")))==null?'':__t)+
'\n                </dd>\n            </dl>\n        </div>\n    </div>\n\n    ';


    }else{
    
__p+='\n    <div class="user sender">\n        <div class="avatar">\n            <span class="ui-img ui-circle" node-id="profile" data-country="'+
((__t=(sendUser.countryCode))==null?'':__t)+
'" data-uid="'+
((__t=(sendUser.uid))==null?'':__t)+
'">\n                <img node-id="img" data-src="'+
((__t=(sendUser.avatar))==null?'':__t)+
'" data-size="42"/>\n            </span>\n        </div>\n        <div class="info">\n            <dl>\n                <dd class="nickname">\n                    '+
((__t=(sendUser.username))==null?'':__t)+
'\n                </dd>\n                <dd>\n                    <div class="ui-gender" data-gender="'+
((__t=(sendUser.gender))==null?'':__t)+
'"></div>\n                    <div class="ui-grade" node-id="grade" data-grade="'+
((__t=(sendUser.grade))==null?'':__t)+
'"></div>\n                </dd>\n                <dd class="giftcount">\n                    '+
((__t=(UpAct.lang.template('贡献值:{count}', {count: UpAct.NumberUtil.separate(sendUser.giftPoint, ',')}) ))==null?'':__t)+
'\n                </dd>\n            </dl>\n        </div>\n    </div>\n\n    ';

    }
    
__p+='\n</div>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.js